import { forwardRef, createElement } from 'react';
import PropTypes from 'prop-types';

const stroke = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
const fill = {
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0
};
const defaultAttributes = {
  default: stroke,
  fill
};

function createComponent(node) {
  return node.map(
    (node2) => createElement(node2[0], node2[1], node2[2]?.length ? createComponent(node2[2]) : [])
  );
}
var createReactComponent = (iconName, iconNamePascal, iconNode, requireFill = false) => {
  const fillAttributes = requireFill ? defaultAttributes.fill : {};
  const iconChildren = createComponent(iconNode);
  const Component = forwardRef(
    ({ color = "currentColor", size = 24, stroke = 2, children, ...rest }, ref) => createElement(
      "svg",
      {
        ref,
        color,
        ...defaultAttributes["default"],
        width: size,
        height: size,
        ...fillAttributes,
        strokeWidth: fillAttributes.strokeWidth ?? stroke,
        stroke: fillAttributes.stroke ?? color,
        className: `ui-icon ui-icon-${iconName}`,
        ...rest
      },
      [...iconChildren, ...children || []]
    )
  );
  Component.propTypes = {
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    stroke: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  };
  Component.displayName = `${iconNamePascal}`;
  return Component;
};

var IconLoadingError = createReactComponent(
  "LoadingError",
  "IconLoadingError",
  [
    [
      "path",
      {
        d: "M12.5 22.4998C18.299 22.4998 23 17.7987 23 11.9998C23 6.20077 18.299 1.49976 12.5 1.49976C6.70101 1.49976 2 6.20077 2 11.9998C2 17.7987 6.70101 22.4998 12.5 22.4998Z",
        fill: "#C8D3F4",
        key: "svg-0-0"
      },
      []
    ],
    [
      "path",
      {
        d: "M0 6C0 5.4477 0.447716 5 1 5H23C23.5523 5 24 5.4477 24 6V18C24 18.5523 23.5523 19 23 19H1C0.447716 19 0 18.5523 0 18V6Z",
        fill: "white",
        key: "svg-0-1"
      },
      []
    ],
    ["path", { d: "M24 7H0V7.375H24V7Z", fill: "#C8D3F4", key: "svg-0-2" }, []],
    [
      "path",
      {
        d: "M23 18.625V19H1V18.625H23ZM23.625 18V6C23.625 5.6548 23.3452 5.375 23 5.375H1C0.65482 5.375 0.375 5.6548 0.375 6V18C0.375 18.3452 0.65482 18.625 1 18.625V19C0.482175 19 0.0565025 18.6064 0.0053711 18.1021L0 18V6C1.9328e-07 5.4477 0.447716 5 1 5H23L23.1021 5.00535C23.6064 5.0565 24 5.48215 24 6V18L23.9946 18.1021C23.9469 18.5729 23.5729 18.9469 23.1021 18.9946L23 19V18.625C23.3452 18.625 23.625 18.3452 23.625 18Z",
        fill: "#C8D3F4",
        key: "svg-0-3"
      },
      []
    ],
    ["path", { d: "M0 7H24V7.375H0V7Z", fill: "#C8D3F4", key: "svg-0-4" }, []],
    [
      "path",
      {
        d: "M1 6.1875C1 6.08395 1.08394 6 1.1875 6H3.3125C3.41606 6 3.5 6.08395 3.5 6.1875C3.5 6.29105 3.41606 6.375 3.3125 6.375H1.1875C1.08394 6.375 1 6.29105 1 6.1875Z",
        fill: "#C8D3F4",
        key: "svg-0-5"
      },
      []
    ],
    [
      "path",
      {
        d: "M11.9996 9C12.1242 9 12.2393 9.0665 12.3016 9.17435L16.2291 15.9766C16.2914 16.0845 16.2914 16.2177 16.2291 16.3256C16.1668 16.4335 16.0517 16.5 15.9271 16.5H8.07246C7.94786 16.5 7.83271 16.4335 7.77036 16.3256C7.70806 16.2177 7.70806 16.0845 7.77036 15.9766L11.6975 9.17435C11.7598 9.06645 11.875 9.00005 11.9996 9ZM11.9999 13.0441C11.7289 13.0441 11.509 13.2637 11.5089 13.5347V15.013C11.5089 15.284 11.7289 15.5037 11.9999 15.5037C12.2709 15.5036 12.4906 15.284 12.4906 15.013V13.5347C12.4905 13.2638 12.2709 13.0442 11.9999 13.0441ZM11.9999 11.5661C11.7289 11.5661 11.5089 11.7857 11.5089 12.0568C11.5089 12.3278 11.7289 12.5475 11.9999 12.5475H12.0034C12.2745 12.5475 12.4944 12.3278 12.4944 12.0568C12.4944 11.7857 12.2745 11.5661 12.0034 11.5661H11.9999Z",
        fill: "#AEBEEF",
        key: "svg-0-6",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ]
  ],
  true
);

var IconAccountCode = createReactComponent(
  "accountCode",
  "IconAccountCode",
  [
    [
      "path",
      {
        d: "M4.44039 9H6.214L4.68283 11.7412V11.9529L6.30332 14.8353H4.45315L3.2665 12.5529H3.03682L1.85016 14.8353H0L1.62049 11.9529V11.7412L0.0765585 9H1.86292L3.03682 11.1412H3.2665L4.44039 9Z",
        fill: "currentColor",
        key: "svg-1-0"
      },
      []
    ],
    [
      "path",
      {
        d: "M11.6153 9H13.3889L11.8577 11.7412V11.9529L13.4782 14.8353H11.628L10.4414 12.5529H10.2117L9.02503 14.8353H7.17487L8.79536 11.9529V11.7412L7.25143 9H9.03779L10.2117 11.1412H10.4414L11.6153 9Z",
        fill: "currentColor",
        key: "svg-1-1"
      },
      []
    ],
    [
      "path",
      {
        d: "M16.7996 13.8824C16.7996 14.0392 16.7656 14.1882 16.6975 14.3294C16.638 14.4627 16.5529 14.5804 16.4423 14.6824C16.3318 14.7765 16.1999 14.851 16.0468 14.9059C15.9022 14.9686 15.7491 15 15.5874 15C15.4173 15 15.2599 14.9686 15.1153 14.9059C14.9707 14.851 14.8431 14.7765 14.7325 14.6824C14.6219 14.5804 14.5326 14.4627 14.4646 14.3294C14.405 14.1882 14.3753 14.0392 14.3753 13.8824C14.3753 13.7255 14.405 13.5804 14.4646 13.4471C14.5326 13.3059 14.6219 13.1882 14.7325 13.0941C14.8431 12.9922 14.9707 12.9137 15.1153 12.8588C15.2599 12.7961 15.4173 12.7647 15.5874 12.7647C15.7491 12.7647 15.9022 12.7961 16.0468 12.8588C16.1999 12.9137 16.3318 12.9922 16.4423 13.0941C16.5529 13.1882 16.638 13.3059 16.6975 13.4471C16.7656 13.5804 16.7996 13.7255 16.7996 13.8824Z",
        fill: "currentColor",
        key: "svg-1-2"
      },
      []
    ],
    [
      "path",
      {
        d: "M22.1371 9H23.9107L22.3795 11.7412V11.9529L24 14.8353H22.1498L20.9632 12.5529H20.7335L19.5468 14.8353H17.6967L19.3172 11.9529V11.7412L17.7732 9H19.5596L20.7335 11.1412H20.9632L22.1371 9Z",
        fill: "currentColor",
        key: "svg-1-3"
      },
      []
    ],
    [
      "path",
      {
        d: "M0 21C0 20.4477 0.447715 20 1 20H17C17.5523 20 18 20.4477 18 21C18 21.5523 17.5523 22 17 22H1C0.447716 22 0 21.5523 0 21Z",
        fill: "currentColor",
        key: "svg-1-4"
      },
      []
    ],
    [
      "path",
      {
        d: "M6 3C6 2.44772 6.44772 2 7 2H23C23.5523 2 24 2.44772 24 3C24 3.55228 23.5523 4 23 4H7C6.44772 4 6 3.55228 6 3Z",
        fill: "currentColor",
        key: "svg-1-5"
      },
      []
    ]
  ],
  true
);

var IconAdd = createReactComponent(
  "add",
  "IconAdd",
  [
    [
      "path",
      {
        fill: "currentColor",
        d: "M12 2.18182C6.57757 2.18182 2.18182 6.57757 2.18182 12C2.18182 17.4224 6.57757 21.8182 12 21.8182C17.4224 21.8182 21.8182 17.4224 21.8182 12C21.8182 6.57757 17.4224 2.18182 12 2.18182ZM0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12ZM12 6.54545C12.6025 6.54545 13.0909 7.03387 13.0909 7.63636V10.9091H16.3636C16.9661 10.9091 17.4545 11.3975 17.4545 12C17.4545 12.6025 16.9661 13.0909 16.3636 13.0909H13.0909V16.3636C13.0909 16.9661 12.6025 17.4545 12 17.4545C11.3975 17.4545 10.9091 16.9661 10.9091 16.3636V13.0909H7.63636C7.03387 13.0909 6.54545 12.6025 6.54545 12C6.54545 11.3975 7.03387 10.9091 7.63636 10.9091H10.9091V7.63636C10.9091 7.03387 11.3975 6.54545 12 6.54545Z",
        key: "svg-2-0",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ]
  ],
  true
);

var IconAddLocation = createReactComponent(
  "addLocation",
  "IconAddLocation",
  [
    [
      "path",
      {
        d: "M16.2776 9.04348H18.8997V5.83278H22.1104V3.2107H18.8997V0H16.2776V3.2107H13.0669V5.83278H16.2776V9.04348ZM9.9097 12.9766C10.534 12.9766 11.0691 12.7536 11.5151 12.3077C11.961 11.8618 12.1839 11.3266 12.1839 10.7023C12.1839 10.078 11.961 9.54292 11.5151 9.09699C11.0691 8.65106 10.534 8.42809 9.9097 8.42809C9.2854 8.42809 8.75028 8.65106 8.30435 9.09699C7.85842 9.54292 7.63545 10.078 7.63545 10.7023C7.63545 11.3266 7.85842 11.8618 8.30435 12.3077C8.75028 12.7536 9.2854 12.9766 9.9097 12.9766ZM9.9097 24C6.93088 21.4493 4.70123 19.0901 3.22074 16.9225C1.74025 14.7557 1 12.7536 1 10.9164C1 8.13378 1.8965 5.91733 3.6895 4.26702C5.48178 2.61744 7.55518 1.79264 9.9097 1.79264C10.0881 1.79264 10.2622 1.79692 10.432 1.80549C10.6011 1.81476 10.7659 1.82832 10.9264 1.84615V4.70903C10.7659 4.67336 10.6011 4.65088 10.432 4.64161C10.2622 4.63304 10.0881 4.62876 9.9097 4.62876C8.19732 4.62876 6.75715 5.21739 5.58916 6.39465C4.42047 7.57191 3.83612 9.07915 3.83612 10.9164C3.83612 12.1115 4.33556 13.4892 5.33445 15.0496C6.33333 16.6107 7.85842 18.3367 9.9097 20.2274C11.8718 18.4259 13.348 16.7802 14.3383 15.2904C15.3279 13.8014 15.8673 12.4682 15.9565 11.291V11.1839H18.7926V11.291C18.7035 13.0925 17.9233 15.0457 16.452 17.1505C14.9801 19.2553 12.7993 21.5385 9.9097 24Z",
        fill: "currentColor",
        key: "svg-3-0"
      },
      []
    ]
  ],
  true
);

var IconAnnouncements = createReactComponent(
  "announcements",
  "IconAnnouncements",
  [
    [
      "path",
      {
        d: "M18.4114 1.82276C18.5853 1.5246 18.4846 1.1419 18.1864 0.967984C17.8883 0.794066 17.5056 0.894785 17.3317 1.19295L15.7701 3.87001C15.5962 4.16818 15.6969 4.55087 15.9951 4.72479C16.2933 4.89871 16.6759 4.79799 16.8499 4.49983L18.4114 1.82276Z",
        fill: "currentColor",
        key: "svg-4-0"
      },
      []
    ],
    [
      "path",
      {
        d: "M21.1562 5.65963C21.4552 5.48704 21.5576 5.1048 21.385 4.80586C21.2124 4.50693 20.8302 4.40451 20.5312 4.5771L17.5351 6.30694C17.2361 6.47953 17.1337 6.86177 17.3063 7.16071C17.4789 7.45964 17.8611 7.56206 18.1601 7.38947L21.1562 5.65963Z",
        fill: "currentColor",
        key: "svg-4-1"
      },
      []
    ],
    [
      "path",
      {
        d: "M23.1095 9.49485C23.111 9.84002 22.8324 10.1211 22.4873 10.1226L19.3881 10.1364C19.0429 10.138 18.7618 9.85939 18.7603 9.51421C18.7588 9.16904 19.0373 8.88797 19.3825 8.88644L22.4817 8.87264C22.8269 8.8711 23.1079 9.14967 23.1095 9.49485Z",
        fill: "currentColor",
        key: "svg-4-2"
      },
      []
    ],
    [
      "path",
      {
        d: "M17.0572 7.30449C15.9741 5.42839 14.7539 3.84031 13.6414 2.79187C13.0881 2.2705 12.5347 1.85702 12.0147 1.61836C11.5128 1.388 10.9001 1.26005 10.3619 1.57078C9.94094 1.81383 9.72963 2.23052 9.63292 2.66365C7.75389 5.88615 5.36177 8.78087 2.55057 11.2336L1.88676 11.8128L1.8602 11.8428C1.33201 12.4384 1.11041 13.2273 1.0982 13.9869C1.08594 14.749 1.282 15.5401 1.65969 16.1942C2.03738 16.8484 2.62439 17.4137 3.29053 17.7842C3.95446 18.1534 4.74846 18.3559 5.52842 18.1963L5.56757 18.1883L6.41346 17.8989C6.44924 17.8867 6.48504 17.8745 6.52085 17.8624C6.59282 18.0945 6.67416 18.3865 6.75728 18.7251C6.92486 19.4076 7.08265 20.2078 7.17274 20.9339C7.29234 21.8981 8.09459 22.7501 9.16196 22.7501C9.97342 22.7501 10.7657 22.2184 10.9338 21.3258C11.0757 20.5721 11.1936 19.5512 11.1914 18.5412C11.19 17.9274 11.1448 17.2749 11.0132 16.6749C13.1029 16.2717 15.2289 16.0634 17.3638 16.0545C17.7874 16.1874 18.254 16.2128 18.6751 15.9697C19.2133 15.6589 19.4088 15.0644 19.4603 14.5145C19.5136 13.9448 19.4322 13.2588 19.2573 12.519C18.9056 11.0313 18.1404 9.18059 17.0572 7.30449ZM10.9869 2.65331C11.0003 2.64559 11.1283 2.58688 11.4933 2.75442C11.8403 2.91366 12.2802 3.22675 12.7841 3.70158C13.7858 4.64554 14.9348 6.12839 15.9747 7.92949C17.0146 9.73059 17.7242 11.4671 18.0409 12.8066C18.2002 13.4804 18.2513 14.0179 18.2157 14.398C18.1783 14.7979 18.0635 14.8794 18.0501 14.8871C18.0367 14.8948 17.9088 14.9536 17.5437 14.786C17.1968 14.6268 16.7568 14.3137 16.2529 13.8389C15.2513 12.8949 14.1022 11.4121 13.0623 9.61095C12.0225 7.80984 11.3128 6.07331 10.9962 4.73385C10.8369 4.06007 10.7857 3.52251 10.8213 3.14241C10.8587 2.7425 10.9735 2.66104 10.9869 2.65331ZM9.54712 16.9912C9.01238 17.1188 8.48049 17.2594 7.95193 17.4128C8.04146 17.7003 8.13076 18.0284 8.21401 18.3674C8.39249 19.0943 8.56257 19.9533 8.66132 20.7493C8.69977 21.0592 8.94551 21.2501 9.16196 21.2501C9.35106 21.2501 9.44265 21.1389 9.45973 21.0482C9.58666 20.3742 9.69336 19.4479 9.69137 18.5445C9.69009 17.9588 9.64276 17.4263 9.54712 16.9912ZM9.77968 5.02143C9.767 4.96777 9.7548 4.91439 9.74312 4.86132C7.96528 7.57637 5.82238 10.0379 3.37236 12.1755L2.77173 12.6996C2.50806 13.0132 2.35661 13.4735 2.34804 14.007C2.33924 14.5539 2.483 15.1203 2.74222 15.5692C3.00144 16.0182 3.42006 16.4259 3.89804 16.6917C4.36444 16.9511 4.83879 17.05 5.24219 16.9785L6.00891 16.7162C9.08115 15.6654 12.28 15.0416 15.5157 14.86C15.4757 14.8234 15.4357 14.7863 15.3956 14.7486C14.2831 13.7001 13.063 12.1121 11.9798 10.2359C10.8966 8.35985 10.1314 6.50914 9.77968 5.02143Z",
        fill: "currentColor",
        key: "svg-4-3",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ]
  ],
  true
);

var IconApple = createReactComponent(
  "apple",
  "IconApple",
  [
    [
      "path",
      {
        d: "M18.721 12.6832C18.7096 10.7159 19.5937 9.2333 21.3791 8.14007C20.3805 6.69782 18.8698 5.90458 16.8784 5.7517C14.9928 5.60171 12.9299 6.85935 12.1745 6.85935C11.3763 6.85935 9.55079 5.80362 8.11445 5.80362C5.15021 5.84977 2 8.18622 2 12.9399C2 14.3446 2.25465 15.7955 2.76395 17.2897C3.44492 19.2569 5.89986 24.0769 8.46066 23.9991C9.79971 23.9673 10.7468 23.0414 12.4893 23.0414C14.1803 23.0414 15.0558 23.9991 16.5494 23.9991C19.133 23.9616 21.3534 19.58 22 17.607C18.535 15.96 18.721 12.7841 18.721 12.6832ZM15.7139 3.88543C17.1645 2.14895 17.0329 0.568247 16.99 0C15.7082 0.0749971 14.226 0.879774 13.382 1.86916C12.4521 2.93066 11.9056 4.2431 12.0229 5.72285C13.4077 5.82958 14.6724 5.11134 15.7139 3.88543Z",
        fill: "currentColor",
        key: "svg-5-0"
      },
      []
    ]
  ],
  true
);

var IconArrowLeft = createReactComponent(
  "arrowLeft",
  "IconArrowLeft",
  [
    [
      "g",
      { key: "svg-6-0", clipPath: "url(#clip0_429_11976)" },
      [
        [
          "path",
          {
            d: "M4.78657 10.4452L22.7568 10.4452C23.0723 10.4455 23.3768 10.5569 23.6078 10.7583C23.839 10.9598 23.9791 11.2361 23.9978 11.5312C24.0166 11.8264 23.9125 12.1163 23.7081 12.3418C23.5052 12.5655 23.219 12.7088 22.9081 12.7444L22.7503 12.7532L4.78657 12.7532L4.25965 12.7532L4.62744 13.0928L10.1894 18.2285L10.1894 18.2285C10.4043 18.4268 10.5342 18.6916 10.5534 18.9735C10.5724 19.2533 10.481 19.5294 10.2971 19.7506L10.1848 19.868C9.97059 20.0637 9.68784 20.1804 9.38916 20.1977C9.09058 20.215 8.79468 20.132 8.5561 19.9631L8.42882 19.8593L0.366467 12.4168L0.366193 12.4166C0.324067 12.3778 0.28492 12.3363 0.249064 12.2924L0.156665 12.1603L0.0890033 12.0284L0.0455368 11.908L0.0133007 11.7676L0.00511625 11.705L7.51943e-07 11.5987L0.00364761 11.5146L0.0254105 11.3657L0.0626667 11.2384L0.118394 11.1087L0.182517 10.9971L0.275998 10.8758L0.370961 10.7773L8.43338 3.33476L8.43363 3.33453C8.65801 3.12822 8.95791 3.00934 9.27211 3.00048C9.58641 2.99162 9.89352 3.09345 10.1309 3.2867C10.3685 3.48009 10.5185 3.7507 10.5488 4.04404C10.5789 4.33531 10.4884 4.62564 10.297 4.8568L10.1846 4.97428L4.62744 10.1056L4.25965 10.4452L4.78657 10.4452Z",
            fill: "#currentColor",
            key: "svg-6-0",
            fillRule: "evenodd",
            clipRule: "evenodd"
          },
          []
        ]
      ]
    ],
    [
      "defs",
      { key: "svg-6-1" },
      [
        [
          "clipPath",
          { id: "clip0_429_11976", key: "svg-6-0" },
          [
            [
              "rect",
              { width: "24", height: "24", fill: "white", key: "svg-6-0" },
              []
            ]
          ]
        ]
      ]
    ]
  ],
  true
);

var IconArrowRight = createReactComponent(
  "arrowRight",
  "IconArrowRight",
  [
    [
      "g",
      { key: "svg-7-0", clipPath: "url(#clip0_198_3477)" },
      [
        [
          "path",
          {
            d: "M19.2134 12.7548L1.24316 12.7548C0.927706 12.7545 0.623246 12.643 0.392227 12.4417C0.161042 12.2402 0.0209287 11.9638 0.00216031 11.6687C-0.0166103 11.3736 0.0875191 11.0836 0.291933 10.8582C0.494832 10.6344 0.78096 10.4912 1.09186 10.4555L1.24972 10.4468L19.2134 10.4468H19.7403L19.3726 10.1072L13.8106 4.97149L13.8106 4.97147C13.5957 4.77312 13.4658 4.50831 13.4466 4.22644C13.4276 3.9466 13.519 3.67053 13.7029 3.4493L13.8152 3.3319C14.0294 3.13625 14.3122 3.01959 14.6108 3.00225C14.9094 2.98492 15.2053 3.06791 15.4439 3.23685L15.5712 3.3406L23.6335 10.7831L23.6338 10.7834C23.6759 10.8221 23.7151 10.8636 23.7509 10.9075L23.8433 11.0397L23.911 11.1715L23.9545 11.2919L23.9867 11.4324L23.9949 11.495L24 11.6012L23.9964 11.6854L23.9746 11.8343L23.9373 11.9615L23.8816 12.0913L23.8175 12.2028L23.724 12.3241L23.629 12.4226L15.5666 19.8652L15.5664 19.8654C15.342 20.0717 15.0421 20.1906 14.7279 20.1995C14.4136 20.2083 14.1065 20.1065 13.8691 19.9132C13.6315 19.7199 13.4815 19.4493 13.4512 19.1559C13.4211 18.8646 13.5116 18.5743 13.703 18.3431L13.8154 18.2257L19.3726 13.0944L19.7403 12.7548H19.2134Z",
            fill: "currentColor",
            key: "svg-7-0",
            fillRule: "evenodd",
            clipRule: "evenodd"
          },
          []
        ]
      ]
    ],
    [
      "defs",
      { key: "svg-7-1" },
      [
        [
          "clipPath",
          { id: "clip0_198_3477", key: "svg-7-0" },
          [
            [
              "rect",
              {
                width: "24",
                height: "24",
                fill: "transparent",
                key: "svg-7-0"
              },
              []
            ]
          ]
        ]
      ]
    ]
  ],
  true
);

var IconArrowsApartVertical = createReactComponent(
  "arrowsApartVertical",
  "IconArrowsApartVertical",
  [
    [
      "g",
      { id: "Direction=Top Bottom, Type=Apart", key: "svg-8-0" },
      [
        [
          "g",
          { id: "Vector", key: "svg-8-0" },
          [
            [
              "path",
              {
                d: "M10.711 23.6142C11.232 24.1275 12.0736 24.1275 12.5945 23.6142L17.9118 18.3745C18.4369 17.8572 18.4369 17.0153 17.9119 16.4979C17.3909 15.9845 16.5493 15.9846 16.0284 16.4979L12.9883 19.4935L12.9884 14.3233C12.9884 13.5855 12.3835 13 11.6529 13C10.9222 13 10.3173 13.5855 10.3173 14.3233L10.3173 19.4935L7.27729 16.4979C6.75634 15.9846 5.91473 15.9846 5.39378 16.4979C4.86874 17.0153 4.86874 17.8572 5.39378 18.3746L10.711 23.6142Z",
                fill: "currentColor",
                key: "svg-8-0"
              },
              []
            ],
            [
              "path",
              {
                d: "M12.5946 0.38573C12.0737 -0.127605 11.2321 -0.127597 10.7111 0.385736L5.39381 5.62539C4.86878 6.14276 4.86877 6.98467 5.39381 7.50204C5.91476 8.01538 6.75637 8.01536 7.27731 7.50203L10.3173 4.50642L10.3173 9.67664C10.3173 10.4144 10.9222 11 11.6528 11C12.3834 11 12.9883 10.4144 12.9883 9.67663L12.9884 4.5064L16.0284 7.50198C16.5493 8.01532 17.3909 8.01531 17.9119 7.50198C18.4369 6.98461 18.4369 6.1427 17.9119 5.62533L12.5946 0.38573Z",
                fill: "currentColor",
                key: "svg-8-1"
              },
              []
            ]
          ]
        ]
      ]
    ]
  ],
  true
);

var IconArrowsTogetherVertical = createReactComponent(
  "arrowsTogetherVertical",
  "IconArrowsTogetherVertical",
  [
    [
      "g",
      { id: "Direction=Top Bottom, Type=Together", key: "svg-9-0" },
      [
        [
          "g",
          { id: "Vector", key: "svg-9-0" },
          [
            [
              "path",
              {
                d: "M12.5946 13.385C12.0737 12.8717 11.232 12.8717 10.7111 13.385L5.39378 18.6247C4.86875 19.142 4.86874 19.9839 5.39378 20.5013C5.91472 21.0146 6.75634 21.0146 7.27728 20.5013L10.3173 17.5057L10.3172 22.6759C10.3172 23.4137 10.9221 23.9992 11.6528 23.9992C12.3834 23.9992 12.9883 23.4137 12.9883 22.6759L12.9884 17.5057L16.0283 20.5012C16.5493 21.0146 17.3909 21.0146 17.9118 20.5012C18.4369 19.9839 18.4369 19.142 17.9119 18.6246L12.5946 13.385Z",
                fill: "currentColor",
                key: "svg-9-0"
              },
              []
            ],
            [
              "path",
              {
                d: "M10.711 10.615C11.232 11.1283 12.0736 11.1283 12.5945 10.615L17.9119 5.37531C18.4369 4.85794 18.4369 4.01603 17.9119 3.49866C17.3909 2.98532 16.5493 2.98533 16.0284 3.49867L12.9883 6.49428L12.9884 1.32406C12.9884 0.58629 12.3835 0.000728671 11.6529 0.000732422C10.9222 0.000736173 10.3173 0.5863 10.3173 1.32406L10.3173 6.4943L7.27729 3.49871C6.75634 2.98537 5.91473 2.98538 5.39378 3.49872C4.86875 4.01609 4.86874 4.858 5.39378 5.37537L10.711 10.615Z",
                fill: "currentColor",
                key: "svg-9-1"
              },
              []
            ]
          ]
        ]
      ]
    ]
  ],
  true
);

var IconArrowsUpDown = createReactComponent(
  "arrowsUpDown",
  "IconArrowsUpDown",
  [
    [
      "g",
      { key: "svg-10-0", clipPath: "url(#clip0_13965_1465)" },
      [
        [
          "path",
          {
            d: "M3.7973 0.442499C3.53683 0.185831 3.11602 0.185835 2.85555 0.442502L0.196891 3.06233C-0.0656273 3.32101 -0.0656321 3.74197 0.196888 4.00065C0.457362 4.25732 0.878169 4.25732 1.13864 4.00065L2.65865 2.50284L2.65862 11.088C2.65862 11.4568 2.96107 11.7496 3.32638 11.7496C3.6917 11.7496 3.99415 11.4568 3.99415 11.088L3.99418 2.50283L5.51417 4.00063C5.77465 4.2573 6.19545 4.25729 6.45592 4.00062C6.71844 3.74194 6.71845 3.32098 6.45593 3.0623L3.7973 0.442499Z",
            fill: "currentColor",
            key: "svg-10-0"
          },
          []
        ],
        [
          "path",
          {
            d: "M9.14445 11.5575L11.8031 8.93767C12.0656 8.67899 12.0656 8.25803 11.8031 7.99935C11.5426 7.74268 11.1218 7.74268 10.8614 7.99935L9.34135 9.49716L9.34138 0.912046C9.34138 0.543164 9.03893 0.25038 8.67362 0.250382C8.3083 0.250384 8.00585 0.543166 8.00585 0.912047L8.00582 9.49717L6.48583 7.99937C6.22535 7.7427 5.80455 7.74271 5.54408 7.99938C5.28156 8.25806 5.28155 8.67902 5.54407 8.9377L8.2027 11.5575C8.46318 11.8142 8.88398 11.8142 9.14445 11.5575Z",
            fill: "currentColor",
            key: "svg-10-1"
          },
          []
        ]
      ]
    ],
    [
      "defs",
      { key: "svg-10-1" },
      [
        [
          "clipPath",
          { id: "clip0_13965_1465", key: "svg-10-0" },
          [
            [
              "rect",
              {
                width: "12",
                height: "12",
                fill: "currentColor",
                key: "svg-10-0"
              },
              []
            ]
          ]
        ]
      ]
    ]
  ],
  true
);

var IconArt = createReactComponent(
  "art",
  "IconArt",
  [
    [
      "g",
      { id: "art", key: "svg-11-0", clipPath: "url(#clip0_14122_11334)" },
      [
        [
          "path",
          {
            id: "Vector",
            d: "M12 24C10.36 24 8.81 23.685 7.35 23.055C5.89 22.425 4.615 21.565 3.525 20.475C2.435 19.385 1.575 18.11 0.945 16.65C0.315 15.19 0 13.64 0 12C0 10.34 0.325 8.78 0.975 7.32C1.625 5.86 2.505 4.59 3.615 3.51C4.725 2.43 6.02 1.575 7.5 0.945C8.98 0.315 10.56 0 12.24 0C13.84 0 15.35 0.275 16.77 0.825C18.19 1.375 19.435 2.135 20.505 3.105C21.575 4.075 22.425 5.225 23.055 6.555C23.685 7.885 24 9.32 24 10.86C24 13.16 23.3 14.925 21.9 16.155C20.5 17.385 18.8 18 16.8 18H14.58C14.4 18 14.275 18.05 14.205 18.15C14.135 18.25 14.1 18.36 14.1 18.48C14.1 18.72 14.25 19.065 14.55 19.515C14.85 19.965 15 20.48 15 21.06C15 22.06 14.725 22.8 14.175 23.28C13.625 23.76 12.9 24 12 24ZM5.4 13.2C5.92 13.2 6.35 13.03 6.69 12.69C7.03 12.35 7.2 11.92 7.2 11.4C7.2 10.88 7.03 10.45 6.69 10.11C6.35 9.77 5.92 9.6 5.4 9.6C4.88 9.6 4.45 9.77 4.11 10.11C3.77 10.45 3.6 10.88 3.6 11.4C3.6 11.92 3.77 12.35 4.11 12.69C4.45 13.03 4.88 13.2 5.4 13.2ZM9 8.4C9.52 8.4 9.95 8.23 10.29 7.89C10.63 7.55 10.8 7.12 10.8 6.6C10.8 6.08 10.63 5.65 10.29 5.31C9.95 4.97 9.52 4.8 9 4.8C8.48 4.8 8.05 4.97 7.71 5.31C7.37 5.65 7.2 6.08 7.2 6.6C7.2 7.12 7.37 7.55 7.71 7.89C8.05 8.23 8.48 8.4 9 8.4ZM15 8.4C15.52 8.4 15.95 8.23 16.29 7.89C16.63 7.55 16.8 7.12 16.8 6.6C16.8 6.08 16.63 5.65 16.29 5.31C15.95 4.97 15.52 4.8 15 4.8C14.48 4.8 14.05 4.97 13.71 5.31C13.37 5.65 13.2 6.08 13.2 6.6C13.2 7.12 13.37 7.55 13.71 7.89C14.05 8.23 14.48 8.4 15 8.4ZM18.6 13.2C19.12 13.2 19.55 13.03 19.89 12.69C20.23 12.35 20.4 11.92 20.4 11.4C20.4 10.88 20.23 10.45 19.89 10.11C19.55 9.77 19.12 9.6 18.6 9.6C18.08 9.6 17.65 9.77 17.31 10.11C16.97 10.45 16.8 10.88 16.8 11.4C16.8 11.92 16.97 12.35 17.31 12.69C17.65 13.03 18.08 13.2 18.6 13.2ZM12 21.6C12.18 21.6 12.325 21.55 12.435 21.45C12.545 21.35 12.6 21.22 12.6 21.06C12.6 20.78 12.45 20.45 12.15 20.07C11.85 19.69 11.7 19.12 11.7 18.36C11.7 17.52 11.99 16.85 12.57 16.35C13.15 15.85 13.86 15.6 14.7 15.6H16.8C18.12 15.6 19.25 15.215 20.19 14.445C21.13 13.675 21.6 12.48 21.6 10.86C21.6 8.44 20.675 6.425 18.825 4.815C16.975 3.205 14.78 2.4 12.24 2.4C9.52 2.4 7.2 3.33 5.28 5.19C3.36 7.05 2.4 9.32 2.4 12C2.4 14.66 3.335 16.925 5.205 18.795C7.075 20.665 9.34 21.6 12 21.6Z",
            fill: "currentColor",
            key: "svg-11-0"
          },
          []
        ]
      ]
    ],
    [
      "defs",
      { key: "svg-11-1" },
      [
        [
          "clipPath",
          { id: "clip0_14122_11334", key: "svg-11-0" },
          [
            [
              "rect",
              { width: "24", height: "24", fill: "white", key: "svg-11-0" },
              []
            ]
          ]
        ]
      ]
    ]
  ],
  true
);

var IconBackslash = createReactComponent(
  "backslash",
  "IconBackslash",
  [
    [
      "path",
      {
        d: "M16.263 1.12L10.823 23.5H8.58301L14.003 1.12H16.263Z",
        fill: "currentColor",
        key: "svg-12-0"
      },
      []
    ]
  ],
  true
);

var IconBank = createReactComponent(
  "bank",
  "IconBank",
  [
    [
      "path",
      {
        d: "M11.1056 2.21115C11.6686 1.92962 12.3314 1.92962 12.8944 2.21115L21.4472 6.48754C21.786 6.65693 22 7.00319 22 7.38197V8.26393C22 8.54007 21.7761 8.76393 21.5 8.76393H2.5C2.22386 8.76393 2 8.54007 2 8.26393V7.38197C2 7.00319 2.214 6.65693 2.55279 6.48754L11.1056 2.21115ZM6 10.7639H4.5C4.22386 10.7639 4 10.9878 4 11.2639V17.2639C4 17.5401 4.22386 17.7639 4.5 17.7639H6C6.27614 17.7639 6.5 17.5401 6.5 17.2639V11.2639C6.5 10.9878 6.27614 10.7639 6 10.7639ZM12.75 10.7639H11.25C10.9739 10.7639 10.75 10.9878 10.75 11.2639V17.2639C10.75 17.5401 10.9739 17.7639 11.25 17.7639H12.75C13.0261 17.7639 13.25 17.5401 13.25 17.2639V11.2639C13.25 10.9878 13.0261 10.7639 12.75 10.7639ZM2.75 19.5H21.25C21.6642 19.5 22 19.8358 22 20.25V21.25C22 21.6642 21.6642 22 21.25 22H2.75C2.33579 22 2 21.6642 2 21.25V20.25C2 19.8358 2.33579 19.5 2.75 19.5ZM19.5 10.7639H18C17.7239 10.7639 17.5 10.9878 17.5 11.2639V17.2639C17.5 17.5401 17.7239 17.7639 18 17.7639H19.5C19.7761 17.7639 20 17.5401 20 17.2639V11.2639C20 10.9878 19.7761 10.7639 19.5 10.7639Z",
        fill: "currentColor",
        key: "svg-13-0",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ]
  ],
  true
);

var IconBling = createReactComponent(
  "bling",
  "IconBling",
  [
    [
      "path",
      {
        d: "M12.5344 0.848083C12.3972 0.303568 11.6271 0.303569 11.4898 0.848084L9.51377 8.68829C9.4169 9.07265 9.11726 9.37306 8.73316 9.47091L0.920974 11.4612C0.379207 11.5992 0.379206 12.3724 0.920973 12.5104L8.73286 14.5006C9.11697 14.5985 9.4166 14.8989 9.51348 15.2833L11.4898 23.1247C11.6271 23.6692 12.3972 23.6692 12.5344 23.1247L14.5108 15.2833C14.6076 14.8989 14.9073 14.5985 15.2914 14.5007L23.1034 12.5104C23.6452 12.3724 23.6452 11.5992 23.1034 11.4612L15.2911 9.47088C14.907 9.37302 14.6073 9.07261 14.5105 8.68826L12.5344 0.848083ZM17.8716 11.9858L14.8467 11.2152C13.8224 10.9542 13.0234 10.1531 12.765 9.12817L12.0121 6.14089L11.2592 9.12821C11.0009 10.1532 10.2018 10.9542 9.17754 11.2152L6.15273 11.9858L9.17724 12.7564C10.2015 13.0173 11.0006 13.8184 11.2589 14.8433L12.0121 17.8319L12.7653 14.8434C13.0237 13.8184 13.8227 13.0174 14.847 12.7564L17.8716 11.9858Z",
        fill: "currentColor",
        key: "svg-14-0",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ],
    [
      "path",
      {
        d: "M4.2002 17.4C4.2002 17.0686 4.46882 16.8 4.8002 16.8C5.13157 16.8 5.4002 17.0686 5.4002 17.4V18.6H6.6002C6.93157 18.6 7.2002 18.8686 7.2002 19.2C7.2002 19.5313 6.93157 19.8 6.6002 19.8H5.4002V21C5.4002 21.3313 5.13157 21.6 4.8002 21.6C4.46882 21.6 4.2002 21.3313 4.2002 21V19.8H3.0002C2.66882 19.8 2.4002 19.5313 2.4002 19.2C2.4002 18.8686 2.66882 18.6 3.0002 18.6H4.2002V17.4Z",
        fill: "currentColor",
        key: "svg-14-1"
      },
      []
    ],
    [
      "path",
      {
        d: "M4.2002 2.99995C4.2002 2.66858 4.46882 2.39995 4.8002 2.39995C5.13157 2.39995 5.4002 2.66858 5.4002 2.99995V4.19995H6.6002C6.93157 4.19995 7.2002 4.46858 7.2002 4.79995C7.2002 5.13132 6.93157 5.39995 6.6002 5.39995H5.4002V6.59995C5.4002 6.93132 5.13157 7.19995 4.8002 7.19995C4.46882 7.19995 4.2002 6.93132 4.2002 6.59995V5.39995H3.0002C2.66882 5.39995 2.4002 5.13132 2.4002 4.79995C2.4002 4.46858 2.66882 4.19995 3.0002 4.19995H4.2002V2.99995Z",
        fill: "currentColor",
        key: "svg-14-2"
      },
      []
    ]
  ],
  true
);

var IconBolt = createReactComponent(
  "bolt",
  "IconBolt",
  [
    [
      "path",
      {
        d: "M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0ZM6 13.5L13.5 4.5V10.5H18L10.5 19.5V13.5H6Z",
        fill: "currentColor",
        key: "svg-15-0",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ]
  ],
  true
);

var IconBook = createReactComponent(
  "book",
  "IconBook",
  [
    [
      "g",
      { id: "book", key: "svg-16-0" },
      [
        [
          "g",
          { id: "Vector", key: "svg-16-0" },
          [
            [
              "path",
              {
                d: "M8.66797 10.5107C9.22009 10.5108 9.66788 10.9586 9.66797 11.5107C9.66797 12.0629 9.22014 12.5106 8.66797 12.5107H5.77539C5.22311 12.5107 4.77539 12.063 4.77539 11.5107C4.77547 10.9585 5.22316 10.5107 5.77539 10.5107H8.66797Z",
                fill: "currentColor",
                key: "svg-16-0"
              },
              []
            ],
            [
              "path",
              {
                d: "M8.04688 7.62399C8.55098 7.67521 8.94413 8.10056 8.94434 8.61813C8.94434 9.1359 8.55113 9.56204 8.04688 9.61325L7.94434 9.61813H5.77539C5.22311 9.61813 4.77539 9.17042 4.77539 8.61813C4.77561 8.06603 5.22324 7.61813 5.77539 7.61813H7.94434L8.04688 7.62399Z",
                fill: "currentColor",
                key: "svg-16-1"
              },
              []
            ],
            [
              "path",
              {
                d: "M1.40039 4.92575C1.40054 3.19743 2.83198 1.86508 4.56641 2.01071L4.56543 2.01169C6.74534 2.18864 9.95197 3.25638 11.8037 4.40622L12.0215 4.53708C12.0272 4.53773 12.0338 4.53804 12.041 4.53806C12.0461 4.53806 12.0513 4.53742 12.0557 4.53708L12.1729 4.46188L12.1836 4.45505L12.5469 4.23825C14.4349 3.15894 17.4004 2.19592 19.4473 2.02048L19.5322 2.01657H19.5713C21.2677 1.90923 22.6825 3.20962 22.6826 4.93552V16.5722C22.6826 17.9943 21.5626 19.2944 20.1289 19.4736H20.125L19.8076 19.5127L19.8066 19.5117C17.8281 19.7774 14.7166 20.8065 12.9775 21.7666C12.6661 21.9414 12.3225 22 12.0352 22C11.7529 21.9999 11.4241 21.9429 11.1221 21.7851L11.083 21.7666C11.0722 21.7612 11.0614 21.7558 11.0508 21.75C9.30705 20.7964 6.19441 19.774 4.22461 19.5107H4.2207L3.9541 19.4726C3.95253 19.4724 3.95079 19.4728 3.94922 19.4726L3.94141 19.4716C2.51379 19.2864 1.40039 17.9901 1.40039 16.5722V4.92575ZM4.39941 4.00388C3.83954 3.95683 3.40053 4.35984 3.40039 4.92575V16.5722C3.40039 16.9744 3.738 17.3821 4.12402 17.4746L4.20215 17.4892L4.21484 17.4902L4.48926 17.5283C6.37099 17.7798 9.07155 18.6123 11.042 19.5136V6.27927C11.0333 6.27422 11.0242 6.26985 11.0156 6.26462L10.7754 6.12106C10.7707 6.11823 10.7654 6.11518 10.7607 6.11227C9.17853 5.12564 6.26587 4.15477 4.40234 4.00388H4.39941ZM19.6738 4.01364C19.6462 4.01595 19.6185 4.01656 19.5908 4.01657C17.7239 4.18363 14.8224 5.15842 13.249 6.14841L13.0957 6.24704L13.0801 6.25778C13.0679 6.26537 13.0543 6.27106 13.042 6.27829V19.5019C15.0102 18.6026 17.683 17.7773 19.5547 17.5283L19.5664 17.5273L19.8848 17.4883C20.3007 17.4339 20.6826 17 20.6826 16.5722V4.93552C20.6825 4.4049 20.2968 4.0167 19.7793 4.00974L19.6738 4.01364Z",
                fill: "currentColor",
                key: "svg-16-2",
                fillRule: "evenodd",
                clipRule: "evenodd"
              },
              []
            ]
          ]
        ]
      ]
    ]
  ],
  true
);

var IconBookmarkHeart = createReactComponent(
  "bookmarkHeart",
  "IconBookmarkHeart",
  [
    [
      "path",
      {
        d: "M4 1C2.61929 1 1.5 2.11929 1.5 3.5V23.1801C1.5 24.6314 2.99725 25.5995 4.32073 25.004L11.3845 21.8253C11.7759 21.6491 12.2241 21.6491 12.6155 21.8253L19.6793 25.004C21.0028 25.5995 22.5 24.6314 22.5 23.1801V3.5C22.5 2.11929 21.3807 1 20 1H4Z",
        fill: "currentColor",
        stroke: "white",
        key: "svg-17-0"
      },
      []
    ],
    [
      "path",
      {
        d: "M16.7777 6.78497C15.856 5.98647 14.8557 5.89092 14.0147 6.08723C13.192 6.27929 12.5149 6.74984 12.1704 7.10993L11.999 7.28906L11.8278 7.11009C10.6796 5.90609 8.66286 5.5297 7.21991 6.78533C5.67926 8.12113 5.59779 10.5138 6.97613 11.9576L11.2375 16.4224L11.2382 16.4232C11.6569 16.8649 12.3428 16.8619 12.7627 16.4243L12.7634 16.4236L17.0259 11.9576L17.0266 11.9568C18.3994 10.5099 18.3235 8.1214 16.7777 6.78497Z",
        fill: "white",
        key: "svg-17-1",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ]
  ],
  true
);

var IconBox = createReactComponent(
  "box",
  "IconBox",
  [
    [
      "path",
      {
        stroke: "currentColor",
        fill: "none",
        d: "M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z",
        key: "svg-18-0",
        strokeWidth: "2"
      },
      []
    ],
    [
      "path",
      {
        stroke: "currentColor",
        fill: "none",
        d: "m3.3 7 8.7 5 8.7-5",
        key: "svg-18-1",
        strokeWidth: "2"
      },
      []
    ],
    [
      "path",
      {
        stroke: "currentColor",
        fill: "none",
        d: "M12 22V12",
        key: "svg-18-2",
        strokeWidth: "2"
      },
      []
    ]
  ],
  true
);

var IconBuilding = createReactComponent(
  "building",
  "IconBuilding",
  [
    [
      "g",
      { key: "svg-19-0", clipPath: "url(#clip0_17181_75225)" },
      [
        [
          "path",
          {
            d: "M5.5 12C5.77614 12 6 12.2239 6 12.5V13.5C6 13.7761 5.77614 14 5.5 14H4.5C4.22386 14 4 13.7761 4 13.5V12.5C4 12.2239 4.22386 12 4.5 12H5.5Z",
            fill: "currentColor",
            key: "svg-19-0"
          },
          []
        ],
        [
          "path",
          {
            d: "M11.5 12C11.7761 12 12 12.2239 12 12.5V13.5C12 13.7761 11.7761 14 11.5 14H10.5C10.2239 14 10 13.7761 10 13.5V12.5C10 12.2239 10.2239 12 10.5 12H11.5Z",
            fill: "currentColor",
            key: "svg-19-1"
          },
          []
        ],
        [
          "path",
          {
            d: "M5.5 8C5.77614 8 6 8.22386 6 8.5V9.5C6 9.77614 5.77614 10 5.5 10H4.5C4.22386 10 4 9.77614 4 9.5V8.5C4 8.22386 4.22386 8 4.5 8H5.5Z",
            fill: "currentColor",
            key: "svg-19-2"
          },
          []
        ],
        [
          "path",
          {
            d: "M11.5 8C11.7761 8 12 8.22386 12 8.5V9.5C12 9.77614 11.7761 10 11.5 10H10.5C10.2239 10 10 9.77614 10 9.5V8.5C10 8.22386 10.2239 8 10.5 8H11.5Z",
            fill: "currentColor",
            key: "svg-19-3"
          },
          []
        ],
        [
          "path",
          {
            d: "M5.5 4C5.77614 4 6 4.22386 6 4.5V5.5C6 5.77614 5.77614 6 5.5 6H4.5C4.22386 6 4 5.77614 4 5.5V4.5C4 4.22386 4.22386 4 4.5 4H5.5Z",
            fill: "currentColor",
            key: "svg-19-4"
          },
          []
        ],
        [
          "path",
          {
            d: "M11.5 4C11.7761 4 12 4.22386 12 4.5V5.5C12 5.77614 11.7761 6 11.5 6H10.5C10.2239 6 10 5.77614 10 5.5V4.5C10 4.22386 10.2239 4 10.5 4H11.5Z",
            fill: "currentColor",
            key: "svg-19-5"
          },
          []
        ],
        [
          "path",
          {
            d: "M19.5 16C19.7761 16 20 16.2239 20 16.5V17.5C20 17.7761 19.7761 18 19.5 18H18.5C18.2239 18 18 17.7761 18 17.5V16.5C18 16.2239 18.2239 16 18.5 16H19.5Z",
            fill: "currentColor",
            key: "svg-19-6"
          },
          []
        ],
        [
          "path",
          {
            d: "M19.5 12C19.7761 12 20 12.2239 20 12.5V13.5C20 13.7761 19.7761 14 19.5 14H18.5C18.2239 14 18 13.7761 18 13.5V12.5C18 12.2239 18.2239 12 18.5 12H19.5Z",
            fill: "currentColor",
            key: "svg-19-7"
          },
          []
        ],
        [
          "path",
          {
            d: "M13 0C14.6569 0 16 1.34315 16 3V8.17383C16.3131 8.06306 16.649 8 17 8H21C22.6569 8 24 9.34315 24 11V21C24 22.6569 22.6569 24 21 24H3C1.39489 24 0.0842144 22.7394 0.00390625 21.1543L0 21V3C1.9328e-07 1.34315 1.34315 2.14752e-08 3 0H13ZM3 2C2.44772 2 2 2.44772 2 3V21L2.00488 21.1025C2.05278 21.573 2.42703 21.9472 2.89746 21.9951L3 22H4V19C4 16.7909 5.79086 15 8 15C10.2091 15 12 16.7909 12 19V22H13C13.5177 22 13.9438 21.6067 13.9951 21.1025L14 21V3C14 2.44772 13.5523 2 13 2H3ZM8 17C6.89543 17 6 17.8954 6 19V22H10V19C10 17.8954 9.10457 17 8 17ZM17 10C16.4477 10 16 10.4477 16 11V21C16 21.5523 16.4477 22 17 22H21L21.1025 21.9951C21.573 21.9472 21.9472 21.573 21.9951 21.1025L22 21V11C22 10.4823 21.6067 10.0562 21.1025 10.0049L21 10H17Z",
            fill: "currentColor",
            key: "svg-19-8",
            fillRule: "evenodd",
            clipRule: "evenodd"
          },
          []
        ]
      ]
    ],
    [
      "defs",
      { key: "svg-19-1" },
      [
        [
          "clipPath",
          { id: "clip0_17181_75225", key: "svg-19-0" },
          [
            [
              "rect",
              { width: "24", height: "24", fill: "white", key: "svg-19-0" },
              []
            ]
          ]
        ]
      ]
    ]
  ],
  true
);

var IconCalendar = createReactComponent(
  "calendar",
  "IconCalendar",
  [
    [
      "path",
      {
        d: "M16.6 13.2H13C12.34 13.2 11.8 13.74 11.8 14.4V18C11.8 18.66 12.34 19.2 13 19.2H16.6C17.26 19.2 17.8 18.66 17.8 18V14.4C17.8 13.74 17.26 13.2 16.6 13.2ZM16.6 1.2V2.4H7V1.2C7 0.54 6.46 0 5.8 0C5.14 0 4.6 0.54 4.6 1.2V2.4H3.4C2.068 2.4 1.012 3.48 1.012 4.8L1 21.6C1 22.92 2.068 24 3.4 24H20.2C21.52 24 22.6 22.92 22.6 21.6V4.8C22.6 3.48 21.52 2.4 20.2 2.4H19V1.2C19 0.54 18.46 0 17.8 0C17.14 0 16.6 0.54 16.6 1.2ZM19 21.6H4.6C3.94 21.6 3.4 21.06 3.4 20.4V8.4H20.2V20.4C20.2 21.06 19.66 21.6 19 21.6Z",
        fill: "currentColor",
        key: "svg-20-0"
      },
      []
    ]
  ],
  true
);

var IconCash = createReactComponent(
  "cash",
  "IconCash",
  [
    [
      "path",
      {
        d: "M13.2785 6.65472C14.1556 6.65472 15.0289 6.54053 15.8761 6.31507L18.9555 5.49556L19.2184 6.47001C19.2478 6.57896 19.3472 6.65472 19.4608 6.65472H20.4998C20.6648 6.65472 20.7849 6.49929 20.7422 6.34102L20.4097 5.10858C20.1945 4.31094 19.369 3.83759 18.5659 4.05132L9.15145 6.55673C9.09477 6.57182 9.10576 6.65472 9.16444 6.65472H13.2785Z",
        fill: "currentColor",
        key: "svg-21-0"
      },
      []
    ],
    [
      "path",
      {
        d: "M1.92019 10.2249C1.92019 10.3376 1.84392 10.4364 1.73423 10.4656L1.50581 10.5264L1.74921 11.4285C1.86271 11.8492 1.92019 12.2829 1.92019 12.7185V17.4607C1.92019 17.519 1.83673 17.5299 1.82154 17.4736L0.0516703 10.9133C-0.16352 10.1157 0.313076 9.29584 1.11618 9.08211L1.73448 8.93455C1.82915 8.91195 1.92019 8.98321 1.92019 9.07992V10.2249Z",
        fill: "currentColor",
        key: "svg-21-1"
      },
      []
    ],
    [
      "path",
      {
        d: "M13.4619 16.5112C14.8476 16.5112 15.971 15.3955 15.971 14.0192C15.971 12.643 14.8476 11.5273 13.4619 11.5273C12.0762 11.5273 10.9529 12.643 10.9529 14.0192C10.9529 15.3955 12.0762 16.5112 13.4619 16.5112Z",
        fill: "currentColor",
        key: "svg-21-2"
      },
      []
    ],
    [
      "path",
      {
        d: "M8.44378 14.2684C8.44378 14.6813 8.10678 15.016 7.69106 15.016C7.27535 15.016 6.93834 14.6813 6.93834 14.2684C6.93834 13.8556 7.27535 13.5209 7.69106 13.5209C8.10678 13.5209 8.44378 13.8556 8.44378 14.2684Z",
        fill: "currentColor",
        key: "svg-21-3"
      },
      []
    ],
    [
      "path",
      {
        d: "M19.2328 15.016C19.6485 15.016 19.9855 14.6813 19.9855 14.2684C19.9855 13.8556 19.6485 13.5209 19.2328 13.5209C18.8171 13.5209 18.4801 13.8556 18.4801 14.2684C18.4801 14.6813 18.8171 15.016 19.2328 15.016Z",
        fill: "currentColor",
        key: "svg-21-4"
      },
      []
    ],
    [
      "path",
      {
        d: "M22.4946 20H4.42928C4.32535 20 4.22388 19.9895 4.12588 19.9696C3.43987 19.8302 2.92384 19.2274 2.92384 18.5048V9.53368C2.92384 8.70791 3.59784 8.0385 4.42928 8.0385H22.4946C23.326 8.0385 24 8.70791 24 9.53368V18.5048C24 19.3306 23.326 20 22.4946 20ZM4.42928 11.0289C5.26071 11.0289 5.93472 10.3595 5.93472 9.53368H20.9891C20.9891 10.3595 21.6631 11.0289 22.4946 11.0289V17.0096C21.6631 17.0096 20.9891 17.679 20.9891 18.5048H5.93472C5.93472 17.679 5.26071 17.0096 4.42928 17.0096V11.0289Z",
        fill: "currentColor",
        key: "svg-21-5",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ]
  ],
  true
);

var IconCheck = createReactComponent(
  "check",
  "IconCheck",
  [
    [
      "path",
      {
        d: "M20.7749 4.08389C21.2809 4.51198 21.344 5.26916 20.9159 5.77508L9.91588 18.7751C9.70552 19.0237 9.40316 19.1761 9.07819 19.1974C8.75323 19.2187 8.43357 19.1069 8.19261 18.8879L2.69261 13.8879C2.20222 13.4421 2.16608 12.6831 2.61189 12.1927C3.05769 11.7024 3.81663 11.6662 4.30702 12.112L8.88694 16.2756L19.0837 4.22482C19.5118 3.71889 20.269 3.6558 20.7749 4.08389Z",
        fill: "currentColor",
        key: "svg-22-0",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ]
  ],
  true
);

var IconCheckboxOutlined = createReactComponent(
  "checkbox-outlined",
  "IconCheckboxOutlined",
  [
    [
      "g",
      { key: "svg-23-0", clipPath: "url(#clip0_16642_2461)" },
      [
        [
          "path",
          {
            d: "M18.0995 7.06053C18.6529 7.52876 18.7219 8.35691 18.2537 8.91027L11.0349 17.4415C10.7978 17.7217 10.4542 17.8898 10.0875 17.9051C9.72078 17.9203 9.36442 17.7813 9.10488 17.5218L5.82363 14.2406C5.31107 13.728 5.31107 12.897 5.82363 12.3844C6.33619 11.8718 7.16722 11.8718 7.67979 12.3844L9.9524 14.657L16.2498 7.21468C16.718 6.66132 17.5461 6.5923 18.0995 7.06053Z",
            fill: "currentColor",
            key: "svg-23-0",
            fillRule: "evenodd",
            clipRule: "evenodd"
          },
          []
        ],
        [
          "path",
          {
            d: "M21.375 7.5C21.375 4.80761 19.1924 2.625 16.5 2.625H7.5C4.80761 2.625 2.625 4.80761 2.625 7.5V16.5C2.625 19.1924 4.80761 21.375 7.5 21.375H16.5C19.1924 21.375 21.375 19.1924 21.375 16.5V7.5ZM23.625 16.5C23.625 20.435 20.435 23.625 16.5 23.625H7.5C3.56497 23.625 0.375 20.435 0.375 16.5V7.5C0.375 3.56497 3.56497 0.375 7.5 0.375H16.5C20.435 0.375 23.625 3.56497 23.625 7.5V16.5Z",
            fill: "currentColor",
            key: "svg-23-1"
          },
          []
        ]
      ]
    ],
    [
      "defs",
      { key: "svg-23-1" },
      [
        [
          "clipPath",
          { id: "clip0_16642_2461", key: "svg-23-0" },
          [
            [
              "rect",
              { width: "24", height: "24", fill: "white", key: "svg-23-0" },
              []
            ]
          ]
        ]
      ]
    ]
  ],
  true
);

var IconChevronDown = createReactComponent(
  "chevronDown",
  "IconChevronDown",
  [
    [
      "path",
      {
        d: "M3.36612 6.86612C2.87796 7.35427 2.87796 8.14573 3.36612 8.63388L11.3661 16.6339C11.8543 17.122 12.6457 17.122 13.1339 16.6339L21.1339 8.63388C21.622 8.14573 21.622 7.35427 21.1339 6.86612C20.6457 6.37796 19.8543 6.37796 19.3661 6.86612L12.25 13.9822L5.13388 6.86612C4.64573 6.37796 3.85427 6.37796 3.36612 6.86612Z",
        fill: "currentColor",
        key: "svg-24-0",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ]
  ],
  true
);

var IconChevronLeft = createReactComponent(
  "chevronLeft",
  "IconChevronLeft",
  [
    [
      "path",
      {
        d: "M17.1339 3.36612C16.6457 2.87796 15.8543 2.87796 15.3661 3.36612L7.36612 11.3661C6.87796 11.8543 6.87796 12.6457 7.36612 13.1339L15.3661 21.1339C15.8543 21.622 16.6457 21.622 17.1339 21.1339C17.622 20.6457 17.622 19.8543 17.1339 19.3661L10.0178 12.25L17.1339 5.13388C17.622 4.64573 17.622 3.85427 17.1339 3.36612Z",
        fill: "currentColor",
        key: "svg-25-0",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ]
  ],
  true
);

var IconChevronRight = createReactComponent(
  "chevronRight",
  "IconChevronRight",
  [
    [
      "path",
      {
        d: "M7.86612 20.6339C8.35427 21.122 9.14573 21.122 9.63388 20.6339L17.6339 12.6339C18.122 12.1457 18.122 11.3543 17.6339 10.8661L9.63388 2.86612C9.14573 2.37796 8.35427 2.37796 7.86612 2.86612C7.37796 3.35427 7.37796 4.14573 7.86612 4.63388L14.9822 11.75L7.86612 18.8661C7.37796 19.3543 7.37796 20.1457 7.86612 20.6339Z",
        fill: "currentColor",
        key: "svg-26-0",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ]
  ],
  true
);

var IconChevronUp = createReactComponent(
  "chevronUp",
  "IconChevronUp",
  [
    [
      "path",
      {
        d: "M21.6339 17.1339C22.122 16.6457 22.122 15.8543 21.6339 15.3661L13.6339 7.36612C13.1457 6.87796 12.3543 6.87796 11.8661 7.36612L3.86612 15.3661C3.37796 15.8543 3.37796 16.6457 3.86612 17.1339C4.35427 17.622 5.14573 17.622 5.63388 17.1339L12.75 10.0178L19.8661 17.1339C20.3543 17.622 21.1457 17.622 21.6339 17.1339Z",
        fill: "currentColor",
        key: "svg-27-0",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ]
  ],
  true
);

var IconCircleCheck = createReactComponent(
  "circleCheck",
  "IconCircleCheck",
  [
    [
      "g",
      { key: "svg-28-0", clipPath: "url(#clip0_194_2683)" },
      [
        [
          "path",
          {
            d: "M18.2357 8.70017C18.7027 8.14824 18.6339 7.32224 18.0819 6.85523C17.53 6.38822 16.704 6.45706 16.237 7.00898L9.95601 14.432L7.6893 12.1653C7.17807 11.654 6.3492 11.654 5.83797 12.1653C5.32674 12.6765 5.32674 13.5054 5.83797 14.0166L9.11069 17.2893C9.36955 17.5482 9.72498 17.6868 10.0908 17.6716C10.4565 17.6564 10.7992 17.4887 11.0357 17.2092L18.2357 8.70017Z",
            fill: "currentColor",
            key: "svg-28-0"
          },
          []
        ],
        [
          "path",
          {
            d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM21.8182 12C21.8182 17.4224 17.4224 21.8182 12 21.8182C6.57757 21.8182 2.18182 17.4224 2.18182 12C2.18182 6.57757 6.57757 2.18182 12 2.18182C17.4224 2.18182 21.8182 6.57757 21.8182 12Z",
            fill: "currentColor",
            key: "svg-28-1",
            fillRule: "evenodd",
            clipRule: "evenodd"
          },
          []
        ]
      ]
    ],
    [
      "defs",
      { key: "svg-28-1" },
      [
        [
          "clipPath",
          { id: "clip0_194_2683", key: "svg-28-0" },
          [
            [
              "rect",
              {
                width: "24",
                height: "24",
                fill: "transparent",
                key: "svg-28-0"
              },
              []
            ]
          ]
        ]
      ]
    ]
  ],
  true
);

var IconCircleClose = createReactComponent(
  "circleClose",
  "IconCircleClose",
  [
    [
      "g",
      { key: "svg-29-0", clipPath: "url(#clip0_1065_4255)" },
      [
        [
          "path",
          {
            d: "M18.9425 5.05748C15.1083 1.22324 8.89174 1.22324 5.0575 5.05748C1.22326 8.89172 1.22326 15.1082 5.0575 18.9425C8.89174 22.7767 15.1083 22.7767 18.9425 18.9425C22.7767 15.1082 22.7767 8.89172 18.9425 5.05748ZM3.51472 3.5147C8.20101 -1.17159 15.799 -1.17159 20.4853 3.5147C25.1716 8.20099 25.1716 15.799 20.4853 20.4853C15.799 25.1716 8.20101 25.1716 3.51472 20.4853C-1.17157 15.799 -1.17157 8.20099 3.51472 3.5147ZM15.8569 8.14304C16.283 8.56906 16.283 9.25979 15.8569 9.68581L13.5428 12L15.8569 14.3141C16.283 14.7402 16.283 15.4309 15.8569 15.8569C15.4309 16.283 14.7402 16.283 14.3142 15.8569L12 13.5428L9.68583 15.8569C9.25981 16.283 8.56908 16.283 8.14305 15.8569C7.71703 15.4309 7.71703 14.7402 8.14305 14.3141L10.4572 12L8.14305 9.68581C7.71703 9.25979 7.71703 8.56906 8.14305 8.14304C8.56908 7.71701 9.25981 7.71701 9.68583 8.14304L12 10.4572L14.3142 8.14304C14.7402 7.71701 15.4309 7.71701 15.8569 8.14304Z",
            fill: "currentColor",
            key: "svg-29-0",
            fillRule: "evenodd",
            clipRule: "evenodd"
          },
          []
        ]
      ]
    ],
    ["defs", { key: "svg-29-1" }, []]
  ],
  true
);

var IconClock = createReactComponent(
  "clock",
  "IconClock",
  [
    [
      "path",
      {
        d: "M13.0076 5.2828C13.0076 4.72633 12.5565 4.27522 12 4.27522C11.4435 4.27522 10.9924 4.72633 10.9924 5.2828V12C10.9924 12.3474 11.1714 12.6703 11.466 12.8544L15.4963 15.3734C15.9682 15.6683 16.5898 15.5249 16.8847 15.053C17.1797 14.5811 17.0362 13.9595 16.5643 13.6645L13.0076 11.4416V5.2828Z",
        fill: "currentColor",
        key: "svg-30-0"
      },
      []
    ],
    [
      "path",
      {
        d: "M12 0.244898C5.50784 0.244898 0.244898 5.50784 0.244898 12C0.244898 18.4922 5.50784 23.7551 12 23.7551C18.4922 23.7551 23.7551 18.4922 23.7551 12C23.7551 5.50784 18.4922 0.244898 12 0.244898ZM2.26006 12C2.26006 6.62078 6.62078 2.26006 12 2.26006C17.3792 2.26006 21.7399 6.62078 21.7399 12C21.7399 17.3792 17.3792 21.7399 12 21.7399C6.62078 21.7399 2.26006 17.3792 2.26006 12Z",
        fill: "currentColor",
        key: "svg-30-1",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ],
    [
      "path",
      {
        d: "M12 0.489796C5.64309 0.489796 0.489796 5.64309 0.489796 12C0.489796 18.3569 5.64309 23.5102 12 23.5102C18.3569 23.5102 23.5102 18.3569 23.5102 12C23.5102 5.64309 18.3569 0.489796 12 0.489796ZM0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12ZM2.01516 12C2.01516 6.48553 6.48553 2.01516 12 2.01516C17.5145 2.01516 21.9848 6.48553 21.9848 12C21.9848 17.5145 17.5145 21.9848 12 21.9848C6.48553 21.9848 2.01516 17.5145 2.01516 12ZM12 2.50496C6.75603 2.50496 2.50496 6.75603 2.50496 12C2.50496 17.244 6.75603 21.495 12 21.495C17.244 21.495 21.495 17.244 21.495 12C21.495 6.75603 17.244 2.50496 12 2.50496ZM12 4.52012C11.5788 4.52012 11.2373 4.86158 11.2373 5.2828V12C11.2373 12.263 11.3728 12.5074 11.5958 12.6468L15.6261 15.1657C15.9833 15.3889 16.4538 15.2804 16.6771 14.9232C16.9003 14.566 16.7917 14.0954 16.4345 13.8722L12.8778 11.6492C12.8062 11.6045 12.7627 11.526 12.7627 11.4416V5.2828C12.7627 4.86158 12.4212 4.52012 12 4.52012ZM10.7475 5.2828C10.7475 4.59107 11.3083 4.03032 12 4.03032C12.6917 4.03032 13.2525 4.59107 13.2525 5.2828V11.3058L16.6941 13.4569C17.2807 13.8235 17.459 14.5962 17.0924 15.1828C16.7258 15.7693 15.9531 15.9477 15.3665 15.5811L11.3362 13.0621C10.97 12.8332 10.7475 12.4318 10.7475 12V5.2828Z",
        fill: "currentColor",
        key: "svg-30-2",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ]
  ],
  true
);

var IconClose = createReactComponent(
  "close",
  "IconClose",
  [
    [
      "path",
      {
        d: "M19.8839 4.11612C19.3957 3.62796 18.6043 3.62796 18.1161 4.11612L12.0001 10.2322L5.88403 4.11614C5.39588 3.62799 4.60442 3.62799 4.11627 4.11614C3.62811 4.6043 3.62811 5.39576 4.11627 5.88391L10.2323 11.9999L4.11612 18.1161C3.62796 18.6043 3.62796 19.3957 4.11612 19.8839C4.60427 20.372 5.39573 20.372 5.88388 19.8839L12.0001 13.7677L18.1163 19.8839C18.6044 20.3721 19.3959 20.3721 19.884 19.8839C20.3722 19.3958 20.3722 18.6043 19.884 18.1161L13.7678 11.9999L19.8839 5.88388C20.372 5.39573 20.372 4.60427 19.8839 4.11612Z",
        fill: "currentColor",
        key: "svg-31-0",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ]
  ],
  true
);

var IconCopy = createReactComponent(
  "copy",
  "IconCopy",
  [
    [
      "g",
      { key: "svg-32-0", clipPath: "url(#clip0_200_3699)" },
      [
        [
          "path",
          {
            d: "M16.1818 0H4.18182C2.98182 0 2 0.819609 2 1.82135V13.6602C2 14.161 2.49091 14.5708 3.09091 14.5708C3.69091 14.5708 4.18182 14.161 4.18182 13.6602V2.73203C4.18182 2.23116 4.67273 1.82135 5.27273 1.82135H16.1818C16.7818 1.82135 17.2727 1.41155 17.2727 0.910677C17.2727 0.409805 16.7818 0 16.1818 0ZM20.5455 3.64271H8.54545C7.34545 3.64271 6.36364 4.46232 6.36364 5.46406V18.2135C6.36364 19.2153 7.34545 20.0349 8.54545 20.0349H20.5455C21.7455 20.0349 22.7273 19.2153 22.7273 18.2135V5.46406C22.7273 4.46232 21.7455 3.64271 20.5455 3.64271Z",
            fill: "currentColor",
            key: "svg-32-0"
          },
          []
        ]
      ]
    ],
    [
      "defs",
      { key: "svg-32-1" },
      [
        [
          "clipPath",
          { id: "clip0_200_3699", key: "svg-32-0" },
          [
            [
              "rect",
              {
                width: "24",
                height: "20.0349",
                fill: "transparent",
                key: "svg-32-0"
              },
              []
            ]
          ]
        ]
      ]
    ]
  ],
  true
);

var IconCreditCard = createReactComponent(
  "creditCard",
  "IconCreditCard",
  [
    [
      "g",
      { key: "svg-33-0", clipPath: "url(#clip0_1439_6229)" },
      [
        [
          "path",
          {
            d: "M3.5 3.5V22C3.5 22.8285 4.1715 23.5 5 23.5H8V3.5H3.5Z",
            fill: "currentColor",
            key: "svg-33-0"
          },
          []
        ],
        [
          "path",
          {
            d: "M20 0.5H4C2.07 0.5 0.5 2.0705 0.5 4C0.5 5.392 1.3195 6.592 2.5 7.1545V5.988C1.896 5.531 1.5 4.814 1.5 4C1.5 2.6215 2.6215 1.5 4 1.5H20C21.3785 1.5 22.5 2.6215 22.5 4C22.5 4.814 22.104 5.531 21.5 5.988V7.1545C22.6805 6.5925 23.5 5.3925 23.5 4C23.5 2.0705 21.93 0.5 20 0.5Z",
            fill: "currentColor",
            key: "svg-33-1"
          },
          []
        ],
        [
          "path",
          {
            d: "M20.5 3.5H12V23.5H19C19.8285 23.5 20.5 22.8285 20.5 22V3.5ZM16.5 19C16.5 19.2765 16.276 19.5 16 19.5C15.724 19.5 15.5 19.2765 15.5 19V14C15.5 13.7235 15.724 13.5 16 13.5C16.276 13.5 16.5 13.7235 16.5 14V19Z",
            fill: "currentColor",
            key: "svg-33-2"
          },
          []
        ]
      ]
    ],
    [
      "defs",
      { key: "svg-33-1" },
      [
        [
          "clipPath",
          { id: "clip0_1439_6229", key: "svg-33-0" },
          [
            [
              "rect",
              {
                width: "24",
                height: "24",
                fill: "transparent",
                key: "svg-33-0"
              },
              []
            ]
          ]
        ]
      ]
    ]
  ],
  true
);

var IconCrop = createReactComponent(
  "crop",
  "IconCrop",
  [
    [
      "g",
      { key: "svg-34-0", clipPath: "url(#clip0_11730_25786)" },
      [
        [
          "path",
          {
            d: "M5.49677 0C6.13814 0 6.65806 0.519927 6.65806 1.16129V4.33548H16.3355C17.2184 4.33548 18.0651 4.68622 18.6895 5.31053C19.3138 5.93485 19.6645 6.7816 19.6645 7.66452V17.3419H22.8387C23.4801 17.3419 24 17.8619 24 18.5032C24 19.1446 23.4801 19.6645 22.8387 19.6645H19.6645V22.8387C19.6645 23.4801 19.1446 24 18.5032 24C17.8619 24 17.3419 23.4801 17.3419 22.8387V19.6645H7.66452C6.7816 19.6645 5.93485 19.3138 5.31053 18.6895C4.68622 18.0651 4.33548 17.2184 4.33548 16.3355V6.65806H1.16129C0.519927 6.65806 0 6.13814 0 5.49677C0 4.85541 0.519927 4.33548 1.16129 4.33548H4.33548V1.16129C4.33548 0.519927 4.85541 0 5.49677 0ZM6.65806 6.65806V16.3355C6.65806 16.6024 6.7641 16.8584 6.95285 17.0471C7.14159 17.2359 7.39759 17.3419 7.66452 17.3419H17.3419V7.66452C17.3419 7.39759 17.2359 7.14159 17.0471 6.95285C16.8584 6.7641 16.6024 6.65806 16.3355 6.65806H6.65806Z",
            fill: "currentColor",
            key: "svg-34-0",
            fillRule: "evenodd",
            clipRule: "evenodd"
          },
          []
        ]
      ]
    ],
    [
      "defs",
      { key: "svg-34-1" },
      [
        [
          "clipPath",
          { id: "clip0_11730_25786", key: "svg-34-0" },
          [
            [
              "rect",
              {
                width: "24",
                height: "24",
                fill: "transparent",
                key: "svg-34-0"
              },
              []
            ]
          ]
        ]
      ]
    ]
  ],
  true
);

var IconDashboard = createReactComponent(
  "dashboard",
  "IconDashboard",
  [
    [
      "path",
      {
        d: "M9.88235 21.5529H14.1176C14.8941 21.5529 15.5294 20.9176 15.5294 20.1411V14.4941C15.5294 13.7176 14.8941 13.0823 14.1176 13.0823H9.88235C9.10588 13.0823 8.47059 13.7176 8.47059 14.4941V20.1411C8.47059 20.9176 9.10588 21.5529 9.88235 21.5529ZM1.41176 21.5529H5.64706C6.42353 21.5529 7.05882 20.9176 7.05882 20.1411V4.61172C7.05882 3.83525 6.42353 3.19995 5.64706 3.19995H1.41176C0.635294 3.19995 0 3.83525 0 4.61172V20.1411C0 20.9176 0.635294 21.5529 1.41176 21.5529ZM18.3529 21.5529H22.5882C23.3647 21.5529 24 20.9176 24 20.1411V14.4941C24 13.7176 23.3647 13.0823 22.5882 13.0823H18.3529C17.5765 13.0823 16.9412 13.7176 16.9412 14.4941V20.1411C16.9412 20.9176 17.5765 21.5529 18.3529 21.5529ZM8.47059 4.61172V10.2588C8.47059 11.0352 9.10588 11.6705 9.88235 11.6705H22.5882C23.3647 11.6705 24 11.0352 24 10.2588V4.61172C24 3.83525 23.3647 3.19995 22.5882 3.19995H9.88235C9.10588 3.19995 8.47059 3.83525 8.47059 4.61172Z",
        fill: "currentColor",
        key: "svg-35-0"
      },
      []
    ]
  ],
  true
);

var IconDelete = createReactComponent(
  "delete",
  "IconDelete",
  [
    [
      "g",
      { key: "svg-36-0", clipPath: "url(#clip0_387_6626)" },
      [
        [
          "path",
          {
            d: "M6 19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V9C18 7.9 17.1 7 16 7H8C6.9 7 6 7.9 6 9V19ZM18 4H15.5L14.79 3.29C14.61 3.11 14.35 3 14.09 3H9.91C9.65 3 9.39 3.11 9.21 3.29L8.5 4H6C5.45 4 5 4.45 5 5C5 5.55 5.45 6 6 6H18C18.55 6 19 5.55 19 5C19 4.45 18.55 4 18 4Z",
            fill: "currentColor",
            key: "svg-36-0"
          },
          []
        ]
      ]
    ],
    [
      "defs",
      { key: "svg-36-1" },
      [
        [
          "clipPath",
          { id: "clip0_387_6626", key: "svg-36-0" },
          [
            [
              "rect",
              {
                width: "24",
                height: "24",
                fill: "transparent",
                key: "svg-36-0"
              },
              []
            ]
          ]
        ]
      ]
    ]
  ],
  true
);

var IconDesktop = createReactComponent(
  "desktop",
  "IconDesktop",
  [
    [
      "path",
      {
        d: "M20 18C21.1 18 22 17.1 22 16V6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V16C2 17.1 2.9 18 4 18H1C0.45 18 0 18.45 0 19C0 19.55 0.45 20 1 20H23C23.55 20 24 19.55 24 19C24 18.45 23.55 18 23 18H20ZM5 6H19C19.55 6 20 6.45 20 7V15C20 15.55 19.55 16 19 16H5C4.45 16 4 15.55 4 15V7C4 6.45 4.45 6 5 6Z",
        fill: "currentColor",
        key: "svg-37-0"
      },
      []
    ]
  ],
  true
);

var IconDirection = createReactComponent(
  "direction",
  "IconDirection",
  [
    [
      "path",
      {
        d: "M13.0631 0.440156L23.5598 10.9369C24.1467 11.5242 24.1467 12.4758 23.5598 13.0631L13.0631 23.5598C12.7697 23.8533 12.3848 24 12 24C11.6152 24 11.2303 23.8533 10.9369 23.5598L0.440156 13.0631C-0.146719 12.4758 -0.146719 11.5242 0.440156 10.9369L10.9369 0.440156C11.2303 0.146719 11.6152 0 12 0C12.3848 0 12.7697 0.146719 13.0631 0.440156ZM9.75 10.5001H15.5105L12.9497 8.13474C12.7978 7.99459 12.788 7.7574 12.9286 7.60506L13.4367 7.05474C13.5769 6.90287 13.8141 6.89303 13.9664 7.03365L17.6386 10.4232C17.8702 10.6369 18.0005 10.9379 18.0005 11.2491C18.0005 11.5604 17.8697 11.8613 17.6414 12.0732L13.9664 15.4651C13.8145 15.6057 13.5773 15.5963 13.4367 15.444L12.9286 14.8937C12.788 14.7418 12.7973 14.5046 12.9497 14.364L15.5105 12.0001H9.75C9.33562 12.0001 9 12.3357 9 12.7501V14.6251C9 14.8322 8.83219 15.0001 8.625 15.0001H7.875C7.66781 15.0001 7.5 14.8322 7.5 14.6251V12.7501C7.5 11.5074 8.50734 10.5001 9.75 10.5001Z",
        fill: "currentColor",
        key: "svg-38-0",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ]
  ],
  true
);

var IconDollar = createReactComponent(
  "dollar",
  "IconDollar",
  [
    [
      "path",
      {
        d: "M15.8802 13.0399C15.8802 13.7066 15.7135 14.3333 15.3802 14.9199C15.0602 15.5066 14.5802 15.9999 13.9402 16.3999C13.3135 16.7999 12.5669 17.0399 11.7002 17.1199V18.7399H10.4002V17.1199C9.14686 16.9999 8.13353 16.6066 7.3602 15.9399C6.58686 15.2733 6.2002 14.3933 6.2002 13.2999H8.6402C8.6802 13.8199 8.84686 14.2533 9.1402 14.5999C9.43353 14.9333 9.85353 15.1466 10.4002 15.2399V10.8399C9.50686 10.6133 8.7802 10.3866 8.2202 10.1599C7.6602 9.91995 7.1802 9.54661 6.7802 9.03995C6.39353 8.53328 6.2002 7.83995 6.2002 6.95995C6.2002 5.85328 6.58686 4.93995 7.3602 4.21995C8.13353 3.48661 9.14686 3.05995 10.4002 2.93995V1.31995H11.7002V2.93995C12.8735 3.04661 13.8135 3.41995 14.5202 4.05995C15.2402 4.68661 15.6469 5.55328 15.7402 6.65995H13.3002C13.2602 6.24661 13.1002 5.87995 12.8202 5.55995C12.5402 5.22661 12.1669 4.99995 11.7002 4.87995V9.19995C12.5935 9.41328 13.3202 9.63995 13.8802 9.87995C14.4402 10.1066 14.9135 10.4733 15.3002 10.9799C15.6869 11.4733 15.8802 12.1599 15.8802 13.0399ZM8.5202 6.83995C8.5202 7.38661 8.6802 7.81328 9.0002 8.11995C9.33353 8.42661 9.8002 8.67328 10.4002 8.85995V4.81995C9.82686 4.88661 9.36686 5.09328 9.0202 5.43995C8.68686 5.78661 8.5202 6.25328 8.5202 6.83995ZM11.7002 15.2399C12.2869 15.1466 12.7469 14.9133 13.0802 14.5399C13.4135 14.1533 13.5802 13.6933 13.5802 13.1599C13.5802 12.6266 13.4135 12.2133 13.0802 11.9199C12.7602 11.6133 12.3002 11.3666 11.7002 11.1799V15.2399Z",
        fill: "currentColor",
        key: "svg-39-0"
      },
      []
    ]
  ],
  true
);

var IconDownload = createReactComponent(
  "download",
  "IconDownload",
  [
    [
      "path",
      {
        d: "M9.8701 13.1849L10.7672 14.1139V12.8225V2.25339C10.7672 1.92403 10.9003 1.60623 11.1404 1.37042C11.3808 1.13429 11.7088 1 12.0528 1C12.3968 1 12.7248 1.13429 12.9653 1.37042C13.2054 1.60623 13.3385 1.92403 13.3385 2.25339V12.8225V14.1147L14.2357 13.1848L18.747 8.50908L18.7475 8.50855C18.863 8.38849 19.002 8.29143 19.1567 8.22338C19.3115 8.15532 19.4787 8.11773 19.6488 8.113C19.819 8.10828 19.9882 8.13652 20.1468 8.19593C20.3053 8.25534 20.4498 8.34461 20.5722 8.45822C20.6946 8.57181 20.7925 8.70746 20.8608 8.85715C20.929 9.00683 20.9664 9.16786 20.9711 9.33114C20.9758 9.49441 20.9477 9.65718 20.8883 9.81025C20.8288 9.96334 20.739 10.104 20.6235 10.2241L12.993 18.1408L12.9925 18.1413C12.8729 18.2657 12.728 18.3654 12.5667 18.4337C12.4053 18.502 12.231 18.5374 12.0546 18.5374C11.8783 18.5374 11.704 18.502 11.5426 18.4337C11.3812 18.3654 11.2364 18.2657 11.1167 18.1413L11.1161 18.1407L3.47854 10.2241L3.47838 10.2239C3.36295 10.1039 3.27319 9.96328 3.21376 9.81025C3.15431 9.65718 3.12624 9.49441 3.13094 9.33114C3.14043 9.00177 3.28273 8.68752 3.52978 8.45822C3.77716 8.22863 4.10921 8.10345 4.45318 8.113C4.79712 8.12256 5.12112 8.26594 5.35456 8.50856L5.35521 8.50923L9.8701 13.1849ZM1.30435 20.8261C0.583976 20.8261 0 21.4101 0 22.1304C0 22.8508 0.583976 23.4348 1.30435 23.4348H22.6957C23.416 23.4348 24 22.8508 24 22.1304C24 21.4101 23.416 20.8261 22.6957 20.8261H1.30435Z",
        fill: "currentColor",
        key: "svg-40-0",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ]
  ],
  true
);

var IconDuplicate = createReactComponent(
  "duplicate",
  "IconDuplicate",
  [
    [
      "g",
      { key: "svg-41-0", clipPath: "url(#clip0_277_8308)" },
      [
        [
          "path",
          {
            d: "M8.12624 14.4479L8.12624 3.80208C8.12624 3.01465 8.76459 2.3763 9.55203 2.3763L20.1979 2.3763C20.9853 2.3763 21.6237 3.01465 21.6237 3.80208V14.4479C21.6237 15.2354 20.9853 15.8737 20.1979 15.8737L9.55203 15.8737C8.76459 15.8737 8.12624 15.2354 8.12624 14.4479ZM5.74993 3.80208C5.74993 1.70225 7.45219 -9.17866e-08 9.55203 0L20.1979 4.65344e-07C22.2977 5.57131e-07 24 1.70225 24 3.80208L24 14.4479C24 16.5477 22.2977 18.25 20.1979 18.25H9.55203C7.45219 18.25 5.74993 16.5477 5.74993 14.4479L5.74993 3.80208Z",
            fill: "currentColor",
            key: "svg-41-0",
            fillRule: "evenodd",
            clipRule: "evenodd"
          },
          []
        ],
        [
          "path",
          {
            d: "M1.18816 12.4993C0.531956 12.4993 2.61025e-07 13.0312 2.32341e-07 13.6874L0 19.0027C-1.20654e-07 21.7629 2.23762 24.0006 4.99786 24.0006H10.3132C10.9694 24.0006 11.5013 23.4686 11.5013 22.8124C11.5013 22.1562 10.9694 21.6243 10.3132 21.6243H4.99786C3.55002 21.6243 2.37631 20.4506 2.37631 19.0027L2.37631 13.6874C2.37631 13.0312 1.84436 12.4993 1.18816 12.4993Z",
            fill: "currentColor",
            key: "svg-41-1",
            fillRule: "evenodd",
            clipRule: "evenodd"
          },
          []
        ]
      ]
    ],
    [
      "defs",
      { key: "svg-41-1" },
      [
        [
          "clipPath",
          { id: "clip0_277_8308", key: "svg-41-0" },
          [
            [
              "rect",
              {
                width: "24",
                height: "24",
                fill: "transparent",
                key: "svg-41-0"
              },
              []
            ]
          ]
        ]
      ]
    ]
  ],
  true
);

var IconEarn = createReactComponent(
  "earn",
  "IconEarn",
  [
    [
      "g",
      { key: "svg-42-0", clipPath: "url(#clip0_2214_16961)" },
      [
        [
          "path",
          {
            d: "M11.8631 4.05C11.863 4.05 11.8632 4.05 11.8631 4.05V4.05Z",
            fill: "currentColor",
            key: "svg-42-0"
          },
          []
        ],
        [
          "path",
          {
            d: "M13.0757 9.1027C12.8964 8.77069 12.5482 8.55 12.1504 8.55C12.1503 8.55 12.1505 8.55 12.1504 8.55C12.5482 8.55 12.8964 8.77069 13.0757 9.1027Z",
            fill: "currentColor",
            key: "svg-42-1"
          },
          []
        ],
        [
          "path",
          {
            d: "M12.9134 5.4V6.22711L13.1284 6.2906C14.0171 6.55291 14.7563 7.16389 15.1874 7.96229C15.463 8.47253 15.2727 9.10955 14.7625 9.38511C14.2522 9.66066 13.6152 9.4704 13.3397 8.96015C13.1098 8.53442 12.6621 8.25 12.1504 8.25C11.4048 8.25 10.8004 8.85442 10.8004 9.6C10.8004 10.2425 11.2492 10.7801 11.8504 10.9165V10.939L12.1278 10.96C13.9095 11.0948 15.3134 12.5836 15.3134 14.4C15.3134 15.8671 14.3976 17.121 13.1054 17.6198L12.9134 17.6939L12.9134 18.6C12.9134 19.1799 12.4432 19.65 11.8633 19.65C11.2834 19.65 10.8134 19.1799 10.8134 18.6L10.8134 17.6938L10.6215 17.6197C9.85083 17.3221 9.21403 16.7555 8.82638 16.0377C8.55082 15.5275 8.74108 14.8904 9.25133 14.6149C9.76158 14.3393 10.3986 14.5296 10.6741 15.0398C10.9041 15.4656 11.3517 15.75 11.8634 15.75C12.609 15.75 13.2134 15.1456 13.2134 14.4C13.2134 13.7575 12.7646 13.2199 12.1634 13.0835V13.061L11.8861 13.04C10.1043 12.9052 8.7004 11.4164 8.7004 9.6C8.7004 8.23504 9.49305 7.05464 10.6445 6.49506L10.8134 6.41299V5.4C10.8134 4.8201 11.2835 4.35 11.8634 4.35C12.4433 4.35 12.9134 4.8201 12.9134 5.4Z",
            fill: "currentColor",
            key: "svg-42-2"
          },
          []
        ],
        [
          "path",
          {
            d: "M0 12C0 5.37103 5.37103 0 12 0C18.629 0 24 5.37103 24 12C24 18.629 18.629 24 12 24C5.37103 24 0 18.629 0 12ZM12 2.35989C6.68494 2.35989 2.35989 6.68494 2.35989 12C2.35989 17.3151 6.68494 21.6401 12 21.6401C17.3151 21.6401 21.6401 17.3151 21.6401 12C21.6401 6.68494 17.3151 2.35989 12 2.35989Z",
            fill: "currentColor",
            key: "svg-42-3",
            fillRule: "evenodd",
            clipRule: "evenodd"
          },
          []
        ]
      ]
    ],
    [
      "defs",
      { key: "svg-42-1" },
      [
        [
          "clipPath",
          { id: "clip0_2214_16961", key: "svg-42-0" },
          [
            [
              "rect",
              {
                width: "24",
                height: "24",
                fill: "transparent",
                key: "svg-42-0"
              },
              []
            ]
          ]
        ]
      ]
    ]
  ],
  true
);

var IconEdit = createReactComponent(
  "edit",
  "IconEdit",
  [
    [
      "g",
      { key: "svg-43-0", clipPath: "url(#clip0_277_8307)" },
      [
        [
          "path",
          {
            d: "M16.4956 0.549418C17.2282 -0.183223 18.4161 -0.183219 19.1487 0.549419L23.1283 4.5291C23.8609 5.26174 23.8609 6.44959 23.1283 7.18223L11.6316 18.6791C11.3446 18.9661 10.9722 19.1523 10.5704 19.2097L5.92747 19.873C4.68937 20.0499 3.62813 18.9886 3.80501 17.7505L4.46828 13.1075C4.52568 12.7057 4.71187 12.3333 4.99889 12.0463L16.4956 0.549418ZM14.5052 5.193L6.32544 13.3728L5.66217 18.0158L10.3051 17.3525L18.4846 9.17285C18.1183 9.53839 17.5249 9.53813 17.1589 9.17207L14.5058 6.51895C14.1397 6.15283 14.1395 5.55937 14.5052 5.193ZM17.8221 1.87598L14.5064 5.19177C14.8728 4.82607 15.4662 4.82627 15.8323 5.19238L18.4854 7.84551C18.8515 8.21157 18.8517 8.80491 18.4862 9.17129L21.8018 5.85567L17.8221 1.87598ZM4.0647 5.23952C2.85592 5.23952 1.87601 6.21944 1.87601 7.42824V19.9352C1.87601 21.144 2.85592 22.1239 4.0647 22.1239H16.5715C17.7802 22.1239 18.7601 21.144 18.7601 19.9352V17.4338C18.7601 16.9157 19.1801 16.4958 19.6982 16.4958C20.2162 16.4958 20.6362 16.9157 20.6362 17.4338V19.9352C20.6362 22.1801 18.8163 23.9999 16.5715 23.9999H4.0647C1.81983 23.9999 0 22.1801 0 19.9352V7.42824C0 5.18333 1.81983 3.36348 4.0647 3.36348H6.56605C7.0841 3.36348 7.50406 3.78345 7.50406 4.3015C7.50406 4.81956 7.0841 5.23952 6.56605 5.23952H4.0647Z",
            fill: "#currentColor",
            key: "svg-43-0",
            fillRule: "evenodd",
            clipRule: "evenodd"
          },
          []
        ]
      ]
    ],
    [
      "defs",
      { key: "svg-43-1" },
      [
        [
          "clipPath",
          { id: "clip0_277_8307", key: "svg-43-0" },
          [
            [
              "rect",
              {
                width: "24",
                height: "24",
                fill: "transparent",
                key: "svg-43-0"
              },
              []
            ]
          ]
        ]
      ]
    ]
  ],
  true
);

var IconEmail = createReactComponent(
  "email",
  "IconEmail",
  [
    [
      "path",
      {
        d: "M2.4 2H21.6C22.2365 2 22.847 2.25286 23.2971 2.70294C23.7471 3.15303 24 3.76348 24 4.4V18.8C24 19.4365 23.7471 20.047 23.2971 20.4971C22.847 20.9471 22.2365 21.2 21.6 21.2H2.4C1.068 21.2 0 20.12 0 18.8V4.4C0 3.068 1.068 2 2.4 2ZM12 10.4L21.6 4.4H2.4L12 10.4ZM2.4 18.8H21.6V7.244L12 13.232L2.4 7.244V18.8Z",
        fill: "currentColor",
        key: "svg-44-0"
      },
      []
    ]
  ],
  true
);

var IconEvent = createReactComponent(
  "event",
  "IconEvent",
  [
    [
      "g",
      { id: "event", key: "svg-45-0" },
      [
        [
          "path",
          {
            id: "Vector",
            d: "M3.11124 19.8585L11.3155 16.9208L6.02054 11.5743L3.11124 19.8585ZM23.7382 6.13967C23.5636 6.31593 23.36 6.40406 23.1272 6.40406C22.8945 6.40406 22.6908 6.31593 22.5163 6.13967L22.429 6.05154C22.1574 5.77736 21.818 5.64027 21.4107 5.64027C21.0034 5.64027 20.664 5.77736 20.3925 6.05154L14.4866 12.015C14.312 12.1912 14.1084 12.2793 13.8756 12.2793C13.6429 12.2793 13.4392 12.1912 13.2647 12.015C13.0901 11.8387 13.0029 11.6331 13.0029 11.398C13.0029 11.163 13.0901 10.9574 13.2647 10.7811L19.1706 4.81773C19.7912 4.19103 20.5379 3.87769 21.4107 3.87769C22.2835 3.87769 23.0302 4.19103 23.6509 4.81773L23.7382 4.90586C23.9127 5.08212 24 5.28775 24 5.52277C24 5.75778 23.9127 5.96341 23.7382 6.13967ZM8.55163 2.6145C8.72618 2.43824 8.92983 2.35011 9.16258 2.35011C9.39532 2.35011 9.59897 2.43824 9.77353 2.6145L9.919 2.76138C10.5396 3.38808 10.85 4.13228 10.85 4.99399C10.85 5.8557 10.5396 6.5999 9.919 7.2266L9.83172 7.31473C9.65716 7.49098 9.45351 7.57911 9.22076 7.57911C8.98802 7.57911 8.78437 7.49098 8.60981 7.31473C8.43525 7.13847 8.34797 6.93283 8.34797 6.69782C8.34797 6.46281 8.43525 6.25718 8.60981 6.08092L8.69709 5.99279C8.96863 5.71861 9.10439 5.38567 9.10439 4.99399C9.10439 4.6023 8.96863 4.26937 8.69709 3.99519L8.55163 3.84831C8.37707 3.67205 8.28979 3.46642 8.28979 3.23141C8.28979 2.99639 8.37707 2.79076 8.55163 2.6145ZM13.2647 0.264388C13.4392 0.0881292 13.6429 0 13.8756 0C14.1084 0 14.312 0.0881292 14.4866 0.264388L15.7376 1.52757C16.3582 2.15427 16.6686 2.90826 16.6686 3.78956C16.6686 4.67085 16.3582 5.42484 15.7376 6.05154L12.1592 9.66484C11.9846 9.8411 11.7809 9.92923 11.5482 9.92923C11.3155 9.92923 11.1118 9.8411 10.9373 9.66484C10.7627 9.48858 10.6754 9.28295 10.6754 9.04793C10.6754 8.81292 10.7627 8.60729 10.9373 8.43103L14.5157 4.81773C14.7872 4.54355 14.923 4.20083 14.923 3.78956C14.923 3.37829 14.7872 3.03556 14.5157 2.76138L13.2647 1.4982C13.0901 1.32194 13.0029 1.1163 13.0029 0.881292C13.0029 0.646281 13.0901 0.440646 13.2647 0.264388ZM22.5744 14.3651C22.3999 14.5413 22.1962 14.6295 21.9635 14.6295C21.7307 14.6295 21.5271 14.5413 21.3525 14.3651L20.1015 13.1019C19.83 12.8277 19.4906 12.6906 19.0833 12.6906C18.676 12.6906 18.3366 12.8277 18.065 13.1019L16.814 14.3651C16.6395 14.5413 16.4358 14.6295 16.2031 14.6295C15.9703 14.6295 15.7667 14.5413 15.5921 14.3651C15.4176 14.1888 15.3303 13.9832 15.3303 13.7482C15.3303 13.5131 15.4176 13.3075 15.5921 13.1313L16.8431 11.8681C17.4638 11.2414 18.2105 10.928 19.0833 10.928C19.9561 10.928 20.7028 11.2414 21.3234 11.8681L22.5744 13.1313C22.749 13.3075 22.8363 13.5131 22.8363 13.7482C22.8363 13.9832 22.749 14.1888 22.5744 14.3651ZM0.0855676 21.386L4.47861 9.04793C4.57558 8.79334 4.7259 8.5975 4.92955 8.46041C5.1332 8.32332 5.3514 8.25477 5.58414 8.25477C5.7393 8.25477 5.88477 8.28415 6.02054 8.3429C6.1563 8.40165 6.28237 8.48978 6.39875 8.60729L14.2539 16.5389C14.3702 16.6564 14.4575 16.7837 14.5157 16.9208C14.5739 17.0579 14.603 17.2048 14.603 17.3615C14.603 17.5965 14.5351 17.8168 14.3993 18.0224C14.2635 18.2281 14.0696 18.3798 13.8175 18.4778L1.5984 22.9136C1.36566 23.0115 1.14261 23.0262 0.929264 22.9577C0.715916 22.8891 0.53166 22.7765 0.376497 22.6198C0.221335 22.4632 0.109812 22.2771 0.0419281 22.0617C-0.0259555 21.8463 -0.011409 21.621 0.0855676 21.386Z",
            fill: "currentColor",
            key: "svg-45-0"
          },
          []
        ]
      ]
    ]
  ],
  true
);

var IconExternalLink = createReactComponent(
  "externalLink",
  "IconExternalLink",
  [
    [
      "path",
      {
        d: "M5 7C4.73478 7 4.48043 7.10536 4.29289 7.29289C4.10536 7.48043 4 7.73478 4 8V19C4 19.2652 4.10536 19.5196 4.29289 19.7071C4.48043 19.8946 4.73478 20 5 20H16C16.2652 20 16.5196 19.8946 16.7071 19.7071C16.8946 19.5196 17 19.2652 17 19V13C17 12.4477 17.4477 12 18 12C18.5523 12 19 12.4477 19 13V19C19 19.7957 18.6839 20.5587 18.1213 21.1213C17.5587 21.6839 16.7957 22 16 22H5C4.20435 22 3.44129 21.6839 2.87868 21.1213C2.31607 20.5587 2 19.7957 2 19V8C2 7.20435 2.31607 6.44129 2.87868 5.87868C3.44129 5.31607 4.20435 5 5 5H11C11.5523 5 12 5.44772 12 6C12 6.55228 11.5523 7 11 7H5Z",
        fill: "currentColor",
        key: "svg-46-0",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ],
    [
      "path",
      {
        d: "M14 3C14 2.44772 14.4477 2 15 2H21C21.5523 2 22 2.44772 22 3V9C22 9.55228 21.5523 10 21 10C20.4477 10 20 9.55228 20 9V4H15C14.4477 4 14 3.55228 14 3Z",
        fill: "currentColor",
        key: "svg-46-1",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ],
    [
      "path",
      {
        d: "M21.7071 2.29289C22.0976 2.68342 22.0976 3.31658 21.7071 3.70711L10.7071 14.7071C10.3166 15.0976 9.68342 15.0976 9.29289 14.7071C8.90237 14.3166 8.90237 13.6834 9.29289 13.2929L20.2929 2.29289C20.6834 1.90237 21.3166 1.90237 21.7071 2.29289Z",
        fill: "currentColor",
        key: "svg-46-2",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ]
  ],
  true
);

var IconFacebook = createReactComponent(
  "facebook",
  "IconFacebook",
  [
    [
      "path",
      {
        d: "M24 4.00027C24 1.8984 22.1024 0 20 0H4C1.8976 0 0 1.8984 0 4.00027V19.9997C0 22.1016 1.8976 24 4.00027 24H12V14.9333H9.06667V10.9333H12V9.37493C12 6.6872 14.0181 4.26667 16.5 4.26667H19.7333V8.26667H16.5C16.1461 8.26667 15.7333 8.69627 15.7333 9.33973V10.9333H19.7333V14.9333H15.7333V24H20C22.1024 24 24 22.1016 24 19.9997V4.00027Z",
        fill: "currentColor",
        key: "svg-47-0"
      },
      []
    ]
  ],
  true
);

var IconFees = createReactComponent(
  "fees",
  "IconFees",
  [
    [
      "path",
      {
        d: "M11.8438 22.5254C17.749 22.5254 22.5362 17.7382 22.5362 11.833C22.5362 5.92771 17.749 1.14055 11.8438 1.14055C5.93852 1.14055 1.15137 5.92771 1.15137 11.833C1.15137 17.7382 5.93852 22.5254 11.8438 22.5254Z",
        fill: "#C8D3F4",
        key: "svg-48-0"
      },
      []
    ],
    [
      "path",
      {
        d: "M17.9738 7.27086H5.71319C5.31951 7.27086 5.00037 7.59001 5.00037 7.98369V22.9531C5.00037 23.3467 5.31951 23.6659 5.71319 23.6659H17.9738C18.3675 23.6659 18.6867 23.3467 18.6867 22.9531V7.98369C18.6867 7.59001 18.3675 7.27086 17.9738 7.27086Z",
        fill: "white",
        key: "svg-48-1"
      },
      []
    ],
    [
      "path",
      {
        d: "M4.66622 22.9533V7.98346C4.66634 7.40542 5.13492 6.93684 5.71296 6.93671L5.71319 7.27086C5.31951 7.27086 5.00037 7.59001 5.00037 7.98369V22.9531L5.00422 23.026C5.0383 23.3614 5.30482 23.6279 5.64026 23.662L5.71319 23.6659H17.9738C18.3429 23.6658 18.6467 23.3854 18.6832 23.026L18.6867 22.9531V7.98369C18.6865 7.6147 18.406 7.31119 18.0466 7.27472L17.9738 7.27086L17.9739 6.93671C18.552 6.93677 19.0206 7.40538 19.0207 7.98346V22.9533C19.0206 23.5314 18.552 23.9999 17.9739 24H5.71296C5.13491 23.9999 4.66632 23.5313 4.66622 22.9533ZM17.9739 6.93671L17.9738 7.27086H5.71319L5.71296 6.93671H17.9739Z",
        fill: "#C8D3F4",
        key: "svg-48-2"
      },
      []
    ],
    [
      "path",
      {
        d: "M10.4178 9.40935H6.7111C6.47489 9.40935 6.2834 9.60083 6.2834 9.83704C6.2834 10.0733 6.47489 10.2647 6.7111 10.2647H10.4178C10.654 10.2647 10.8455 10.0733 10.8455 9.83704C10.8455 9.60083 10.654 9.40935 10.4178 9.40935Z",
        fill: "#AEBEEF",
        key: "svg-48-3"
      },
      []
    ],
    [
      "path",
      {
        d: "M12.9839 11.2627H6.71101C6.4748 11.2627 6.28331 11.4542 6.28331 11.6904C6.28331 11.9266 6.4748 12.1181 6.71101 12.1181H12.9839C13.2201 12.1181 13.4116 11.9266 13.4116 11.6904C13.4116 11.4542 13.2201 11.2627 12.9839 11.2627Z",
        fill: "#C8D3F4",
        key: "svg-48-4"
      },
      []
    ],
    [
      "path",
      {
        d: "M10.4178 13.2586H6.7111C6.47489 13.2586 6.2834 13.4501 6.2834 13.6863C6.2834 13.9225 6.47489 14.114 6.7111 14.114H10.4178C10.654 14.114 10.8455 13.9225 10.8455 13.6863C10.8455 13.4501 10.654 13.2586 10.4178 13.2586Z",
        fill: "#AEBEEF",
        key: "svg-48-5"
      },
      []
    ],
    [
      "path",
      {
        d: "M12.9839 15.1119H6.71101C6.4748 15.1119 6.28331 15.3034 6.28331 15.5396C6.28331 15.7758 6.4748 15.9673 6.71101 15.9673H12.9839C13.2201 15.9673 13.4116 15.7758 13.4116 15.5396C13.4116 15.3034 13.2201 15.1119 12.9839 15.1119Z",
        fill: "#C8D3F4",
        key: "svg-48-6"
      },
      []
    ],
    [
      "path",
      {
        d: "M10.4178 17.1079H6.7111C6.47489 17.1079 6.2834 17.2994 6.2834 17.5356C6.2834 17.7718 6.47489 17.9633 6.7111 17.9633H10.4178C10.654 17.9633 10.8455 17.7718 10.8455 17.5356C10.8455 17.2994 10.654 17.1079 10.4178 17.1079Z",
        fill: "#AEBEEF",
        key: "svg-48-7"
      },
      []
    ],
    [
      "path",
      {
        d: "M12.9839 18.9613H6.71101C6.4748 18.9613 6.28331 19.1528 6.28331 19.389C6.28331 19.6252 6.4748 19.8167 6.71101 19.8167H12.9839C13.2201 19.8167 13.4116 19.6252 13.4116 19.389C13.4116 19.1528 13.2201 18.9613 12.9839 18.9613Z",
        fill: "#C8D3F4",
        key: "svg-48-8"
      },
      []
    ],
    [
      "path",
      {
        d: "M17.9738 3.05176e-05H5.71317C5.31949 3.05176e-05 5.00034 0.319174 5.00034 0.712858V4.98982C5.00034 5.3835 5.31949 5.70265 5.71317 5.70265H17.9738C18.3675 5.70265 18.6866 5.3835 18.6866 4.98982V0.712858C18.6866 0.319174 18.3675 3.05176e-05 17.9738 3.05176e-05Z",
        fill: "#234DD4",
        key: "svg-48-9"
      },
      []
    ],
    [
      "path",
      {
        d: "M10.4178 1.56828H6.7111C6.47489 1.56828 6.2834 1.75976 6.2834 1.99597C6.2834 2.23218 6.47489 2.42367 6.7111 2.42367H10.4178C10.654 2.42367 10.8455 2.23218 10.8455 1.99597C10.8455 1.75976 10.654 1.56828 10.4178 1.56828Z",
        fill: "#AEBEEF",
        key: "svg-48-10"
      },
      []
    ],
    [
      "path",
      {
        d: "M12.9839 3.42165H6.71101C6.4748 3.42165 6.28331 3.61313 6.28331 3.84934C6.28331 4.08555 6.4748 4.27704 6.71101 4.27704H12.9839C13.2201 4.27704 13.4116 4.08555 13.4116 3.84934C13.4116 3.61313 13.2201 3.42165 12.9839 3.42165Z",
        fill: "white",
        key: "svg-48-11"
      },
      []
    ]
  ],
  true
);

var IconFile = createReactComponent(
  "file",
  "IconFile",
  [
    [
      "g",
      { opacity: "0.3", key: "svg-49-0" },
      [
        [
          "path",
          {
            opacity: "0.3",
            d: "M13.9664 4.9248C13.4197 4.92427 12.8956 4.70685 12.509 4.32028C12.1224 3.93371 11.905 3.40956 11.9045 2.86287V1.85846e-07H2.69189C2.33844 -0.000131162 1.98841 0.0693617 1.66182 0.204533C1.33523 0.339704 1.03848 0.5379 0.788505 0.787785C0.538527 1.03767 0.340228 1.33435 0.204935 1.66089C0.069643 1.98743 -2.4405e-08 2.33742 0 2.69088V18.9122C-2.4405e-08 19.2657 0.069643 19.6157 0.204935 19.9422C0.340228 20.2688 0.538527 20.5654 0.788505 20.8153C1.03848 21.0652 1.33523 21.2634 1.66182 21.3986C1.98841 21.5337 2.33844 21.6032 2.69189 21.6031H13.7514C14.1048 21.6031 14.4547 21.5335 14.7812 21.3983C15.1077 21.2631 15.4043 21.0648 15.6542 20.815C15.9041 20.5651 16.1023 20.2684 16.2375 19.942C16.3727 19.6155 16.4423 19.2656 16.4423 18.9122V4.9248H13.9664Z",
            fill: "currentColor",
            key: "svg-49-0"
          },
          []
        ]
      ]
    ],
    [
      "path",
      {
        d: "M16.4421 4.92478H13.9662C13.4195 4.92425 12.8954 4.70683 12.5088 4.32026C12.1222 3.93369 11.9048 3.40955 11.9043 2.86285V-1.52588e-05L16.4421 4.92478Z",
        fill: "currentColor",
        key: "svg-49-1"
      },
      []
    ],
    [
      "path",
      {
        d: "M13.0599 8.37263H2.73629C2.6371 8.37263 2.54198 8.33323 2.47185 8.26309C2.40171 8.19296 2.36231 8.09784 2.36231 7.99865C2.36217 7.94945 2.37176 7.90071 2.39049 7.85522C2.40923 7.80973 2.43675 7.76838 2.47149 7.73355C2.50623 7.69871 2.54751 7.67109 2.59295 7.65223C2.63839 7.63337 2.68709 7.62366 2.73629 7.62366H13.0599C13.1593 7.62366 13.2547 7.66318 13.325 7.7335C13.3953 7.80382 13.4349 7.8992 13.4349 7.99865C13.4346 8.09793 13.395 8.19306 13.3247 8.26316C13.2544 8.33327 13.1592 8.37263 13.0599 8.37263Z",
        fill: "currentColor",
        key: "svg-49-2"
      },
      []
    ],
    [
      "path",
      {
        d: "M13.0599 10.6096H2.73629C2.6371 10.6096 2.54198 10.5702 2.47185 10.5C2.40171 10.4299 2.36231 10.3348 2.36231 10.2356C2.36217 10.1864 2.37176 10.1376 2.39049 10.0921C2.40923 10.0467 2.43675 10.0053 2.47149 9.97047C2.50623 9.93564 2.54751 9.90801 2.59295 9.88915C2.63839 9.87029 2.68709 9.86059 2.73629 9.86059H13.0599C13.1593 9.86059 13.2547 9.90007 13.325 9.9704C13.3953 10.0407 13.4349 10.1361 13.4349 10.2356C13.4346 10.3349 13.395 10.43 13.3247 10.5001C13.2544 10.5702 13.1592 10.6096 13.0599 10.6096Z",
        fill: "currentColor",
        key: "svg-49-3"
      },
      []
    ],
    [
      "path",
      {
        d: "M13.0599 12.8464H2.73629C2.68709 12.8464 2.63839 12.8367 2.59295 12.8179C2.54751 12.799 2.50623 12.7714 2.47149 12.7366C2.43675 12.7017 2.40923 12.6604 2.39049 12.6149C2.37176 12.5694 2.36217 12.5207 2.36231 12.4715C2.36231 12.3723 2.40171 12.2772 2.47185 12.207C2.54198 12.1369 2.6371 12.0975 2.73629 12.0975H13.0599C13.1592 12.0975 13.2544 12.1368 13.3247 12.2069C13.395 12.2771 13.4346 12.3722 13.4349 12.4715C13.4349 12.5709 13.3953 12.6663 13.325 12.7366C13.2547 12.8069 13.1593 12.8464 13.0599 12.8464Z",
        fill: "currentColor",
        key: "svg-49-4"
      },
      []
    ],
    [
      "path",
      {
        d: "M8.98803 15.0834H2.73629C2.68709 15.0834 2.63839 15.0737 2.59295 15.0548C2.54751 15.0359 2.50623 15.0083 2.47149 14.9735C2.43675 14.9386 2.40923 14.8973 2.39049 14.8518C2.37176 14.8063 2.36217 14.7576 2.36231 14.7084C2.36231 14.6092 2.40171 14.514 2.47185 14.4439C2.54198 14.3738 2.6371 14.3344 2.73629 14.3344H8.98803C9.08722 14.3344 9.18235 14.3738 9.25249 14.4439C9.32262 14.514 9.36202 14.6092 9.36202 14.7084C9.36215 14.7576 9.35258 14.8063 9.33384 14.8518C9.31511 14.8973 9.28758 14.9386 9.25284 14.9735C9.2181 15.0083 9.17682 15.0359 9.13139 15.0548C9.08595 15.0737 9.03723 15.0834 8.98803 15.0834Z",
        fill: "currentColor",
        key: "svg-49-5"
      },
      []
    ]
  ],
  true
);

var IconFilter = createReactComponent(
  "filter",
  "IconFilter",
  [
    [
      "path",
      {
        d: "M1.20339 1C0.734884 1 0.308971 1.27191 0.111788 1.6969C-0.0853946 2.12189 -0.0179954 2.62268 0.284529 2.98042L8.6373 12.8576V19.478C8.6373 19.9338 8.89483 20.3504 9.30251 20.5543L13.6212 22.7136C13.9942 22.9001 14.4372 22.8802 14.792 22.6609C15.1467 22.4417 15.3627 22.0543 15.3627 21.6373V12.8576L23.7155 2.98042C24.018 2.62268 24.0854 2.12189 23.8882 1.6969C23.691 1.27191 23.2651 1 22.7966 1H1.20339ZM10.7595 11.6399L3.79702 3.40674H20.203L13.2405 11.6399C13.0568 11.8572 12.9559 12.1325 12.9559 12.417V19.6902L11.044 18.7342V12.417C11.044 12.1325 10.9432 11.8572 10.7595 11.6399Z",
        fill: "currentColor",
        key: "svg-50-0",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ]
  ],
  true
);

var IconFolderTree = createReactComponent(
  "folderTree",
  "IconFolderTree",
  [
    [
      "path",
      {
        fill: "currentColor",
        stroke: "none",
        d: "M20 10a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-2.5a1 1 0 0 1-.8-.4l-.9-1.2A1 1 0 0 0 15 3h-2a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1Z",
        key: "svg-51-0"
      },
      []
    ],
    [
      "path",
      {
        fill: "currentColor",
        stroke: "none",
        d: "M20 21a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-2.9a1 1 0 0 1-.88-.55l-.42-.85a1 1 0 0 0-.92-.6H13a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1Z",
        key: "svg-51-1"
      },
      []
    ],
    [
      "path",
      {
        stroke: "currentColor",
        fill: "none",
        d: "M3 5a2 2 0 0 0 2 2h3",
        key: "svg-51-2",
        strokeWidth: "2"
      },
      []
    ],
    [
      "path",
      {
        stroke: "currentColor",
        fill: "none",
        d: "M3 3v13a2 2 0 0 0 2 2h3",
        key: "svg-51-3",
        strokeWidth: "2"
      },
      []
    ]
  ],
  true
);

var IconFood = createReactComponent(
  "food",
  "IconFood",
  [
    [
      "g",
      { id: "food", key: "svg-52-0" },
      [
        [
          "path",
          {
            id: "Vector",
            d: "M14.6435 1L14.745 1.00488C15.2494 1.05596 15.6435 1.48213 15.6435 2C15.6435 2.51787 15.2494 2.94404 14.745 2.99512L14.6435 3H11.9101C11.6522 3.00005 11.4188 3.14139 11.2968 3.3623L11.2509 3.46094L10.6757 5.04102H15.5068C15.789 5.04102 16.0584 5.16002 16.248 5.36914C16.4137 5.55204 16.505 5.78883 16.5068 6.0332L16.5019 6.13867L16.0986 10.2451L16.0829 10.3467C15.9825 10.8433 15.52 11.1932 15.0048 11.1426C14.4553 11.0884 14.0533 10.5984 14.1074 10.0488L14.4033 7.04102H4.10345L5.31536 19.3672L5.34075 19.498C5.42725 19.7908 5.69811 20 6.0136 20H8.01067L8.11321 20.0049C8.6174 20.0562 9.01067 20.4823 9.01067 21C9.01067 21.5177 8.6174 21.9438 8.11321 21.9951L8.01067 22H6.0136C4.71095 22 3.60714 21.0736 3.36224 19.8184L3.32513 19.5635L2.00481 6.13867C1.97719 5.85788 2.06929 5.57824 2.25872 5.36914C2.44828 5.16002 2.71768 5.04102 2.99993 5.04102H8.54681L9.372 2.77637L9.45208 2.58105C9.88779 1.62406 10.8457 1.00005 11.9101 1H14.6435ZM19.3867 15.2568C19.3864 14.8698 19.0725 14.5559 18.6855 14.5557H13.1161C12.729 14.5557 12.4152 14.8697 12.415 15.2568V16.2754H19.3867V15.2568ZM12.415 19.9961H19.3867V18.2754H16.6503L15.8085 19.1162C15.4182 19.5066 14.7851 19.5073 14.3945 19.1172L13.5517 18.2754H12.415V19.9961ZM21.3867 16.3047C21.8233 16.412 22.1474 16.8056 22.1474 17.2754C22.1474 17.745 21.8232 18.1377 21.3867 18.2451V20.9961C21.3867 21.5483 20.9388 21.9959 20.3867 21.9961H11.415C10.8627 21.9961 10.415 21.5484 10.415 20.9961V18.2441C9.97933 18.1361 9.65619 17.7444 9.65618 17.2754C9.65618 16.8063 9.97921 16.4136 10.415 16.3057V15.2568C10.4152 13.765 11.6245 12.5557 13.1161 12.5557H18.6855C20.177 12.5559 21.3864 13.7652 21.3867 15.2568V16.3047Z",
            fill: "currentColor",
            key: "svg-52-0"
          },
          []
        ]
      ]
    ]
  ],
  true
);

var IconGift = createReactComponent(
  "gift",
  "IconGift",
  [
    [
      "g",
      { key: "svg-53-0", clipPath: "url(#clip0_195_2408)" },
      [
        [
          "path",
          {
            d: "M3.27353 10.9089C3.87602 10.9089 4.36444 11.3973 4.36444 11.9998V21.818H19.6372V11.9998C19.6372 11.3973 20.1256 10.9089 20.7281 10.9089C21.3306 10.9089 21.819 11.3973 21.819 11.9998V22.9089C21.819 23.5114 21.3306 23.9998 20.7281 23.9998H3.27353C2.67103 23.9998 2.18262 23.5114 2.18262 22.9089V11.9998C2.18262 11.3973 2.67103 10.9089 3.27353 10.9089Z",
            fill: "currentColor",
            key: "svg-53-0",
            fillRule: "evenodd",
            clipRule: "evenodd"
          },
          []
        ],
        [
          "path",
          {
            d: "M0 6.54599C0 5.94349 0.488417 5.45508 1.09091 5.45508H22.9091C23.5116 5.45508 24 5.94349 24 6.54599V12.0005C24 12.603 23.5116 13.0914 22.9091 13.0914H1.09091C0.488417 13.0914 0 12.603 0 12.0005V6.54599ZM2.18182 7.6369V10.9096H21.8182V7.6369H2.18182Z",
            fill: "currentColor",
            key: "svg-53-1",
            fillRule: "evenodd",
            clipRule: "evenodd"
          },
          []
        ],
        [
          "path",
          {
            d: "M11.9996 5.45435C12.6021 5.45435 13.0905 5.94276 13.0905 6.54525V22.9089C13.0905 23.5114 12.6021 23.9998 11.9996 23.9998C11.3971 23.9998 10.9087 23.5114 10.9087 22.9089V6.54525C10.9087 5.94276 11.3971 5.45435 11.9996 5.45435Z",
            fill: "currentColor",
            key: "svg-53-2",
            fillRule: "evenodd",
            clipRule: "evenodd"
          },
          []
        ],
        [
          "path",
          {
            d: "M7.09064 2.18182C6.65665 2.18182 6.24044 2.35422 5.93356 2.6611C5.62668 2.96798 5.45428 3.38419 5.45428 3.81818C5.45428 4.25217 5.62668 4.66839 5.93356 4.97527C6.24044 5.28214 6.65665 5.45455 7.09064 5.45455H10.5314C10.3982 5.10612 10.2296 4.723 10.0211 4.34391C9.33499 3.09638 8.39308 2.18182 7.09064 2.18182ZM11.9997 6.54545C13.0695 6.33151 13.0693 6.33074 13.0693 6.33074L13.0687 6.32768L13.0675 6.32185L13.0638 6.30429C13.0608 6.29 13.0566 6.2706 13.0512 6.24642C13.0404 6.19808 13.0247 6.13053 13.0037 6.0465C12.9618 5.87865 12.8983 5.64374 12.8096 5.36385C12.6336 4.80798 12.3524 4.05529 11.9329 3.29245C11.119 1.81272 9.60639 0 7.09064 0C6.078 0 5.10683 0.402271 4.39078 1.11832C3.67473 1.83437 3.27246 2.80554 3.27246 3.81818C3.27246 4.83083 3.67473 5.802 4.39078 6.51804C5.10683 7.23409 6.078 7.63636 7.09064 7.63636H11.9997C12.3266 7.63636 12.6362 7.48983 12.8434 7.23708C13.0506 6.98433 13.1334 6.65123 13.0693 6.33074L11.9997 6.54545Z",
            fill: "currentColor",
            key: "svg-53-3",
            fillRule: "evenodd",
            clipRule: "evenodd"
          },
          []
        ],
        [
          "path",
          {
            d: "M12.0665 3.29245C12.8803 1.81272 14.393 0 16.9087 0C17.9213 0 18.8925 0.402271 19.6086 1.11832C20.3246 1.83437 20.7269 2.80554 20.7269 3.81818C20.7269 4.83083 20.3246 5.802 19.6086 6.51804C18.8925 7.23409 17.9213 7.63636 16.9087 7.63636H11.9997C11.6729 7.63636 11.3632 7.48983 11.156 7.23708C10.9488 6.98433 10.8658 6.65199 10.9299 6.33151L11.9997 6.54545C10.93 6.33151 10.9299 6.33151 10.9299 6.33151L10.9302 6.32985L10.9307 6.32768L10.9318 6.32185L10.9355 6.30429C10.9385 6.29 10.9427 6.2706 10.9481 6.24642C10.9589 6.19808 10.9746 6.13053 10.9956 6.0465C11.0376 5.87865 11.1011 5.64374 11.1897 5.36385C11.3657 4.80798 11.6469 4.05529 12.0665 3.29245ZM13.468 5.45455H16.9087C17.3427 5.45455 17.7589 5.28214 18.0658 4.97527C18.3727 4.66839 18.5451 4.25217 18.5451 3.81818C18.5451 3.38419 18.3727 2.96798 18.0658 2.6611C17.7589 2.35422 17.3427 2.18182 16.9087 2.18182C15.6063 2.18182 14.6644 3.09638 13.9782 4.34391C13.7697 4.723 13.6011 5.10612 13.468 5.45455Z",
            fill: "currentColor",
            key: "svg-53-4",
            fillRule: "evenodd",
            clipRule: "evenodd"
          },
          []
        ]
      ]
    ],
    [
      "defs",
      { key: "svg-53-1" },
      [
        [
          "clipPath",
          { id: "clip0_195_2408", key: "svg-53-0" },
          [
            [
              "rect",
              {
                width: "24",
                height: "24",
                fill: "transparent",
                key: "svg-53-0"
              },
              []
            ]
          ]
        ]
      ]
    ]
  ],
  true
);

var IconGivebacks = createReactComponent(
  "givebacks",
  "IconGivebacks",
  [
    [
      "path",
      {
        d: "M9.00678 2.94858C8.8877 2.21245 8.86605 1.80108 8.86605 1.44384C8.86605 1.34641 8.94183 1.27063 9.03926 1.28146H11.1286C11.226 1.28146 11.3018 1.35724 11.3018 1.45467V9.79027C11.3018 13.6225 8.69284 14.7375 5.75914 14.7375C3.73478 14.7375 1.54804 14.2395 0.541273 12.2043C0.497971 12.1177 0.541275 11.9987 0.638705 11.9662L2.57646 11.295C2.65224 11.2734 2.73884 11.295 2.78214 11.3708C3.33424 12.3234 4.25441 12.724 5.71584 12.724C7.49122 12.724 8.68202 11.8688 8.82275 10.3965V8.75102H8.77945C7.96754 10.3207 6.61435 10.6888 5.20705 10.6888C1.89446 10.6888 0 8.44791 0 5.87145C0 3.01353 2.24087 1 5.14209 1C6.80921 1 8.10827 1.70365 8.67119 3.04601C8.70367 3.11096 8.75779 3.15426 8.83357 3.15426C8.94183 3.15426 9.02843 3.05684 9.00678 2.94858ZM1.8295 5.8065C1.8295 7.24629 3.30176 8.40461 5.3153 8.40461C7.37214 8.40461 8.8877 7.23546 8.87687 5.8065C8.87687 4.35589 7.33966 3.24087 5.3153 3.24087C3.29094 3.24087 1.8295 4.37754 1.8295 5.8065Z",
        fill: "currentColor",
        key: "svg-54-0",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ],
    [
      "path",
      {
        d: "M15.1664 21.3627H14.8308C15.139 22.0288 15.1368 22.4027 15.1344 22.8115C15.1342 22.8478 15.134 22.8845 15.134 22.9216H12.6874V10.2558L15.1664 9.3573C15.1664 9.63734 15.1694 9.92912 15.1726 10.233C15.1873 11.6561 15.2048 13.3457 14.9283 15.3438H15.2639C16.1407 13.6767 17.5156 13.1895 18.9986 13.1895C22.0514 13.1895 24 15.4304 24 18.18C24 21.3303 21.5534 23.2139 18.8254 23.2139C17.1367 23.2139 15.8593 22.5102 15.1664 21.3627ZM18.544 20.9405C20.525 20.9405 21.9323 19.8039 21.9323 18.2125C21.9323 16.632 20.525 15.4629 18.544 15.4629C16.5846 15.4629 15.1231 16.6212 15.1231 18.2125C15.1231 19.8147 16.617 20.9405 18.544 20.9405Z",
        fill: "currentColor",
        key: "svg-54-1",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ],
    [
      "path",
      {
        d: "M8.23815 23.203H7.46954V21.1137L7.25304 20.8972L6.12719 22.023L5.58592 21.4817L6.71176 20.3559L6.49525 20.1394H4.40594V19.3708H6.48443L6.71176 19.1434L5.59674 18.0284L6.13802 17.4871L7.25304 18.6022L7.48037 18.3748V16.2963H8.24898V18.3856L8.46549 18.6022L9.59134 17.4763L10.1326 18.0176L9.00676 19.1434L9.22327 19.3599H11.3126V20.1286H9.21244L8.99593 20.3451L10.1218 21.4709L9.58051 22.0122L8.45466 20.8863L8.23815 21.1028V23.203ZM7.24221 20.1718L7.83761 20.7781L8.86603 19.7497L7.82679 18.7104L6.79837 19.7388L7.24221 20.1718Z",
        fill: "currentColor",
        key: "svg-54-2",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ]
  ],
  true
);

var IconGoal = createReactComponent(
  "goal",
  "IconGoal",
  [
    [
      "g",
      { key: "svg-55-0", clipPath: "url(#clip0_1631_8068)" },
      [
        [
          "path",
          {
            d: "M5.31894 18.0303L7.5671 17.0213C7.7104 16.957 7.85473 16.8959 8 16.8381V5H17L14.7143 8L17 11H10V16.2537C12.1987 15.8322 14.4956 16.0881 16.575 17.0213L18.7219 17.9848C17.0735 19.8349 14.6728 21 12 21C9.34916 21 6.96599 19.854 5.31894 18.0303Z",
            fill: "currentColor",
            key: "svg-55-0"
          },
          []
        ],
        [
          "path",
          {
            d: "M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
            fill: "currentColor",
            key: "svg-55-1",
            fillRule: "evenodd",
            clipRule: "evenodd"
          },
          []
        ]
      ]
    ],
    [
      "defs",
      { key: "svg-55-1" },
      [
        [
          "clipPath",
          { id: "clip0_1631_8068", key: "svg-55-0" },
          [
            [
              "rect",
              {
                width: "24",
                height: "24",
                fill: "transparent",
                key: "svg-55-0"
              },
              []
            ]
          ]
        ]
      ]
    ]
  ],
  true
);

var IconGraduation = createReactComponent(
  "graduation",
  "IconGraduation",
  [
    [
      "path",
      {
        d: "M12.3919 13.5148C12.1419 13.6208 11.8581 13.6208 11.6081 13.5148L5.69555 11.0062V16.8905C5.74785 16.9545 5.81186 17.0316 5.88936 17.1175C6.14879 17.4049 6.5457 17.795 7.08304 18.186C8.15272 18.9643 9.77453 19.7461 11.9995 19.7462C14.2244 19.7462 15.8463 18.9642 16.916 18.186C17.4533 17.795 17.8512 17.4049 18.1106 17.1175C18.1881 17.0316 18.2521 16.9545 18.3044 16.8905V11.0062L12.3919 13.5148ZM3.47403 7.9557L11.9995 11.5707L20.524 7.9557L11.9995 4.33978L3.47403 7.9557ZM24 15.8022C24 16.3369 23.5579 16.7703 23.0127 16.7704C22.4674 16.7704 22.0253 16.3369 22.0253 15.8022V9.42892L20.2791 10.1693V17.212C20.2791 17.4002 20.2231 17.5841 20.1181 17.7416L20.1172 17.7434L20.1162 17.7453C20.1152 17.7468 20.1136 17.7482 20.1123 17.7501L20.0738 17.8068C20.0492 17.8412 20.0145 17.8877 19.9706 17.9449C19.8828 18.0592 19.7557 18.2157 19.5888 18.4006C19.2555 18.7699 18.7592 19.2559 18.0933 19.7405C16.7562 20.7135 14.7312 21.6827 11.9995 21.6827C9.2681 21.6827 7.24375 20.7134 5.90671 19.7405C5.24074 19.2559 4.74455 18.7699 4.41123 18.4006C4.24437 18.2158 4.11718 18.0592 4.02941 17.9449C3.98555 17.8877 3.95079 17.8412 3.92624 17.8068C3.91396 17.7896 3.90384 17.7751 3.89635 17.7642C3.89266 17.7589 3.8902 17.7538 3.88767 17.7501C3.88642 17.7482 3.88478 17.7468 3.88381 17.7453L3.88285 17.7434L3.88188 17.7425C3.88175 17.742 3.89246 17.7351 4.70821 17.212L3.88188 17.7425C3.7769 17.585 3.72091 17.4002 3.72086 17.212V10.1693L0.595878 8.84455C0.234431 8.69127 4.10374e-06 8.34189 0 7.9557C-8.07223e-08 7.56951 0.234428 7.22013 0.595878 7.06685L11.6081 2.39661L11.7035 2.36162C11.9287 2.29214 12.1732 2.30386 12.3919 2.39661L23.4041 7.06685L23.5333 7.13304C23.8205 7.30781 24 7.61762 24 7.9557V15.8022Z",
        fill: "currentColor",
        key: "svg-56-0"
      },
      []
    ]
  ],
  true
);

var IconHambMenu = createReactComponent(
  "hambMenu",
  "IconHambMenu",
  [
    [
      "path",
      {
        d: "M1 2H13.8925V4.44444H1V2ZM23 10.2796V12.724H1V10.2796H23ZM18.5054 18.5591H1V21.0036H18.5054V18.5591Z",
        fill: "currentColor",
        key: "svg-57-0",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ]
  ],
  true
);

var IconHeart = createReactComponent(
  "heart",
  "IconHeart",
  [
    [
      "path",
      {
        d: "M20.2474 4.2829L20.2459 4.2816C18.9621 3.16949 17.6461 3.05087 16.4841 3.32212C15.2595 3.608 14.2386 4.32925 13.7862 4.80231L11.998 6.67097L10.2081 4.80044C8.49517 3.00414 5.67328 2.60818 3.7527 4.27943L3.75 4.28179C1.54385 6.1946 1.41972 9.66099 3.3989 11.7342L11.927 20.6695L11.928 20.6706C11.9472 20.6908 11.9612 20.698 11.9686 20.7012C11.9774 20.7049 11.9873 20.7071 11.9982 20.707C12.0093 20.707 12.0213 20.7048 12.0335 20.6997C12.0444 20.6951 12.0609 20.6859 12.0814 20.6647C12.0817 20.6645 12.082 20.6642 12.0822 20.6639L20.6023 11.737C20.6021 11.7372 20.6025 11.7368 20.6023 11.737C20.6025 11.7368 20.6033 11.7359 20.6035 11.7357C22.5798 9.65135 22.4567 6.19297 20.2474 4.2829ZM22.0532 13.1136L22.0517 13.1151L13.5254 22.0486C12.6856 22.9239 11.3137 22.9299 10.4764 22.0464L10.475 22.0448L1.95226 13.1152C-0.804427 10.2276 -0.64148 5.44227 2.43982 2.77068C5.04828 0.500839 8.59431 0.897617 10.9476 2.77303C11.198 2.9725 11.4348 3.1887 11.6555 3.4202L11.998 3.77814L12.3409 3.41986C12.5011 3.25234 12.6974 3.07286 12.9249 2.89121C13.6756 2.292 14.7668 1.66923 16.0295 1.37448C17.7114 0.981855 19.7119 1.17294 21.5554 2.76995C24.647 5.44281 24.7987 10.2198 22.0532 13.1136Z",
        fill: "currentColor",
        key: "svg-58-0",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ]
  ],
  true
);

var IconHeartCircle = createReactComponent(
  "heartCircle",
  "IconHeartCircle",
  [
    [
      "g",
      { key: "svg-59-0", clipPath: "url(#clip0_191_3298)" },
      [
        [
          "path",
          {
            d: "M12 0C5.37103 0 0 5.37103 0 12C0 18.629 5.37103 24 12 24C18.629 24 24 18.629 24 12C24 5.37103 18.629 0 12 0ZM2.35989 12C2.35989 6.68494 6.68494 2.35989 12 2.35989C17.3151 2.35989 21.6401 6.68494 21.6401 12C21.6401 17.3151 17.3151 21.6401 12 21.6401C6.68494 21.6401 2.35989 17.3151 2.35989 12ZM17.694 6.89636C16.5957 5.94492 15.4038 5.83108 14.4018 6.06499C13.4215 6.29382 12.6146 6.85451 12.2042 7.28356L12 7.49701L11.7959 7.28376C10.4279 5.84915 8.02487 5.40067 6.30554 6.8968C4.46981 8.48844 4.37273 11.3394 6.01508 13.0597L11.0926 18.3797L11.0935 18.3806C11.5923 18.907 12.4096 18.9034 12.9099 18.3819L12.9107 18.3811L17.9896 13.0597L17.9905 13.0587C19.6262 11.3348 19.5358 8.48876 17.694 6.89636ZM7.82596 8.68955C8.22606 8.34172 8.6658 8.28027 9.07874 8.36405C9.50787 8.45113 9.89344 8.69528 10.1146 8.92756L12 10.9025L13.8854 8.92756L13.8868 8.92607C14.0392 8.76498 14.4065 8.49884 14.8485 8.38531C15.2697 8.27712 15.7357 8.31049 16.1755 8.69086C17.0648 9.45685 16.9421 10.752 16.3025 11.4263L12 15.9374L7.69661 11.4254C7.05843 10.7566 6.93461 9.45732 7.82446 8.69086L7.82596 8.68955Z",
            fill: "currentColor",
            key: "svg-59-0",
            fillRule: "evenodd",
            clipRule: "evenodd"
          },
          []
        ]
      ]
    ],
    [
      "defs",
      { key: "svg-59-1" },
      [
        [
          "clipPath",
          { id: "clip0_191_3298", key: "svg-59-0" },
          [
            [
              "rect",
              {
                width: "24",
                height: "24",
                fill: "transparent",
                key: "svg-59-0"
              },
              []
            ]
          ]
        ]
      ]
    ]
  ],
  true
);

var IconHome = createReactComponent(
  "home",
  "IconHome",
  [
    [
      "path",
      {
        d: "M11.3861 1.21065C11.7472 0.929784 12.2528 0.929784 12.6139 1.21065L21.6139 8.21065C21.8575 8.4001 22 8.69141 22 9V20C22 20.7957 21.6839 21.5587 21.1213 22.1213C20.5587 22.6839 19.7957 23 19 23H5C4.20435 23 3.44129 22.6839 2.87868 22.1213C2.31607 21.5587 2 20.7957 2 20V9C2 8.69141 2.14247 8.4001 2.38606 8.21065L11.3861 1.21065ZM4 9.48908V20C4 20.2652 4.10536 20.5196 4.29289 20.7071C4.48043 20.8946 4.73478 21 5 21H19C19.2652 21 19.5196 20.8946 19.7071 20.7071C19.8946 20.5196 20 20.2652 20 20V9.48908L12 3.26686L4 9.48908Z",
        fill: "currentColor",
        key: "svg-60-0",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ],
    [
      "path",
      {
        d: "M8 12C8 11.4477 8.44772 11 9 11H15C15.5523 11 16 11.4477 16 12V22C16 22.5523 15.5523 23 15 23C14.4477 23 14 22.5523 14 22V13H10V22C10 22.5523 9.55228 23 9 23C8.44772 23 8 22.5523 8 22V12Z",
        fill: "currentColor",
        key: "svg-60-1",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ],
    [
      "path",
      {
        d: "M11.2326 1.01331C11.684 0.66223 12.316 0.66223 12.7674 1.01331L21.7674 8.01331C22.0719 8.25013 22.25 8.61426 22.25 9V20C22.25 20.862 21.9076 21.6886 21.2981 22.2981C20.6886 22.9076 19.862 23.25 19 23.25H5C4.13805 23.25 3.3114 22.9076 2.7019 22.2981C2.09241 21.6886 1.75 20.862 1.75 20V9C1.75 8.61426 1.92809 8.25013 2.23257 8.01331L11.2326 1.01331ZM10.0001 22.75H13.9999C13.843 22.5411 13.75 22.2814 13.75 22V21.25H10.25V22C10.25 22.2814 10.157 22.5411 10.0001 22.75ZM9.75 21.25V22C9.75 22.4142 9.41421 22.75 9 22.75C8.58579 22.75 8.25 22.4142 8.25 22V21.25H9.75ZM10.25 20.75H13.75V13.25H10.25V20.75ZM14.25 20.75V13C14.25 12.8619 14.1381 12.75 14 12.75H10C9.86193 12.75 9.75 12.8619 9.75 13V20.75H8.25V12C8.25 11.5858 8.58579 11.25 9 11.25H15C15.4142 11.25 15.75 11.5858 15.75 12V20.75H14.25ZM14.25 21.25V22C14.25 22.4142 14.5858 22.75 15 22.75C15.4142 22.75 15.75 22.4142 15.75 22V21.25H14.25ZM16.25 21.25V22C16.25 22.2814 16.157 22.5411 16.0001 22.75H19C19.7293 22.75 20.4288 22.4603 20.9445 21.9445C21.4603 21.4288 21.75 20.7293 21.75 20V9C21.75 8.76856 21.6431 8.55008 21.4605 8.40799L12.4605 1.40799C12.1896 1.19734 11.8104 1.19734 11.5395 1.40799L2.53954 8.40799C2.35685 8.55008 2.25 8.76856 2.25 9V20C2.25 20.7293 2.53973 21.4288 3.05546 21.9445C3.57118 22.4603 4.27065 22.75 5 22.75H7.99991C7.84299 22.5411 7.75 22.2814 7.75 22V21.25H5C4.66848 21.25 4.35054 21.1183 4.11612 20.8839C3.8817 20.6495 3.75 20.3315 3.75 20V9.48908C3.75 9.41194 3.78562 9.33911 3.84651 9.29175L11.8465 3.06952C11.9368 2.99931 12.0632 2.99931 12.1535 3.06952L20.1535 9.29175C20.2144 9.33911 20.25 9.41194 20.25 9.48908V20C20.25 20.3315 20.1183 20.6495 19.8839 20.8839C19.6495 21.1183 19.3315 21.25 19 21.25H16.25ZM7.75 20.75V12C7.75 11.3096 8.30964 10.75 9 10.75H15C15.6904 10.75 16.25 11.3096 16.25 12V20.75H19C19.1989 20.75 19.3897 20.671 19.5303 20.5303C19.671 20.3897 19.75 20.1989 19.75 20V9.61135L12 3.58358L4.25 9.61135V20C4.25 20.1989 4.32902 20.3897 4.46967 20.5303C4.61032 20.671 4.80109 20.75 5 20.75H7.75Z",
        fill: "currentColor",
        key: "svg-60-2",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ]
  ],
  true
);

var IconImage = createReactComponent(
  "image",
  "IconImage",
  [
    [
      "g",
      { key: "svg-61-0", clipPath: "url(#clip0_10572_7464)" },
      [
        [
          "path",
          {
            d: "M5.19434 8.11112C5.19434 6.50029 6.50017 5.19446 8.111 5.19446C9.72183 5.19446 11.0277 6.50029 11.0277 8.11112C11.0277 9.72196 9.72183 11.0278 8.111 11.0278C6.50017 11.0278 5.19434 9.72196 5.19434 8.11112ZM8.111 7.69446C7.88088 7.69446 7.69434 7.88101 7.69434 8.11112C7.69434 8.34124 7.88088 8.52779 8.111 8.52779C8.34112 8.52779 8.52767 8.34124 8.52767 8.11112C8.52767 7.88101 8.34112 7.69446 8.111 7.69446Z",
            fill: "currentColor",
            key: "svg-61-0",
            fillRule: "evenodd",
            clipRule: "evenodd"
          },
          []
        ],
        [
          "path",
          {
            d: "M23.25 15.9919V4.22222C23.25 2.30457 21.6954 0.75 19.7778 0.75H4.22222C2.30457 0.75 0.75 2.30457 0.75 4.22222V19.7778C0.75 21.6918 2.29869 23.2441 4.21133 23.25C4.21776 23.25 4.22419 23.25 4.23062 23.25H19.7778C21.6954 23.25 23.25 21.6954 23.25 19.7778V16.0081C23.25 16.0027 23.25 15.9973 23.25 15.9919ZM4.22222 3.25C3.68528 3.25 3.25 3.68528 3.25 4.22222V19.7778C3.25 20.1425 3.45081 20.4603 3.74789 20.6266L10.0463 13.192C10.4567 12.7076 11.1651 12.6077 11.6934 12.9599L13.6026 14.2328L15.9282 10.3569C16.1262 10.0268 16.4653 9.80641 16.8473 9.75938C17.2293 9.71235 17.6117 9.84395 17.8839 10.1161L20.75 12.9822V4.22222C20.75 3.68528 20.3147 3.25 19.7778 3.25H4.22222ZM20.75 16.5178L17.2482 13.016L15.0719 16.6431C14.896 16.9363 14.6078 17.1446 14.2743 17.2196C13.9408 17.2946 13.5911 17.2297 13.3067 17.0401L11.2336 15.6581L6.91991 20.75H19.7778C20.3147 20.75 20.75 20.3147 20.75 19.7778V16.5178Z",
            fill: "currentColor",
            key: "svg-61-1",
            fillRule: "evenodd",
            clipRule: "evenodd"
          },
          []
        ]
      ]
    ],
    [
      "defs",
      { key: "svg-61-1" },
      [
        [
          "clipPath",
          { id: "clip0_10572_7464", key: "svg-61-0" },
          [["rect", { width: "24", height: "24", key: "svg-61-0" }, []]]
        ]
      ]
    ]
  ],
  true
);

var IconInfo = createReactComponent(
  "info",
  "IconInfo",
  [
    [
      "path",
      {
        d: "M12.0002 11.0345C12.5334 11.0345 12.9657 11.4668 12.9657 12V16.4138C12.9657 16.947 12.5334 17.3793 12.0002 17.3793C11.4669 17.3793 11.0347 16.947 11.0347 16.4138V12C11.0347 11.4668 11.4669 11.0345 12.0002 11.0345Z",
        fill: "currentColor",
        key: "svg-62-0"
      },
      []
    ],
    [
      "path",
      {
        d: "M12.0002 6.62073C11.4669 6.62073 11.0347 7.053 11.0347 7.58624C11.0347 8.11948 11.4669 8.55176 12.0002 8.55176H12.0112C12.5445 8.55176 12.9767 8.11948 12.9767 7.58624C12.9767 7.053 12.5445 6.62073 12.0112 6.62073H12.0002Z",
        fill: "currentColor",
        key: "svg-62-1"
      },
      []
    ],
    [
      "path",
      {
        d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12ZM12 1.93103C6.43906 1.93103 1.93103 6.43906 1.93103 12C1.93103 17.5609 6.43906 22.069 12 22.069C17.5609 22.069 22.069 17.5609 22.069 12C22.069 6.43906 17.5609 1.93103 12 1.93103Z",
        fill: "currentColor",
        key: "svg-62-2",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ]
  ],
  true
);

var IconInstagram = createReactComponent(
  "instagram",
  "IconInstagram",
  [
    [
      "g",
      { key: "svg-63-0", clipPath: "url(#clip0_6628_48066)" },
      [
        [
          "path",
          {
            d: "M12 0.25C8.8089 0.25 8.40875 0.263538 7.15548 0.320697C5.90483 0.377752 5.05069 0.57641 4.30328 0.866825C3.53061 1.1671 2.87534 1.5689 2.22214 2.2221C1.5689 2.87531 1.1671 3.53065 0.86686 4.30332C0.576375 5.05069 0.377787 5.90483 0.320662 7.15548C0.263503 8.40875 0.25 8.8089 0.25 12C0.25 15.1911 0.263503 15.5912 0.320662 16.8445C0.377787 18.0952 0.576375 18.9493 0.86686 19.6967C1.16714 20.4694 1.56893 21.1246 2.22214 21.7779C2.87538 22.4311 3.53061 22.8329 4.30328 23.1332C5.05069 23.4236 5.90483 23.6222 7.15548 23.6793C8.40875 23.7365 8.8089 23.75 12 23.75C15.1911 23.75 15.5912 23.7365 16.8445 23.6793C18.0952 23.6222 18.9493 23.4236 19.6967 23.1332C20.4694 22.8329 21.1246 22.4311 21.7779 21.7779C22.4311 21.1246 22.8329 20.4694 23.1332 19.6967C23.4236 18.9493 23.6222 18.0952 23.6793 16.8445C23.7365 15.5912 23.75 15.1911 23.75 12C23.75 8.8089 23.7365 8.40875 23.6793 7.15548C23.6222 5.90483 23.4236 5.05069 23.1332 4.30332C22.8329 3.53065 22.4311 2.87531 21.7779 2.2221C21.1246 1.5689 20.4694 1.1671 19.6967 0.866825C18.9493 0.57641 18.0952 0.377752 16.8445 0.320697C15.5912 0.263538 15.1911 0.25 12 0.25ZM12 2.3671C15.1374 2.3671 15.509 2.3791 16.748 2.43563C17.8936 2.48786 18.5158 2.67927 18.9298 2.84019C19.4783 3.05336 19.8697 3.30796 20.2808 3.71913C20.692 4.1303 20.9466 4.52174 21.1598 5.07017C21.3207 5.48421 21.5121 6.10639 21.5644 7.25199C21.6209 8.49099 21.6329 8.86263 21.6329 12C21.6329 15.1374 21.6209 15.509 21.5644 16.748C21.5121 17.8936 21.3207 18.5158 21.1598 18.9298C20.9466 19.4783 20.692 19.8697 20.2808 20.2808C19.8697 20.692 19.4783 20.9466 18.9298 21.1598C18.5158 21.3207 17.8936 21.5121 16.748 21.5644C15.5092 21.6209 15.1376 21.6329 12 21.6329C8.86239 21.6329 8.49085 21.6209 7.25199 21.5643C6.10635 21.5121 5.48421 21.3207 5.07021 21.1598C4.5217 20.9466 4.1303 20.692 3.71916 20.2808C3.30799 19.8697 3.05336 19.4783 2.84019 18.9298C2.67927 18.5158 2.48789 17.8936 2.43563 16.748C2.3791 15.509 2.3671 15.1374 2.3671 12C2.3671 8.86263 2.3791 8.49099 2.43563 7.25199C2.48789 6.10635 2.67927 5.48421 2.84019 5.07021C3.05336 4.5217 3.30799 4.1303 3.71913 3.71916C4.1303 3.30796 4.52174 3.05336 5.07017 2.84019C5.48421 2.67927 6.10639 2.48786 7.25199 2.43563C8.49099 2.3791 8.86267 2.3671 12 2.3671Z",
            fill: "currentColor",
            key: "svg-63-0"
          },
          []
        ],
        [
          "path",
          {
            d: "M12 15.9167C9.83686 15.9167 8.08332 14.1631 8.08332 12C8.08332 9.83686 9.83686 8.08332 12 8.08332C14.1631 8.08332 15.9167 9.83686 15.9167 12C15.9167 14.1631 14.1631 15.9167 12 15.9167ZM12 5.96622C8.66761 5.96622 5.96622 8.66761 5.96622 12C5.96622 15.3324 8.66761 18.0338 12 18.0338C15.3324 18.0338 18.0338 15.3324 18.0338 12C18.0338 8.66761 15.3324 5.96622 12 5.96622ZM19.6822 5.72782C19.6822 6.50657 19.0509 7.13781 18.2722 7.13781C17.4935 7.13781 16.8622 6.50657 16.8622 5.72782C16.8622 4.9491 17.4935 4.31779 18.2722 4.31779C19.0509 4.31779 19.6822 4.9491 19.6822 5.72782Z",
            fill: "currentColor",
            key: "svg-63-1"
          },
          []
        ]
      ]
    ],
    [
      "defs",
      { key: "svg-63-1" },
      [
        [
          "clipPath",
          { id: "clip0_6628_48066", key: "svg-63-0" },
          [
            [
              "rect",
              {
                width: "24",
                height: "24",
                fill: "currentColor",
                key: "svg-63-0"
              },
              []
            ]
          ]
        ]
      ]
    ]
  ],
  true
);

var IconLink = createReactComponent(
  "link",
  "IconLink",
  [
    [
      "g",
      { key: "svg-64-0", clipPath: "url(#clip0_198_3548)" },
      [
        [
          "path",
          {
            d: "M12.7755 2.75068C13.9071 1.65773 15.4227 1.05296 16.9959 1.06663C18.5691 1.0803 20.074 1.71132 21.1864 2.82377C22.2988 3.93621 22.9299 5.44109 22.9435 7.01427C22.9572 8.58745 22.3524 10.1031 21.2595 11.2347L21.2473 11.2471L18.2474 14.2469C17.6392 14.8554 16.9072 15.326 16.101 15.6267C15.2949 15.9274 14.4336 16.0512 13.5754 15.9897C12.7172 15.9283 11.8823 15.683 11.1273 15.2705C10.3723 14.858 9.71478 14.2879 9.19943 13.5989C8.86863 13.1567 8.95897 12.53 9.40122 12.1992C9.84347 11.8684 10.4702 11.9587 10.801 12.401C11.1445 12.8603 11.5829 13.2403 12.0862 13.5153C12.5896 13.7903 13.1462 13.9539 13.7183 13.9949C14.2904 14.0358 14.8646 13.9533 15.402 13.7528C15.9394 13.5523 16.4275 13.2386 16.833 12.833L19.8266 9.83934C20.5516 9.08557 20.9527 8.0777 20.9436 7.03165C20.9345 5.98286 20.5138 4.97961 19.7722 4.23798C19.0306 3.49635 18.0273 3.07567 16.9785 3.06656C15.932 3.05746 14.9237 3.45887 14.1698 4.1845L12.4552 5.88913C12.0636 6.27851 11.4304 6.27667 11.041 5.88501C10.6516 5.49335 10.6535 4.86018 11.0452 4.4708L12.7652 2.7608L12.7755 2.75068Z",
            fill: "currentColor",
            key: "svg-64-0",
            fillRule: "evenodd",
            clipRule: "evenodd"
          },
          []
        ],
        [
          "path",
          {
            d: "M7.89935 8.37325C8.70546 8.07255 9.56681 7.94873 10.425 8.01019C11.2832 8.07165 12.1181 8.31695 12.8731 8.72946C13.6281 9.14197 14.2856 9.71203 14.801 10.401C15.1318 10.8432 15.0414 11.4699 14.5992 11.8007C14.1569 12.1315 13.5302 12.0412 13.1994 11.5989C12.8559 11.1396 12.4175 10.7596 11.9142 10.4846C11.4108 10.2096 10.8542 10.0461 10.2821 10.0051C9.71 9.9641 9.13577 10.0466 8.59836 10.2471C8.06095 10.4476 7.57294 10.7613 7.16743 11.1669L4.17379 14.1606C3.44875 14.9144 3.0477 15.9222 3.05679 16.9683C3.06591 18.0171 3.48658 19.0203 4.22821 19.762C4.96985 20.5036 5.9731 20.9243 7.02188 20.9334C8.06793 20.9425 9.0758 20.5414 9.82957 19.8164L11.5331 18.1129C11.9236 17.7223 12.5568 17.7223 12.9473 18.1129C13.3378 18.5034 13.3378 19.1365 12.9473 19.5271L11.2373 21.2371L11.2249 21.2493C10.0933 22.3422 8.57768 22.947 7.0045 22.9333C5.43132 22.9196 3.92645 22.2886 2.814 21.1762C1.70155 20.0637 1.07054 18.5588 1.05687 16.9857C1.0432 15.4125 1.64796 13.8969 2.74091 12.7653L2.75309 12.7529L5.75296 9.75299C6.3612 9.14457 7.0933 8.67393 7.89935 8.37325Z",
            fill: "currentColor",
            key: "svg-64-1",
            fillRule: "evenodd",
            clipRule: "evenodd"
          },
          []
        ],
        [
          "path",
          {
            d: "M12.9492 2.9305L12.9414 2.93809L12.9401 2.93936L11.2214 4.64809C10.9277 4.94013 10.9263 5.415 11.2183 5.70875C11.5104 6.00249 11.9852 6.00388 12.279 5.71184L13.9964 4.00436C14.7974 3.23337 15.8688 2.80691 16.9807 2.81657C18.095 2.82625 19.161 3.27322 19.949 4.0612C20.7369 4.84919 21.1839 5.91514 21.1936 7.02948C21.2033 8.14091 20.7771 9.21177 20.0068 10.0127L20.0034 10.0162L17.0098 13.0097C16.5789 13.4407 16.0604 13.7741 15.4894 13.987C14.9184 14.2 14.3083 14.2878 13.7004 14.2442C13.0926 14.2007 12.5012 14.0269 11.9663 13.7347C11.4315 13.4425 10.9658 13.0387 10.6008 12.5507C10.3527 12.219 9.88265 12.1513 9.55097 12.3994C9.21928 12.6475 9.15152 13.1175 9.39963 13.4492C9.8935 14.1094 10.5236 14.6558 11.2472 15.0511C11.9707 15.4464 12.7709 15.6815 13.5933 15.7404C14.4157 15.7993 15.2412 15.6806 16.0137 15.3924C16.7862 15.1043 17.4877 14.6533 18.0706 14.0702L21.069 11.0718L21.0705 11.0703L21.0797 11.061C22.1267 9.97661 22.7066 8.52377 22.6935 7.01644C22.6804 5.50881 22.0757 4.06664 21.0096 3.00054C19.9435 1.93445 18.5014 1.32972 16.9937 1.31662C15.4864 1.30353 14.0336 1.88348 12.9492 2.9305ZM12.6018 2.57086C13.7806 1.43237 15.3593 0.802402 16.9981 0.816643C18.6368 0.830883 20.2044 1.48819 21.3632 2.64699C22.522 3.80579 23.1793 5.37337 23.1935 7.0121C23.2078 8.65083 22.5778 10.2296 21.4393 11.4084L21.4378 11.4099L21.4256 11.4223L21.4241 11.4238L18.4242 14.4237C17.7906 15.0575 17.0281 15.5477 16.1884 15.8609C15.3487 16.1741 14.4515 16.3031 13.5576 16.2391C12.6636 16.1751 11.7939 15.9196 11.0074 15.4899C10.2209 15.0602 9.53606 14.4663 8.99924 13.7487C8.58573 13.1959 8.69866 12.4125 9.25148 11.999C9.80429 11.5855 10.5876 11.6984 11.0012 12.2512C11.3232 12.6818 11.7342 13.0381 12.2061 13.2959C12.678 13.5538 13.1998 13.7071 13.7361 13.7455C14.2725 13.7839 14.8108 13.7065 15.3147 13.5186C15.8185 13.3306 16.276 13.0365 16.6562 12.6562L19.6481 9.66431C20.3268 8.95784 20.7021 8.0137 20.6936 7.03382C20.6851 6.05058 20.2907 5.11004 19.5954 4.41476C18.9001 3.71948 17.9596 3.32509 16.9763 3.31655C15.9959 3.30803 15.0513 3.68383 14.3447 4.36323L12.6315 6.06642C12.1419 6.55315 11.3505 6.55084 10.8637 6.06127C10.377 5.57169 10.3793 4.78024 10.8689 4.29351L12.5889 2.58351L12.5902 2.58224L12.6005 2.57212L12.6018 2.57086ZM10.4071 8.25955C9.58471 8.20065 8.75925 8.31931 7.98673 8.60748C7.21427 8.89563 6.51267 9.34666 5.92977 9.92974M5.57619 9.57621C6.20976 8.94246 6.97234 8.45222 7.81197 8.13902C8.65167 7.82578 9.54891 7.6968 10.4428 7.76083C11.3368 7.82485 12.2065 8.08037 12.993 8.51007C13.7795 8.93976 14.4643 9.53358 15.0012 10.2512C15.4147 10.8041 15.3017 11.5874 14.7489 12.0009C14.1961 12.4144 13.4128 12.3015 12.9992 11.7487C12.6772 11.3181 12.2662 10.9618 11.7943 10.704C11.3224 10.4462 10.8006 10.2929 10.2643 10.2544C9.7279 10.216 9.18955 10.2934 8.68573 10.4814C8.18192 10.6693 7.72441 10.9634 7.34424 11.3437L4.35232 14.3356C3.67364 15.0421 3.29827 15.9862 3.30678 16.9661C3.31533 17.9493 3.70971 18.8899 4.40499 19.5852C5.10027 20.2805 6.04082 20.6748 7.02406 20.6834C8.00391 20.6919 8.94804 20.3165 9.65451 19.6379L11.3563 17.9361C11.8445 17.4479 12.6359 17.4479 13.1241 17.9361C13.6122 18.4242 13.6122 19.2157 13.1241 19.7038L11.4141 21.4138L11.4125 21.4154L11.4002 21.4276L11.3986 21.4291C10.2198 22.5676 8.64106 23.1975 7.00233 23.1833C5.3636 23.169 3.79602 22.5117 2.63722 21.3529C1.47842 20.1941 0.821117 18.6266 0.806877 16.9878C0.792637 15.3491 1.4226 13.7703 2.56109 12.5916L2.5626 12.59L2.57631 12.5761L5.57619 9.57621ZM5.92977 9.92974L2.9314 12.9281L2.92987 12.9296L2.92073 12.9389L2.91999 12.9397C1.87305 14.0241 1.29376 15.4762 1.30686 16.9835C1.31996 18.4911 1.92468 19.9333 2.99078 20.9994C4.05687 22.0655 5.49905 22.6702 7.00668 22.6833C8.514 22.6964 9.96618 22.1171 11.0506 21.0701L11.0605 21.0603L11.0621 21.0588L12.7705 19.3503C13.0634 19.0574 13.0634 18.5825 12.7705 18.2896C12.4776 17.9967 12.0028 17.9967 11.7099 18.2896L10.0029 19.9966C9.20202 20.7669 8.13113 21.193 7.01971 21.1834C5.90537 21.1737 4.83942 20.7267 4.05144 19.9387C3.26345 19.1507 2.81648 18.0848 2.8068 16.9705C2.79714 15.859 3.22326 14.7882 3.99361 13.9873L3.99698 13.9838L6.99063 10.9902C7.42147 10.5592 7.94 10.2259 8.51098 10.0129C9.08198 9.79989 9.6921 9.71218 10.3 9.75572C10.9078 9.79925 11.4992 9.97301 12.0341 10.2652C12.5689 10.5574 13.0346 10.9612 13.3996 11.4492C13.6477 11.7809 14.1177 11.8486 14.4494 11.6005C14.7811 11.3524 14.8489 10.8824 14.6008 10.5507C14.1069 9.89048 13.4768 9.34417 12.7532 8.94885C12.0297 8.55353 11.2295 8.31845 10.4071 8.25955",
            fill: "currentColor",
            key: "svg-64-2",
            fillRule: "evenodd",
            clipRule: "evenodd"
          },
          []
        ]
      ]
    ],
    [
      "defs",
      { key: "svg-64-1" },
      [
        [
          "clipPath",
          { id: "clip0_198_3548", key: "svg-64-0" },
          [
            [
              "rect",
              { width: "24", height: "24", fill: "white", key: "svg-64-0" },
              []
            ]
          ]
        ]
      ]
    ]
  ],
  true
);

var IconLinkedIn = createReactComponent(
  "linkedIn",
  "IconLinkedIn",
  [
    [
      "g",
      { key: "svg-65-0", clipPath: "url(#clip0_622_4880)" },
      [
        [
          "path",
          {
            d: "M21.3333 0C22.0406 0 22.7189 0.280951 23.219 0.781048C23.719 1.28115 24 1.95942 24 2.66667V21.3333C24 22.0406 23.719 22.7189 23.219 23.219C22.7189 23.719 22.0406 24 21.3333 24H2.66667C1.95942 24 1.28115 23.719 0.781048 23.219C0.280951 22.7189 0 22.0406 0 21.3333V2.66667C0 1.95942 0.280951 1.28115 0.781048 0.781048C1.28115 0.280951 1.95942 0 2.66667 0H21.3333ZM20.6667 20.6667V13.6C20.6667 12.4472 20.2087 11.3416 19.3936 10.5264C18.5784 9.71128 17.4728 9.25333 16.32 9.25333C15.1867 9.25333 13.8667 9.94667 13.2267 10.9867V9.50667H9.50667V20.6667H13.2267V14.0933C13.2267 13.0667 14.0533 12.2267 15.08 12.2267C15.5751 12.2267 16.0499 12.4233 16.3999 12.7734C16.75 13.1235 16.9467 13.5983 16.9467 14.0933V20.6667H20.6667ZM5.17333 7.41333C5.76742 7.41333 6.33717 7.17733 6.75725 6.75725C7.17733 6.33717 7.41333 5.76742 7.41333 5.17333C7.41333 3.93333 6.41333 2.92 5.17333 2.92C4.57571 2.92 4.00257 3.1574 3.57999 3.57999C3.1574 4.00257 2.92 4.57571 2.92 5.17333C2.92 6.41333 3.93333 7.41333 5.17333 7.41333ZM7.02667 20.6667V9.50667H3.33333V20.6667H7.02667Z",
            fill: "currentColor",
            key: "svg-65-0"
          },
          []
        ]
      ]
    ],
    [
      "defs",
      { key: "svg-65-1" },
      [
        [
          "clipPath",
          { id: "clip0_622_4880", key: "svg-65-0" },
          [
            [
              "rect",
              {
                width: "24",
                height: "24",
                fill: "transparent",
                key: "svg-65-0"
              },
              []
            ]
          ]
        ]
      ]
    ]
  ],
  true
);

var IconLocation = createReactComponent(
  "location",
  "IconLocation",
  [
    [
      "path",
      {
        d: "M11.7573 12.1967C13.099 12.1967 14.1967 11.099 14.1967 9.75734C14.1967 8.4157 13.099 7.318 11.7573 7.318C10.4157 7.318 9.318 8.4157 9.318 9.75734C9.318 11.099 10.4157 12.1967 11.7573 12.1967ZM11.7573 0C16.8799 0 21.5147 3.92733 21.5147 10.0013C21.5147 13.8798 18.5265 18.4414 12.5623 23.6981C12.0988 24.1006 11.4036 24.1006 10.9402 23.6981C4.98818 18.4414 2 13.8798 2 10.0013C2 3.92733 6.63474 0 11.7573 0Z",
        fill: "currentColor",
        key: "svg-66-0"
      },
      []
    ]
  ],
  true
);

var IconLock = createReactComponent(
  "lock",
  "IconLock",
  [
    [
      "path",
      {
        fill: "currentColor",
        d: "M18 8H17V6C17 3.24 14.76 1 12 1C9.24 1 7 3.24 7 6V8H6C4.9 8 4 8.9 4 10V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V10C20 8.9 19.1 8 18 8ZM12 17C10.9 17 10 16.1 10 15C10 13.9 10.9 13 12 13C13.1 13 14 13.9 14 15C14 16.1 13.1 17 12 17ZM15.1 8H8.9V6C8.9 4.29 10.29 2.9 12 2.9C13.71 2.9 15.1 4.29 15.1 6V8Z",
        key: "svg-67-0"
      },
      []
    ]
  ],
  true
);

var IconMap = createReactComponent(
  "map",
  "IconMap",
  [
    [
      "g",
      { key: "svg-68-0", clipPath: "url(#clip0_153_3547)" },
      [
        [
          "path",
          {
            d: "M12 7.63636C9.58909 7.63636 7.63636 9.58909 7.63636 12C7.63636 14.4109 9.58909 16.3636 12 16.3636C14.4109 16.3636 16.3636 14.4109 16.3636 12C16.3636 9.58909 14.4109 7.63636 12 7.63636ZM21.7527 10.9091C21.2509 6.36 17.64 2.74909 13.0909 2.24727V1.09091C13.0909 0.490909 12.6 0 12 0C11.4 0 10.9091 0.490909 10.9091 1.09091V2.24727C6.36 2.74909 2.74909 6.36 2.24727 10.9091H1.09091C0.490909 10.9091 0 11.4 0 12C0 12.6 0.490909 13.0909 1.09091 13.0909H2.24727C2.74909 17.64 6.36 21.2509 10.9091 21.7527V22.9091C10.9091 23.5091 11.4 24 12 24C12.6 24 13.0909 23.5091 13.0909 22.9091V21.7527C17.64 21.2509 21.2509 17.64 21.7527 13.0909H22.9091C23.5091 13.0909 24 12.6 24 12C24 11.4 23.5091 10.9091 22.9091 10.9091H21.7527ZM12 19.6364C7.77818 19.6364 4.36364 16.2218 4.36364 12C4.36364 7.77818 7.77818 4.36364 12 4.36364C16.2218 4.36364 19.6364 7.77818 19.6364 12C19.6364 16.2218 16.2218 19.6364 12 19.6364Z",
            fill: "currentColor",
            key: "svg-68-0"
          },
          []
        ]
      ]
    ],
    [
      "defs",
      { key: "svg-68-1" },
      [
        [
          "clipPath",
          { id: "clip0_153_3547", key: "svg-68-0" },
          [
            [
              "rect",
              {
                width: "24",
                height: "24",
                fill: "transparent",
                key: "svg-68-0"
              },
              []
            ]
          ]
        ]
      ]
    ]
  ],
  true
);

var IconMembershipCard = createReactComponent(
  "membershipCard",
  "IconMembershipCard",
  [
    [
      "g",
      { key: "svg-69-0", clipPath: "url(#clip0_10182_8764)" },
      [
        [
          "path",
          {
            d: "M22.2133 5.85727V18.7144C22.2133 19.3061 21.7336 19.7858 21.1419 19.7858L2.85617 19.7858C2.26443 19.7858 1.78474 19.3061 1.78474 18.7144L1.78474 5.85727C1.78474 5.26553 2.26443 4.78584 2.85617 4.78584L21.1419 4.78584C21.7336 4.78584 22.2133 5.26553 22.2133 5.85727ZM23.999 18.7144C23.999 20.2924 22.7198 21.5716 21.1419 21.5716H2.85617C1.27821 21.5716 -0.000975844 20.2924 -0.000975913 18.7144L-0.000976562 5.85727C-0.000976631 4.27931 1.27821 3.00012 2.85617 3.00012L21.1419 3.00012C22.7198 3.00012 23.999 4.27931 23.999 5.85727V18.7144Z",
            fill: "currentColor",
            key: "svg-69-0",
            fillRule: "evenodd",
            clipRule: "evenodd"
          },
          []
        ],
        [
          "path",
          {
            d: "M8.12443 7.39007C6.74372 7.39007 5.62443 8.50936 5.62443 9.89007C5.62443 11.2708 6.74372 12.3901 8.12443 12.3901C9.50514 12.3901 10.6244 11.2708 10.6244 9.89007C10.6244 8.50936 9.50514 7.39007 8.12443 7.39007Z",
            fill: "currentColor",
            key: "svg-69-1",
            fillRule: "evenodd",
            clipRule: "evenodd"
          },
          []
        ],
        [
          "path",
          {
            d: "M3.83285 15.6192C3.83285 14.2385 4.95213 13.1192 6.33285 13.1192H9.66618C11.0469 13.1192 12.1662 14.2385 12.1662 15.6192V16.8692H3.83285V15.6192Z",
            fill: "currentColor",
            key: "svg-69-2"
          },
          []
        ],
        [
          "path",
          {
            d: "M15.9995 14.2859C15.9995 13.7336 16.4472 13.2859 16.9995 13.2859H18.9995C19.5518 13.2859 19.9995 13.7336 19.9995 14.2859C19.9995 14.8382 19.5518 15.2859 18.9995 15.2859H16.9995C16.4472 15.2859 15.9995 14.8382 15.9995 14.2859Z",
            fill: "currentColor",
            key: "svg-69-3"
          },
          []
        ],
        [
          "path",
          {
            d: "M15.9995 10.2859C15.9995 9.73362 16.4472 9.2859 16.9995 9.2859H18.9995C19.5518 9.2859 19.9995 9.73362 19.9995 10.2859C19.9995 10.8382 19.5518 11.2859 18.9995 11.2859H16.9995C16.4472 11.2859 15.9995 10.8382 15.9995 10.2859Z",
            fill: "currentColor",
            key: "svg-69-4"
          },
          []
        ]
      ]
    ],
    [
      "defs",
      { key: "svg-69-1" },
      [
        [
          "clipPath",
          { id: "clip0_10182_8764", key: "svg-69-0" },
          [
            [
              "rect",
              { width: "24", height: "24", fill: "white", key: "svg-69-0" },
              []
            ]
          ]
        ]
      ]
    ]
  ],
  true
);

var IconMinus = createReactComponent(
  "minus",
  "IconMinus",
  [
    [
      "path",
      { d: "M23 13.5H1V11H23V13.5Z", fill: "currentColor", key: "svg-70-0" },
      []
    ]
  ],
  true
);

var IconMobile = createReactComponent(
  "mobile",
  "IconMobile",
  [
    [
      "path",
      {
        d: "M15.5 1H7.5C6.12 1 5 2.12 5 3.5V20.5C5 21.88 6.12 23 7.5 23H15.5C16.88 23 18 21.88 18 20.5V3.5C18 2.12 16.88 1 15.5 1ZM11.5 22C10.67 22 10 21.33 10 20.5C10 19.67 10.67 19 11.5 19C12.33 19 13 19.67 13 20.5C13 21.33 12.33 22 11.5 22ZM16 18H7V4H16V18Z",
        fill: "currentColor",
        key: "svg-71-0"
      },
      []
    ]
  ],
  true
);

var IconMore = createReactComponent(
  "more",
  "IconMore",
  [
    [
      "g",
      { key: "svg-72-0", clipPath: "url(#clip0_251_8041)" },
      [
        [
          "path",
          {
            d: "M21 15C19.3431 15 18 13.6569 18 12C18 10.3431 19.3431 9 21 9C22.6569 9 24 10.3431 24 12C24 13.6569 22.6569 15 21 15Z",
            fill: "currentColor",
            key: "svg-72-0"
          },
          []
        ],
        [
          "path",
          {
            d: "M3 15C1.34315 15 -2.03558e-07 13.6569 -1.31134e-07 12C-5.87108e-08 10.3431 1.34315 9 3 9C4.65685 9 6 10.3431 6 12C6 13.6569 4.65685 15 3 15Z",
            fill: "currentColor",
            key: "svg-72-1"
          },
          []
        ],
        [
          "path",
          {
            d: "M12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15Z",
            fill: "currentColor",
            key: "svg-72-2"
          },
          []
        ]
      ]
    ],
    [
      "defs",
      { key: "svg-72-1" },
      [
        [
          "clipPath",
          { id: "clip0_251_8041", key: "svg-72-0" },
          [
            [
              "rect",
              { width: "24", height: "24", fill: "white", key: "svg-72-0" },
              []
            ]
          ]
        ]
      ]
    ]
  ],
  true
);

var IconMove = createReactComponent(
  "move",
  "IconMove",
  [
    [
      "path",
      {
        d: "M6 0C5.44772 0 5 0.447715 5 1V5C5 5.55228 5.44772 6 6 6H10C10.5523 6 11 5.55228 11 5V1C11 0.447715 10.5523 0 10 0H6Z",
        fill: "currentColor",
        key: "svg-73-0"
      },
      []
    ],
    [
      "path",
      {
        d: "M6 9C5.44772 9 5 9.44772 5 10V14C5 14.5523 5.44772 15 6 15H10C10.5523 15 11 14.5523 11 14V10C11 9.44772 10.5523 9 10 9H6Z",
        fill: "currentColor",
        key: "svg-73-1"
      },
      []
    ],
    [
      "path",
      {
        d: "M5 19C5 18.4477 5.44772 18 6 18H10C10.5523 18 11 18.4477 11 19V23C11 23.5523 10.5523 24 10 24H6C5.44772 24 5 23.5523 5 23V19Z",
        fill: "currentColor",
        key: "svg-73-2"
      },
      []
    ],
    [
      "path",
      {
        d: "M15 0C14.4477 0 14 0.447715 14 1V5C14 5.55228 14.4477 6 15 6H19C19.5523 6 20 5.55228 20 5V1C20 0.447715 19.5523 0 19 0H15Z",
        fill: "currentColor",
        key: "svg-73-3"
      },
      []
    ],
    [
      "path",
      {
        d: "M14 10C14 9.44772 14.4477 9 15 9H19C19.5523 9 20 9.44772 20 10V14C20 14.5523 19.5523 15 19 15H15C14.4477 15 14 14.5523 14 14V10Z",
        fill: "currentColor",
        key: "svg-73-4"
      },
      []
    ],
    [
      "path",
      {
        d: "M15 18C14.4477 18 14 18.4477 14 19V23C14 23.5523 14.4477 24 15 24H19C19.5523 24 20 23.5523 20 23V19C20 18.4477 19.5523 18 19 18H15Z",
        fill: "currentColor",
        key: "svg-73-5"
      },
      []
    ]
  ],
  true
);

var IconMusic = createReactComponent(
  "music",
  "IconMusic",
  [
    [
      "path",
      {
        d: "M10.1914 17.4053C10.1914 15.9721 9.02888 14.8095 7.5957 14.8095C6.16265 14.8097 5.00098 15.9722 5.00098 17.4053C5.00115 18.8382 6.16276 19.9998 7.5957 20C9.02877 20 10.1912 18.8383 10.1914 17.4053ZM18.2881 6.87205C18.2881 6.61439 18.1818 6.28915 17.9619 5.98533C17.743 5.68287 17.4669 5.47759 17.2197 5.39353L13.2471 4.07322L13.2432 4.07127C12.843 3.93604 12.5975 4.01829 12.4736 4.1074C12.3501 4.19633 12.1965 4.40085 12.1992 4.81638V5.88279C12.1992 6.14045 12.3055 6.46569 12.5254 6.76951C12.744 7.07144 13.0198 7.27605 13.2666 7.36033H13.2676L17.2402 8.68162H17.2393C17.6425 8.81494 17.887 8.73213 18.0098 8.64353C18.1323 8.55499 18.2881 8.34883 18.2881 7.92283V6.87205ZM20.2881 7.92283C20.2881 8.87177 19.9131 9.7362 19.1797 10.2656C18.4466 10.7945 17.5096 10.8777 16.6104 10.5801H16.6084L12.6367 9.25877L12.6328 9.25779C12.4793 9.20613 12.3326 9.1393 12.1904 9.06541L12.1914 17.4053L12.1846 17.6416C12.0614 20.0693 10.0541 22 7.5957 22C5.05819 21.9998 3.00115 19.9428 3.00098 17.4053C3.00098 14.8676 5.05808 12.8097 7.5957 12.8095C8.55842 12.8095 9.45209 13.1062 10.1904 13.6123V4.82224C10.1904 4.77381 10.1945 4.72626 10.2012 4.67966C10.2334 3.78838 10.6087 2.98547 11.3047 2.48435C12.0378 1.95657 12.9766 1.87261 13.8779 2.17576L13.8789 2.17478L17.8506 3.49607L17.8545 3.49705L18.1162 3.59959C18.7145 3.86405 19.218 4.3096 19.582 4.81248C19.998 5.38719 20.2881 6.11412 20.2881 6.87205V7.92283Z",
        fill: "currentColor",
        key: "svg-74-0"
      },
      []
    ]
  ],
  true
);

var IconNotificationBell = createReactComponent(
  "notificationBell",
  "IconNotificationBell",
  [
    [
      "path",
      {
        d: "M12 23.6922C10.13 23.6922 8.53 22.4022 8.08 20.6422H3.52C2.13 20.6422 1 19.5122 1 18.1222C1 16.9422 1.46 15.8822 2.29 15.0422C3.28 14.0322 3.85 12.6122 3.85 11.1422V9.45221C3.86 4.92221 7.4 1.13221 11.75 1.00221C13.96 0.952208 16.08 1.75221 17.67 3.30221C19.26 4.85221 20.14 6.92221 20.14 9.14221V11.0922C20.14 12.6522 20.7 14.0722 21.66 14.9922C22.51 15.8022 23 16.9422 23 18.1222C23 19.3022 22.09 20.6422 20.08 20.6422H15.92C15.47 22.4022 13.87 23.6922 12 23.6922ZM12 3.00221C11.94 3.00221 11.87 3.00221 11.81 3.00221C8.53 3.10221 5.86 5.99221 5.86 9.44221V11.1322C5.86 13.1222 5.08 15.0622 3.72 16.4422C3.26 16.9122 3 17.4722 3 18.0222C3 18.4022 3.23 18.6422 3.52 18.6422H8.73C9.38 18.6422 9.91 19.1422 9.96 19.8022C10.04 20.8622 10.94 21.6922 12 21.6922C13.06 21.6922 13.96 20.8622 14.04 19.8022C14.09 19.1422 14.62 18.6422 15.28 18.6422H20.08C20.3 18.6422 21 18.6022 21 18.1222C21 17.4922 20.74 16.8822 20.28 16.4422C18.93 15.1522 18.15 13.2022 18.14 11.1022V9.15221C18.14 7.47221 17.47 5.91221 16.27 4.74221C15.11 3.62221 13.6 3.01221 11.99 3.01221L12 3.00221Z",
        fill: "#CCCCCC",
        key: "svg-75-0"
      },
      []
    ]
  ],
  true
);

var IconPartiallyPaid = createReactComponent(
  "partially-paid",
  "IconPartiallyPaid",
  [
    [
      "path",
      {
        d: "M12 0C12.3874 5.49834e-06 12.7704 0.0187918 13.1484 0.0546875C13.1572 0.0555214 13.166 0.0557876 13.1748 0.0566406C13.9701 0.133857 14.7413 0.289856 15.4834 0.514648L15.4844 0.513672C15.4955 0.517045 15.5065 0.521009 15.5176 0.524414C15.6273 0.558015 15.7354 0.596174 15.8438 0.632812C15.9243 0.660048 16.0052 0.685956 16.085 0.714844C16.1801 0.749304 16.2741 0.78646 16.3682 0.823242C16.457 0.857989 16.546 0.891925 16.6338 0.928711C16.7163 0.963277 16.7974 1.00077 16.8789 1.03711C16.9786 1.08153 17.0786 1.12485 17.1768 1.17188C17.2505 1.20718 17.3226 1.24547 17.3955 1.28223C17.4832 1.32645 17.5718 1.36875 17.6582 1.41504L17.6572 1.41602C18.3526 1.78848 19.0074 2.22664 19.6123 2.72363C19.7511 2.83766 19.887 2.95612 20.0205 3.07617C20.3236 3.3488 20.6137 3.63564 20.8877 3.9375C21.0208 4.0841 21.1506 4.23367 21.2764 4.38672C21.7735 4.99161 22.2105 5.64645 22.583 6.3418C22.6033 6.37964 22.6217 6.41895 22.6416 6.45703C22.7078 6.58391 22.7732 6.71133 22.835 6.84082C22.8517 6.87577 22.8674 6.91115 22.8838 6.94629C22.9484 7.08511 23.0119 7.22457 23.0713 7.36621C23.1066 7.45036 23.1384 7.53598 23.1719 7.62109C23.21 7.71836 23.2485 7.81558 23.2842 7.91406C23.309 7.98263 23.3318 8.05195 23.3555 8.12109C23.3963 8.24064 23.4375 8.36024 23.4746 8.48145C23.4781 8.49295 23.4828 8.5041 23.4863 8.51562H23.4844C23.8186 9.6185 24 10.788 24 12C24 13.2117 23.8184 14.3808 23.4844 15.4834L23.4863 15.4844C23.4829 15.4956 23.478 15.5064 23.4746 15.5176C23.441 15.6273 23.4029 15.7354 23.3662 15.8438C23.3389 15.9243 23.3131 16.0052 23.2842 16.085C23.2497 16.1801 23.2126 16.2741 23.1758 16.3682C23.1411 16.4566 23.108 16.5454 23.0713 16.6328C23.0259 16.7412 22.9762 16.8474 22.9277 16.9541C22.8968 17.0222 22.8671 17.0908 22.835 17.1582C22.7757 17.2826 22.7138 17.4054 22.6504 17.5273C22.6278 17.5708 22.6071 17.6151 22.584 17.6582L22.583 17.6572C22.2105 18.3526 21.7725 19.0074 21.2754 19.6123L21.2764 19.6133C21.2718 19.6188 21.2663 19.6234 21.2617 19.6289C20.8923 20.0769 20.4912 20.4977 20.0615 20.8877C19.9151 21.0206 19.7661 21.1508 19.6133 21.2764L19.6123 21.2754C19.0074 21.7725 18.3526 22.2105 17.6572 22.583L17.6582 22.584C17.6201 22.6044 17.5803 22.6216 17.542 22.6416C17.4151 22.7078 17.2877 22.7732 17.1582 22.835C17.0908 22.8671 17.0222 22.8968 16.9541 22.9277C16.8474 22.9762 16.7412 23.0259 16.6328 23.0713C16.5454 23.108 16.4566 23.1411 16.3682 23.1758C16.2741 23.2126 16.1801 23.2497 16.085 23.2842C16.0052 23.3131 15.9243 23.3389 15.8438 23.3662C15.7354 23.4029 15.6273 23.441 15.5176 23.4746C15.5064 23.478 15.4956 23.4829 15.4844 23.4863L15.4834 23.4844C14.7412 23.7092 13.9691 23.8652 13.1738 23.9424L13.1748 23.9434C13.1661 23.9442 13.1572 23.9435 13.1484 23.9443C12.7704 23.9802 12.3874 24 12 24C11.6273 24 11.2586 23.9815 10.8945 23.9482C10.8711 23.9461 10.8476 23.9456 10.8242 23.9434V23.9414C10.0294 23.864 9.25744 23.7093 8.51562 23.4844V23.4863C8.49592 23.4804 8.47669 23.4729 8.45703 23.4668C8.29799 23.4177 8.14052 23.365 7.98438 23.3096C7.95302 23.2984 7.92186 23.2868 7.89062 23.2754C7.73353 23.2181 7.57778 23.1583 7.42383 23.0947C7.39348 23.0822 7.36323 23.0694 7.33301 23.0566C6.26269 22.6042 5.27347 21.9995 4.38867 21.2725L4.38672 21.2764C4.33073 21.2304 4.27779 21.1808 4.22266 21.1338C4.16413 21.0839 4.1054 21.0344 4.04785 20.9834C3.95934 20.905 3.87229 20.8251 3.78613 20.7441C3.72739 20.6889 3.66895 20.6335 3.61133 20.5771C3.52788 20.4955 3.44629 20.4121 3.36523 20.3281C3.3296 20.2912 3.292 20.2561 3.25684 20.2188L3.25879 20.2158C3.07475 20.0201 2.89428 19.821 2.72363 19.6133L4.34668 18.2803C4.72609 18.742 5.14776 19.1674 5.60352 19.5537C6.17282 20.0363 6.79712 20.4546 7.46582 20.7998C7.95722 21.0536 8.47206 21.268 9.00684 21.4375C9.74892 21.6725 10.5286 21.8206 11.335 21.874C11.5547 21.8885 11.7765 21.8994 12 21.8994C12.2293 21.8994 12.4565 21.8883 12.6816 21.873C13.6255 21.8088 14.533 21.6151 15.3857 21.3047C15.5595 21.2414 15.7303 21.1722 15.8994 21.0996C18.3588 20.0444 20.3027 18.0223 21.2559 15.5107C21.2717 15.4689 21.2894 15.4278 21.3047 15.3857C21.6151 14.533 21.8088 13.6255 21.873 12.6816C21.8883 12.4565 21.8994 12.2293 21.8994 12C21.8994 11.7708 21.8883 11.5435 21.873 11.3184C21.8088 10.3742 21.6152 9.46634 21.3047 8.61328C21.2824 8.55221 21.2578 8.49215 21.2344 8.43164C20.8496 7.43628 20.3108 6.51776 19.6436 5.70801C19.6096 5.66686 19.5736 5.6275 19.5391 5.58691C19.4414 5.47221 19.341 5.3601 19.2383 5.25C18.941 4.93137 18.6247 4.63072 18.2881 4.35352C17.7125 3.87953 17.0819 3.47048 16.4082 3.13477C15.9302 2.89654 15.4309 2.69435 14.9131 2.53516C14.2003 2.31598 13.453 2.17748 12.6816 2.125C12.4565 2.10975 12.2293 2.09961 12 2.09961C11.6717 2.09961 11.3468 2.11539 11.0273 2.14648L10.8242 0.0566406C11.2112 0.0189772 11.6037 0 12 0Z",
        fill: "currentColor",
        key: "svg-76-0"
      },
      []
    ],
    [
      "path",
      {
        d: "M16.2861 7.00879C16.753 6.45703 17.5789 6.38793 18.1309 6.85449C18.6828 7.3215 18.7522 8.14827 18.2852 8.7002L11.085 17.209C10.8485 17.4884 10.5054 17.6557 10.1396 17.6709C9.77407 17.686 9.41891 17.5478 9.16016 17.2891L5.8877 14.0166C5.37646 13.5054 5.37646 12.6763 5.8877 12.165C6.39889 11.654 7.22709 11.654 7.73828 12.165L10.0049 14.4316L16.2861 7.00879Z",
        fill: "currentColor",
        key: "svg-76-1"
      },
      []
    ],
    [
      "path",
      {
        d: "M2.52344 14.875C2.71295 15.5005 2.96307 16.1003 3.2666 16.667L1.41504 17.6582C1.047 16.9711 0.743749 16.2437 0.513672 15.4844L2.52344 14.875Z",
        fill: "currentColor",
        key: "svg-76-2"
      },
      []
    ],
    [
      "path",
      {
        d: "M2.14648 11.0273C2.11539 11.3468 2.09961 11.6717 2.09961 12C2.09962 12.3281 2.11541 12.6523 2.14648 12.9717L0.0566406 13.1748C0.0190098 12.788 6.32661e-06 12.3961 0 12C0 11.6037 0.0189771 11.2112 0.0566406 10.8242L2.14648 11.0273Z",
        fill: "currentColor",
        key: "svg-76-3"
      },
      []
    ],
    [
      "path",
      {
        d: "M3.2666 7.33301C2.96307 7.8997 2.71295 8.49949 2.52344 9.125L0.513672 8.51562C0.743729 7.75629 1.04702 7.02896 1.41504 6.3418L3.2666 7.33301Z",
        fill: "currentColor",
        key: "svg-76-4"
      },
      []
    ],
    [
      "path",
      {
        d: "M5.71973 4.34668C5.21853 4.75849 4.75849 5.21853 4.34668 5.71973L2.72363 4.38672C3.22234 3.77974 3.77974 3.22234 4.38672 2.72363L5.71973 4.34668Z",
        fill: "currentColor",
        key: "svg-76-5"
      },
      []
    ],
    [
      "path",
      {
        d: "M9.125 2.52344C8.49949 2.71295 7.8997 2.96307 7.33301 3.2666L6.3418 1.41504C7.02896 1.04702 7.75629 0.743729 8.51562 0.513672L9.125 2.52344Z",
        fill: "currentColor",
        key: "svg-76-6"
      },
      []
    ]
  ],
  true
);

var IconPercent = createReactComponent(
  "percent",
  "IconPercent",
  [
    [
      "g",
      { id: "percent", key: "svg-77-0" },
      [
        [
          "g",
          { id: "Vector", key: "svg-77-0" },
          [
            [
              "path",
              {
                d: "M19.263 1L7.82304 23H5.58304L17.003 1H19.263Z",
                fill: "currentColor",
                key: "svg-77-0"
              },
              []
            ],
            [
              "path",
              {
                d: "M19.263 1H17.003L5.58304 23H7.82304L19.263 1ZM18 21.25C19.1442 21.25 20.25 20.2322 20.25 18.75C20.25 17.2678 19.1442 16.25 18 16.25C16.8558 16.25 15.75 17.2678 15.75 18.75C15.75 20.2322 16.8558 21.25 18 21.25ZM6 7.75C7.14421 7.75 8.25 6.73217 8.25 5.25C8.25 3.76783 7.14421 2.75 6 2.75C4.85579 2.75 3.75 3.76783 3.75 5.25C3.75 6.73217 4.85579 7.75 6 7.75ZM6 9.5C8.20914 9.5 10 7.59721 10 5.25C10 2.90279 8.20914 1 6 1C3.79086 1 2 2.90279 2 5.25C2 7.59721 3.79086 9.5 6 9.5ZM22 18.75C22 21.0972 20.2091 23 18 23C15.7909 23 14 21.0972 14 18.75C14 16.4028 15.7909 14.5 18 14.5C20.2091 14.5 22 16.4028 22 18.75Z",
                fill: "currentColor",
                key: "svg-77-1",
                fillRule: "evenodd",
                clipRule: "evenodd"
              },
              []
            ]
          ]
        ]
      ]
    ]
  ],
  true
);

var IconPlus = createReactComponent(
  "plus",
  "IconPlus",
  [
    [
      "g",
      { key: "svg-78-0", clipPath: "url(#clip0_198_3486)" },
      [
        [
          "path",
          {
            d: "M10.6262 9.76908V0H13.3738V9.76908V10.6262H14.2309H24V13.3738H14.2309H13.3738V14.2309V24H10.6262V14.2309V13.3738H9.76908H0V10.6262H9.76908H10.6262V9.76908Z",
            fill: "currentColor",
            key: "svg-78-0",
            fillRule: "evenodd",
            clipRule: "evenodd"
          },
          []
        ]
      ]
    ],
    [
      "defs",
      { key: "svg-78-1" },
      [
        [
          "clipPath",
          { id: "clip0_198_3486", key: "svg-78-0" },
          [
            [
              "rect",
              {
                width: "24",
                height: "24",
                fill: "transparent",
                key: "svg-78-0"
              },
              []
            ]
          ]
        ]
      ]
    ]
  ],
  true
);

var IconPrint = createReactComponent(
  "print",
  "IconPrint",
  [
    [
      "path",
      {
        d: "M5 2C5 1.44772 5.44772 1 6 1H18C18.5523 1 19 1.44772 19 2V8H20C20.7957 8 21.5587 8.31607 22.1213 8.87868C22.6839 9.44129 23 10.2043 23 11V16C23 16.7957 22.6839 17.5587 22.1213 18.1213C21.5587 18.6839 20.7957 19 20 19H19V22C19 22.5523 18.5523 23 18 23H6C5.44772 23 5 22.5523 5 22V19H4C3.20435 19 2.44129 18.6839 1.87868 18.1213C1.31607 17.5587 1 16.7956 1 16V11C1 10.2044 1.31607 9.44129 1.87868 8.87868C2.44129 8.31607 3.20435 8 4 8H5V2ZM7 21H17V15H7V21ZM19 17V14C19 13.4477 18.5523 13 18 13H6C5.44772 13 5 13.4477 5 14V17H4C3.73478 17 3.48043 16.8946 3.29289 16.7071C3.10536 16.5196 3 16.2652 3 16V11C3 10.7348 3.10536 10.4804 3.29289 10.2929C3.48043 10.1054 3.73478 10 4 10H20C20.2652 10 20.5196 10.1054 20.7071 10.2929C20.8946 10.4804 21 10.7348 21 11V16C21 16.2652 20.8946 16.5196 20.7071 16.7071C20.5196 16.8946 20.2652 17 20 17H19ZM17 3V8H7V3H17Z",
        fill: "currentColor",
        key: "svg-79-0",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ]
  ],
  true
);

var IconProfile = createReactComponent(
  "profile",
  "IconProfile",
  [
    [
      "path",
      {
        fill: "currentColor",
        d: "M7.6998 6.25C7.6998 4.26177 9.31158 2.65 11.2998 2.65C13.288 2.65 14.8998 4.26177 14.8998 6.25C14.8998 8.23822 13.288 9.85 11.2998 9.85C9.31158 9.85 7.6998 8.23822 7.6998 6.25ZM11.2998 0.25C7.9861 0.25 5.2998 2.93629 5.2998 6.25C5.2998 9.56371 7.9861 12.25 11.2998 12.25C14.6135 12.25 17.2998 9.56371 17.2998 6.25C17.2998 2.93629 14.6135 0.25 11.2998 0.25ZM6.5 14.65C4.9087 14.65 3.38258 15.2822 2.25736 16.4074C1.13214 17.5326 0.5 19.0587 0.5 20.65V23.05C0.5 23.7128 1.03726 24.25 1.7 24.25C2.36274 24.25 2.9 23.7128 2.9 23.05V20.65C2.9 19.6952 3.27928 18.7796 3.95442 18.1044C4.62955 17.4293 5.54522 17.05 6.5 17.05H16.1C17.0548 17.05 17.9705 17.4293 18.6456 18.1044C19.3207 18.7796 19.7 19.6952 19.7 20.65V23.05C19.7 23.7128 20.2373 24.25 20.9 24.25C21.5627 24.25 22.1 23.7128 22.1 23.05V20.65C22.1 19.0587 21.4679 17.5326 20.3426 16.4074C19.2174 15.2822 17.6913 14.65 16.1 14.65H6.5Z",
        key: "svg-80-0",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ]
  ],
  true
);

var IconQrCode = createReactComponent(
  "qrCode",
  "IconQrCode",
  [
    [
      "g",
      { key: "svg-81-0", clipPath: "url(#clip0_622_4881)" },
      [
        [
          "path",
          {
            d: "M3.75 1.85938C2.70584 1.85938 1.85938 2.70584 1.85938 3.75V7.875C1.85938 8.34962 1.47462 8.73438 1 8.73438C0.525381 8.73438 0.140625 8.34962 0.140625 7.875V3.75C0.140625 1.7566 1.7566 0.140625 3.75 0.140625H7.875C8.34962 0.140625 8.73438 0.525381 8.73438 1C8.73438 1.47462 8.34962 1.85938 7.875 1.85938H3.75Z",
            fill: "currentColor",
            key: "svg-81-0",
            fillRule: "evenodd",
            clipRule: "evenodd"
          },
          []
        ],
        [
          "path",
          {
            d: "M1.85938 16.125L1.85938 20.25C1.85938 21.2942 2.70584 22.1406 3.75 22.1406H7.875C8.34962 22.1406 8.73438 22.5254 8.73438 23C8.73438 23.4746 8.34962 23.8594 7.875 23.8594H3.75C1.7566 23.8594 0.140625 22.2434 0.140625 20.25L0.140625 16.125C0.140625 15.6504 0.52538 15.2656 1 15.2656C1.47462 15.2656 1.85938 15.6504 1.85938 16.125Z",
            fill: "currentColor",
            key: "svg-81-1",
            fillRule: "evenodd",
            clipRule: "evenodd"
          },
          []
        ],
        [
          "path",
          {
            d: "M20.25 22.1406C21.2942 22.1406 22.1406 21.2942 22.1406 20.25V16.125C22.1406 15.6504 22.5254 15.2656 23 15.2656C23.4746 15.2656 23.8594 15.6504 23.8594 16.125V20.25C23.8594 22.2434 22.2434 23.8594 20.25 23.8594H16.125C15.6504 23.8594 15.2656 23.4746 15.2656 23C15.2656 22.5254 15.6504 22.1406 16.125 22.1406H20.25Z",
            fill: "currentColor",
            key: "svg-81-2",
            fillRule: "evenodd",
            clipRule: "evenodd"
          },
          []
        ],
        [
          "path",
          {
            d: "M22.1406 3.75C22.1406 2.70584 21.2942 1.85938 20.25 1.85938L16.125 1.85938C15.6504 1.85938 15.2656 1.47462 15.2656 1C15.2656 0.52538 15.6504 0.140625 16.125 0.140625L20.25 0.140625C22.2434 0.140625 23.8594 1.7566 23.8594 3.75V7.875C23.8594 8.34962 23.4746 8.73438 23 8.73438C22.5254 8.73438 22.1406 8.34962 22.1406 7.875V3.75Z",
            fill: "currentColor",
            key: "svg-81-3",
            fillRule: "evenodd",
            clipRule: "evenodd"
          },
          []
        ],
        [
          "path",
          {
            d: "M5.125 13.375H10.625V18.875H5.125V13.375ZM6.5 14.75V17.5H9.25V14.75H6.5Z",
            fill: "currentColor",
            key: "svg-81-4",
            fillRule: "evenodd",
            clipRule: "evenodd"
          },
          []
        ],
        [
          "path",
          {
            d: "M13.375 5.125H18.875V10.625H13.375V5.125ZM14.75 6.5V9.25H17.5V6.5H14.75Z",
            fill: "currentColor",
            key: "svg-81-5",
            fillRule: "evenodd",
            clipRule: "evenodd"
          },
          []
        ],
        [
          "path",
          {
            d: "M13.375 13.375H14.75V14.75H13.375V13.375Z",
            fill: "currentColor",
            key: "svg-81-6"
          },
          []
        ],
        [
          "path",
          {
            d: "M10.625 5.125V6.5H9.25V5.125H10.625Z",
            fill: "currentColor",
            key: "svg-81-7"
          },
          []
        ],
        [
          "path",
          {
            d: "M13.375 16.125H14.75V17.5H13.375V16.125Z",
            fill: "currentColor",
            key: "svg-81-8"
          },
          []
        ],
        [
          "path",
          {
            d: "M7.875 5.125V6.5H6.5V5.125H7.875Z",
            fill: "currentColor",
            key: "svg-81-9"
          },
          []
        ],
        [
          "path",
          {
            d: "M16.125 13.375H18.875V14.75H16.125V13.375Z",
            fill: "currentColor",
            key: "svg-81-10"
          },
          []
        ],
        [
          "path",
          {
            d: "M10.625 7.875V10.625H9.25V7.875H10.625Z",
            fill: "currentColor",
            key: "svg-81-11"
          },
          []
        ],
        [
          "path",
          {
            d: "M17.5 17.5H18.875V18.875H17.5V17.5Z",
            fill: "currentColor",
            key: "svg-81-12"
          },
          []
        ],
        [
          "path",
          {
            d: "M6.5 9.25V10.625H5.125V9.25H6.5Z",
            fill: "currentColor",
            key: "svg-81-13"
          },
          []
        ],
        [
          "path",
          {
            d: "M13.375 17.5H16.125V18.875H13.375V17.5Z",
            fill: "currentColor",
            key: "svg-81-14"
          },
          []
        ],
        [
          "path",
          {
            d: "M6.5 5.125V7.875H5.125V5.125H6.5Z",
            fill: "currentColor",
            key: "svg-81-15"
          },
          []
        ],
        [
          "path",
          {
            d: "M16.125 13.375H17.5V16.125H16.125V13.375Z",
            fill: "currentColor",
            key: "svg-81-16"
          },
          []
        ],
        [
          "path",
          {
            d: "M10.625 7.875V9.25H7.875V7.875H10.625Z",
            fill: "currentColor",
            key: "svg-81-17"
          },
          []
        ]
      ]
    ],
    [
      "defs",
      { key: "svg-81-1" },
      [
        [
          "clipPath",
          { id: "clip0_622_4881", key: "svg-81-0" },
          [
            [
              "rect",
              {
                width: "24",
                height: "24",
                fill: "transparent",
                key: "svg-81-0"
              },
              []
            ]
          ]
        ]
      ]
    ]
  ],
  true
);

var IconQuestionMark = createReactComponent(
  "questionMark",
  "IconQuestionMark",
  [
    [
      "g",
      { key: "svg-82-0", clipPath: "url(#clip0_12666_8138)" },
      [
        [
          "path",
          {
            d: "M12 2.18182C6.57757 2.18182 2.18182 6.57757 2.18182 12C2.18182 17.4224 6.57757 21.8182 12 21.8182C17.4224 21.8182 21.8182 17.4224 21.8182 12C21.8182 6.57757 17.4224 2.18182 12 2.18182ZM0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
            fill: "white",
            key: "svg-82-0",
            fillRule: "evenodd",
            clipRule: "evenodd"
          },
          []
        ],
        [
          "path",
          {
            d: "M10.588 12.8549L10.5642 12.1789C10.5522 11.8388 10.8122 11.5506 11.1517 11.5276L11.6623 11.4931C12.1868 11.4629 12.6155 11.3116 12.9484 11.0392C13.2914 10.7668 13.4629 10.3684 13.4629 9.84388C13.4629 9.40005 13.3065 9.03187 12.9938 8.73934C12.6811 8.44681 12.2726 8.30055 11.7682 8.30055C11.4152 8.30055 11.1075 8.39133 10.8453 8.5729C10.446 8.84438 9.96011 9.12278 9.49562 8.99117L9.45742 8.98035C8.93149 8.83133 8.6156 8.26315 8.93244 7.81769C9.1252 7.54669 9.36436 7.3092 9.64993 7.10523C10.2249 6.70174 10.931 6.5 11.7682 6.5C12.4743 6.5 13.0997 6.64626 13.6444 6.93879C14.1891 7.22123 14.6128 7.61463 14.9154 8.11898C15.2281 8.61325 15.3845 9.18822 15.3845 9.84388C15.3845 10.4491 15.2382 10.9787 14.9457 11.4326C14.6531 11.8865 14.2446 12.2396 13.7201 12.4917C13.1956 12.7338 12.5853 12.8549 11.8893 12.8549H10.588ZM11.5715 17.5C11.2387 17.5 10.9512 17.384 10.7091 17.152C10.4771 16.9099 10.3611 16.6174 10.3611 16.2744C10.3611 15.9415 10.4771 15.6591 10.7091 15.4271C10.9512 15.185 11.2387 15.064 11.5715 15.064C11.9044 15.064 12.1868 15.185 12.4188 15.4271C12.6609 15.6591 12.782 15.9415 12.782 16.2744C12.782 16.6174 12.6609 16.9099 12.4188 17.152C12.1868 17.384 11.9044 17.5 11.5715 17.5ZM11.5715 14.2318C11.042 14.2318 10.6098 13.8082 10.5991 13.2787L10.5729 11.9773H12.5702L12.5439 13.2787C12.5333 13.8082 12.1011 14.2318 11.5715 14.2318Z",
            fill: "white",
            key: "svg-82-1"
          },
          []
        ]
      ]
    ],
    [
      "defs",
      { key: "svg-82-1" },
      [
        [
          "clipPath",
          { id: "clip0_12666_8138", key: "svg-82-0" },
          [
            [
              "rect",
              { width: "24", height: "24", fill: "white", key: "svg-82-0" },
              []
            ]
          ]
        ]
      ]
    ]
  ],
  true
);

var IconReceipt = createReactComponent(
  "receipt",
  "IconReceipt",
  [
    [
      "path",
      {
        d: "M6.11128 1.96286C5.56925 1.96286 5.12985 2.40226 5.12985 2.94428V20.6597C5.12985 20.996 5.26345 21.3185 5.50125 21.5563C5.92867 21.9837 6.59835 22.05 7.10129 21.7147L7.19068 21.6551C8.31996 20.9023 9.79116 20.9023 10.9204 21.6551L11.0721 21.7562C11.6339 22.1308 12.3658 22.1308 12.9276 21.7562L13.0792 21.6551C14.2085 20.9023 15.6797 20.9023 16.809 21.6551L16.8984 21.7147C17.4013 22.05 18.071 21.9837 18.4984 21.5563C18.7362 21.3185 18.8698 20.996 18.8698 20.6597V2.94428C18.8698 2.40226 18.4304 1.96286 17.8884 1.96286H6.11128ZM3.16699 2.94428C3.16699 1.3182 4.48519 0 6.11128 0H17.8884C19.5145 0 20.8327 1.3182 20.8327 2.94428V20.6597C20.8327 21.5165 20.4923 22.3383 19.8864 22.9442C18.7974 24.0333 17.0911 24.2022 15.8096 23.3479L15.7202 23.2883C15.2503 22.975 14.638 22.975 14.168 23.2883L14.0164 23.3894C12.7953 24.2035 11.2044 24.2035 9.9833 23.3894L9.83164 23.2883C9.36168 22.975 8.74943 22.975 8.27948 23.2883L8.19008 23.3479C6.90863 24.2022 5.20233 24.0333 4.1133 22.9442C3.50739 22.3383 3.16699 21.5165 3.16699 20.6597V2.94428Z",
        fill: "currentColor",
        key: "svg-83-0",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ],
    [
      "path",
      {
        d: "M7.0927 5.29263C7.0927 4.82804 7.46933 4.45141 7.93393 4.45141H16.0658C16.5304 4.45141 16.907 4.82804 16.907 5.29263C16.907 5.75723 16.5304 6.13386 16.0658 6.13386H7.93393C7.46933 6.13386 7.0927 5.75723 7.0927 5.29263Z",
        fill: "currentColor",
        key: "svg-83-1",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ],
    [
      "path",
      {
        d: "M11.9998 15.3873C11.9998 14.9227 12.3765 14.5461 12.8411 14.5461H16.0658C16.5304 14.5461 16.907 14.9227 16.907 15.3873C16.907 15.8519 16.5304 16.2285 16.0658 16.2285H12.8411C12.3765 16.2285 11.9998 15.8519 11.9998 15.3873Z",
        fill: "currentColor",
        key: "svg-83-2",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ],
    [
      "path",
      {
        d: "M7.0927 12.0224C7.0927 11.5578 7.46933 11.1812 7.93393 11.1812H16.0658C16.5304 11.1812 16.907 11.5578 16.907 12.0224C16.907 12.487 16.5304 12.8637 16.0658 12.8637H7.93393C7.46933 12.8637 7.0927 12.487 7.0927 12.0224Z",
        fill: "currentColor",
        key: "svg-83-3",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ],
    [
      "path",
      {
        d: "M7.0927 8.65753C7.0927 8.19293 7.46933 7.81631 7.93393 7.81631H16.0658C16.5304 7.81631 16.907 8.19293 16.907 8.65753C16.907 9.12212 16.5304 9.49875 16.0658 9.49875H7.93393C7.46933 9.49875 7.0927 9.12212 7.0927 8.65753Z",
        fill: "currentColor",
        key: "svg-83-4",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ]
  ],
  true
);

var IconReferral = createReactComponent(
  "referral",
  "IconReferral",
  [
    [
      "g",
      { key: "svg-84-0", clipPath: "url(#clip0_198_3508)" },
      [
        [
          "path",
          {
            d: "M16.6352 0L16.029 0.664485C14.6713 2.15888 13.5522 2.82706 12.6206 3.2642C11.689 3.70041 10.9062 3.83072 10.1373 4.41942C9.31757 5.04787 8.12631 6.25299 7.62448 8.40448C6.54873 8.63922 5.76133 9.05141 5.14028 9.58836C4.52663 10.1188 4.06454 10.7223 3.49524 11.3794C3.49062 11.3868 3.49802 11.4007 3.49524 11.4081C2.67827 12.347 1.96388 13.3581 0.577612 13.8923L0 14.1233V24H17.6176C18.6278 23.9455 19.3283 23.2459 19.7543 22.5555C20.1794 21.8661 20.4151 21.1193 20.5343 20.5057C20.8412 18.942 21.4003 14.4403 21.4003 14.4403L21.4299 14.3543V14.2675C21.4003 13.6427 21.1434 13.1122 20.8227 12.6206L21.8624 9.53106L23.5093 7.04686L23.9714 6.38238L23.3642 5.83434L17.2997 0.577612L16.6352 0ZM16.6934 2.54149L21.5158 6.72987L20.2451 8.60595L20.1591 8.69375L20.1295 8.83792L19.2922 11.3212C18.8551 11.141 18.405 11.0144 17.906 11.0328H17.8477L12.0143 11.0615H11.0901V14.6427C10.9608 15.65 10.4007 16.04 9.70388 16.3182C9.47283 16.4116 9.44418 16.3607 9.24179 16.4042V11.0338C9.09022 7.60784 10.3101 6.62174 11.2639 5.89256C11.5273 5.69017 12.299 5.45635 13.4006 4.93974C14.3211 4.5063 15.4652 3.72906 16.6934 2.54149ZM7.45165 10.4839C7.44796 10.6937 7.38234 10.8415 7.39343 11.0615V18.4549H8.31761C8.31761 18.4549 9.30648 18.4438 10.3684 18.0215C11.4293 17.5991 12.7112 16.6103 12.9385 14.8737V12.9099L17.906 12.8812H17.9346C18.3403 12.859 18.7383 12.9984 19.0414 13.269C19.3445 13.5395 19.5281 13.9192 19.5519 14.3248C19.5482 14.3396 19.5057 14.6824 19.4946 14.7582H15.711V16.6066H19.2636C19.1656 17.321 19.076 17.7692 18.9743 18.4549H15.711V20.3033H18.686C18.5768 20.7504 18.4014 21.1787 18.1657 21.574C17.9134 21.9853 17.6962 22.1406 17.5021 22.1516H1.84836V15.249C3.34645 14.4542 4.27802 13.3109 4.88059 12.6215C5.50533 11.9062 5.93415 11.3646 6.35373 11.0042C6.62821 10.7695 7.05795 10.6355 7.45165 10.4839Z",
            fill: "currentColor",
            key: "svg-84-0"
          },
          []
        ]
      ]
    ],
    [
      "defs",
      { key: "svg-84-1" },
      [
        [
          "clipPath",
          { id: "clip0_198_3508", key: "svg-84-0" },
          [
            [
              "rect",
              {
                width: "24",
                height: "24",
                fill: "transparent",
                key: "svg-84-0"
              },
              []
            ]
          ]
        ]
      ]
    ]
  ],
  true
);

var IconRewardsCenter = createReactComponent(
  "rewardsCenter",
  "IconRewardsCenter",
  [
    [
      "g",
      { key: "svg-85-0", clipPath: "url(#clip0_16446_11516)" },
      [
        [
          "path",
          {
            d: "M2.61335 17.4751C1.3395 15.6277 0.593427 13.3882 0.593427 10.9745C0.593428 10.6376 0.608129 10.3041 0.636594 9.97465C0.530225 10.6281 0.47461 11.2995 0.474609 11.9843C0.474609 14.5741 1.26663 16.9723 2.61335 18.9331V17.4751Z",
            fill: "#519676",
            key: "svg-85-0"
          },
          []
        ],
        [
          "path",
          {
            d: "M4.7518 19.8099C4.50539 19.6059 4.26761 19.3918 4.03918 19.1682L4.03918 20.6435C4.26792 20.8708 4.5057 21.0885 4.7518 21.296L4.7518 19.8099Z",
            fill: "#519676",
            key: "svg-85-1"
          },
          []
        ],
        [
          "path",
          {
            d: "M18.8907 20.1827C16.9826 21.6007 14.6186 22.4398 12.0587 22.4398C9.49885 22.4398 7.13509 21.6008 5.22708 20.1829V21.6763C7.14242 23.1276 9.50403 23.9843 12.0588 23.9843C14.6137 23.9843 16.9753 23.1275 18.8907 21.6762V20.1827Z",
            fill: "#519676",
            key: "svg-85-2"
          },
          []
        ],
        [
          "path",
          {
            d: "M21.0293 18.1152C20.8044 18.3973 20.5665 18.6687 20.3164 18.9282V20.4C20.5659 20.1373 20.8038 19.8629 21.0293 19.5774V18.1152Z",
            fill: "#519676",
            key: "svg-85-3"
          },
          []
        ],
        [
          "path",
          {
            d: "M23.6429 11.9843C23.6429 11.2989 23.5874 10.6269 23.4809 9.97287C23.5095 10.3029 23.5241 10.637 23.5241 10.9745C23.5241 13.3881 22.7782 15.6274 21.5044 17.4748V18.933C22.8511 16.9722 23.6429 14.574 23.6429 11.9843Z",
            fill: "#519676",
            key: "svg-85-4"
          },
          []
        ],
        [
          "circle",
          {
            cx: "10.9901",
            cy: "10.9901",
            r: "10.9901",
            transform: "matrix(1 0 0 -1 1.06836 21.9653)",
            fill: "#68C097",
            key: "svg-85-5"
          },
          []
        ],
        [
          "path",
          {
            d: "M20.6313 10.8422C20.6313 15.5761 16.7937 19.4137 12.0598 19.4137C7.32598 19.4137 3.4884 15.5761 3.48839 10.8422C3.48839 6.10838 7.32598 2.2708 12.0598 2.27079V1.69939C7.01039 1.6994 2.91699 5.79279 2.91699 10.8422C2.917 15.8917 7.01039 19.9851 12.0598 19.9851C17.1093 19.9851 21.2027 15.8917 21.2027 10.8422C21.2027 5.79278 17.1093 1.69939 12.0598 1.69939V2.27079C16.7937 2.27079 20.6313 6.10838 20.6313 10.8422Z",
            fill: "#F2FBF9",
            key: "svg-85-6"
          },
          []
        ],
        [
          "path",
          {
            d: "M9.17657 14.496C9.06874 14.9843 9.5958 15.3658 10.026 15.1108L11.9574 13.9657C12.1364 13.8596 12.359 13.8592 12.5384 13.9647L14.474 15.1027C14.9051 15.3561 15.4307 14.9727 15.3211 14.4848L14.829 12.2941C14.7834 12.091 14.8518 11.8792 15.0075 11.7412L16.6879 10.252C17.0622 9.92033 16.86 9.30192 16.3621 9.25539L14.1265 9.04647C13.9193 9.0271 13.739 8.8966 13.6559 8.70581L12.7588 6.64746C12.5591 6.18903 11.9084 6.19022 11.7103 6.64937L10.8208 8.71097C10.7383 8.90206 10.5585 9.03322 10.3514 9.05334L8.11655 9.2704C7.61883 9.31874 7.4189 9.93788 7.79436 10.2682L9.48018 11.7512C9.63644 11.8887 9.70561 12.1003 9.66073 12.3035L9.17657 14.496Z",
            fill: "#F2FBF9",
            key: "svg-85-7"
          },
          []
        ]
      ]
    ],
    [
      "defs",
      { key: "svg-85-1" },
      [
        [
          "clipPath",
          { id: "clip0_16446_11516", key: "svg-85-0" },
          [
            [
              "rect",
              { width: "24", height: "24", fill: "white", key: "svg-85-0" },
              []
            ]
          ]
        ]
      ]
    ]
  ],
  true
);

var IconRewardsLeft = createReactComponent(
  "rewardsLeft",
  "IconRewardsLeft",
  [
    [
      "g",
      { key: "svg-86-0", clipPath: "url(#clip0_16446_11518)" },
      [
        [
          "path",
          {
            d: "M11.9677 22.8761C14.2045 23.0555 16.517 22.5819 18.6074 21.375C18.8991 21.2066 19.1805 21.0272 19.4516 20.8378C18.9389 21.2566 18.3852 21.6405 17.7922 21.9829C15.5494 23.2778 13.0765 23.7909 10.705 23.6051L11.9677 22.8761Z",
            fill: "#519676",
            key: "svg-86-0"
          },
          []
        ],
        [
          "path",
          {
            d: "M8.8764 22.1915C9.1763 22.3029 9.48059 22.4018 9.78845 22.4878L8.51087 23.2254C8.19958 23.141 7.89219 23.0439 7.58944 22.9346L8.8764 22.1915Z",
            fill: "#519676",
            key: "svg-86-1"
          },
          []
        ],
        [
          "path",
          {
            d: "M1.48412 10.1333C1.21013 12.4947 1.66544 14.9616 2.94541 17.1786C4.22534 19.3954 6.13387 21.023 8.3158 21.9664L7.02242 22.7131C4.80794 21.78 2.88517 20.1632 1.60776 17.9507C0.330342 15.7381 -0.108453 13.2644 0.190736 10.88L1.48412 10.1333Z",
            fill: "#519676",
            key: "svg-86-2"
          },
          []
        ],
        [
          "path",
          {
            d: "M2.20537 7.24743C2.07346 7.58329 1.95746 7.925 1.85771 8.27135L0.583079 9.00726C0.68582 8.65983 0.804571 8.31652 0.939088 7.97851L2.20537 7.24743Z",
            fill: "#519676",
            key: "svg-86-3"
          },
          []
        ],
        [
          "path",
          {
            d: "M6.20804 1.91858C6.80164 1.57587 7.41133 1.28787 8.03102 1.05313C7.73089 1.19342 7.43429 1.34781 7.14204 1.51654C5.05177 2.72335 3.48538 4.48898 2.52239 6.51576L1.25958 7.24485C2.28437 5.09822 3.96529 3.21343 6.20804 1.91858Z",
            fill: "#519676",
            key: "svg-86-4"
          },
          []
        ],
        [
          "circle",
          {
            cx: "12.8749",
            cy: "11.4458",
            r: "10.9901",
            fill: "#68C097",
            key: "svg-86-5"
          },
          []
        ],
        [
          "path",
          {
            d: "M21.561 11.3786C21.561 6.64471 17.7234 2.80712 12.9895 2.80712C8.25567 2.80712 4.41808 6.64471 4.41808 11.3786C4.41808 16.1124 8.25567 19.95 12.9895 19.95V20.5214C7.94008 20.5214 3.84668 16.428 3.84668 11.3786C3.84668 6.32912 7.94008 2.23572 12.9895 2.23572C18.039 2.23572 22.1324 6.32911 22.1324 11.3786C22.1324 16.428 18.039 20.5214 12.9895 20.5214V19.95C17.7234 19.95 21.561 16.1124 21.561 11.3786Z",
            fill: "#F2FBF9",
            key: "svg-86-6"
          },
          []
        ],
        [
          "path",
          {
            d: "M11.3166 7.1624C11.39 6.66776 12.0185 6.49936 12.3294 6.89103L13.7254 8.64961C13.8548 8.81262 14.0626 8.89239 14.2678 8.85783L16.482 8.48505C16.9751 8.40203 17.3295 8.94769 17.0531 9.36442L15.8119 11.2355C15.6969 11.409 15.6852 11.6312 15.7815 11.8158L16.8203 13.8063C17.0516 14.2497 16.6421 14.7553 16.1604 14.6212L13.9973 14.019C13.7968 13.9632 13.5818 14.0208 13.4361 14.1694L11.8639 15.7724C11.5138 16.1294 10.9064 15.8963 10.8851 15.3967L10.7893 13.1534C10.7805 12.9455 10.6593 12.7588 10.4729 12.6661L8.4625 11.6662C8.01475 11.4436 8.0488 10.7938 8.51737 10.6192L10.6213 9.83492C10.8163 9.76223 10.9564 9.58926 10.9869 9.38339L11.3166 7.1624Z",
            fill: "#F2FBF9",
            key: "svg-86-7"
          },
          []
        ]
      ]
    ],
    [
      "defs",
      { key: "svg-86-1" },
      [
        [
          "clipPath",
          { id: "clip0_16446_11518", key: "svg-86-0" },
          [
            [
              "rect",
              { width: "24", height: "24", fill: "white", key: "svg-86-0" },
              []
            ]
          ]
        ]
      ]
    ]
  ],
  true
);

var IconRewardsRight = createReactComponent(
  "rewardsRight",
  "IconRewardsRight",
  [
    [
      "g",
      { key: "svg-87-0", clipPath: "url(#clip0_16446_11517)" },
      [
        [
          "path",
          {
            d: "M11.9972 22.8761C9.76034 23.0555 7.44787 22.5819 5.35749 21.375C5.06576 21.2066 4.78433 21.0272 4.51322 20.8378C5.02597 21.2566 5.5796 21.6405 6.17267 21.9829C8.41548 23.2778 10.8884 23.7909 13.2599 23.6051L11.9972 22.8761Z",
            fill: "#519676",
            key: "svg-87-0"
          },
          []
        ],
        [
          "path",
          {
            d: "M15.0884 22.1915C14.7885 22.3029 14.4843 22.4018 14.1764 22.4878L15.454 23.2254C15.7653 23.141 16.0727 23.0439 16.3754 22.9346L15.0884 22.1915Z",
            fill: "#519676",
            key: "svg-87-1"
          },
          []
        ],
        [
          "path",
          {
            d: "M22.4807 10.1333C22.7547 12.4947 22.2994 14.9616 21.0194 17.1786C19.7395 19.3954 17.831 21.023 15.649 21.9664L16.9424 22.7131C19.1569 21.78 21.0797 20.1632 22.3571 17.9507C23.6345 15.7381 24.0733 13.2644 23.7741 10.88L22.4807 10.1333Z",
            fill: "#519676",
            key: "svg-87-2"
          },
          []
        ],
        [
          "path",
          {
            d: "M21.7595 7.24743C21.8914 7.58329 22.0074 7.925 22.1071 8.27135L23.3818 9.00726C23.279 8.65983 23.1603 8.31652 23.0258 7.97851L21.7595 7.24743Z",
            fill: "#519676",
            key: "svg-87-3"
          },
          []
        ],
        [
          "path",
          {
            d: "M17.7568 1.91858C17.1632 1.57587 16.5535 1.28787 15.9338 1.05313C16.2339 1.19342 16.5306 1.34781 16.8228 1.51654C18.9131 2.72335 20.4795 4.48898 21.4425 6.51576L22.7053 7.24485C21.6805 5.09822 19.9995 3.21343 17.7568 1.91858Z",
            fill: "#519676",
            key: "svg-87-4"
          },
          []
        ],
        [
          "circle",
          {
            cx: "10.9901",
            cy: "10.9901",
            r: "10.9901",
            transform: "matrix(-1 0 0 1 22.0811 0.455688)",
            fill: "#68C097",
            key: "svg-87-5"
          },
          []
        ],
        [
          "path",
          {
            d: "M2.40483 11.3786C2.40483 6.64471 6.24241 2.80712 10.9763 2.80712C15.7102 2.80712 19.5477 6.64471 19.5477 11.3786C19.5477 16.1124 15.7102 19.95 10.9763 19.95V20.5214C16.0257 20.5214 20.1191 16.428 20.1191 11.3786C20.1191 6.32912 16.0257 2.23572 10.9763 2.23572C5.92682 2.23572 1.83343 6.32911 1.83343 11.3786C1.83343 16.428 5.92682 20.5214 10.9763 20.5214V19.95C6.24241 19.95 2.40483 16.1124 2.40483 11.3786Z",
            fill: "#F2FBF9",
            key: "svg-87-6"
          },
          []
        ],
        [
          "path",
          {
            d: "M12.6482 7.1624C12.5748 6.66776 11.9464 6.49936 11.6354 6.89103L10.2394 8.64961C10.11 8.81262 9.90225 8.89239 9.69702 8.85783L7.48286 8.48505C6.98973 8.40203 6.63538 8.94769 6.91179 9.36442L8.15292 11.2355C8.26797 11.409 8.27962 11.6312 8.18333 11.8158L7.14459 13.8063C6.91324 14.2497 7.32269 14.7553 7.80444 14.6212L9.9675 14.019C10.168 13.9632 10.383 14.0208 10.5287 14.1694L12.1009 15.7724C12.451 16.1294 13.0585 15.8963 13.0798 15.3967L13.1755 13.1534C13.1844 12.9455 13.3056 12.7588 13.4919 12.6661L15.5023 11.6662C15.9501 11.4436 15.916 10.7938 15.4475 10.6192L13.3436 9.83492C13.1485 9.76223 13.0085 9.58926 12.9779 9.38339L12.6482 7.1624Z",
            fill: "#F2FBF9",
            key: "svg-87-7"
          },
          []
        ]
      ]
    ],
    [
      "defs",
      { key: "svg-87-1" },
      [
        [
          "clipPath",
          { id: "clip0_16446_11517", key: "svg-87-0" },
          [
            [
              "rect",
              { width: "24", height: "24", fill: "white", key: "svg-87-0" },
              []
            ]
          ]
        ]
      ]
    ]
  ],
  true
);

var IconRewardsSimple = createReactComponent(
  "rewardsSimple",
  "IconRewardsSimple",
  [
    [
      "g",
      { key: "svg-88-0", clipPath: "url(#clip0_16446_11515)" },
      [
        [
          "path",
          {
            d: "M11.3242 5.40723C11.5966 4.84033 12.4034 4.84033 12.6758 5.40723L14.1387 8.45117C14.248 8.67864 14.4647 8.8355 14.7148 8.86914L18.0615 9.31934C18.6846 9.40333 18.934 10.1712 18.4795 10.6055L16.0361 12.9365C15.8535 13.1108 15.7711 13.3659 15.8164 13.6143L16.4219 16.9365C16.5346 17.5552 15.8817 18.0299 15.3281 17.7314L12.3564 16.1279C12.1342 16.0081 11.8658 16.0081 11.6436 16.1279L8.67188 17.7314C8.11834 18.0299 7.4654 17.5552 7.57812 16.9365L8.18359 13.6143C8.22891 13.3659 8.14652 13.1108 7.96387 12.9365L5.52051 10.6055C5.06595 10.1712 5.31541 9.40333 5.93848 9.31934L9.28516 8.86914C9.53531 8.8355 9.75196 8.67864 9.86133 8.45117L11.3242 5.40723Z",
            fill: "currentColor",
            key: "svg-88-0"
          },
          []
        ],
        [
          "path",
          {
            d: "M12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0ZM12 2.18164C6.57757 2.18164 2.18164 6.57757 2.18164 12C2.18164 17.4224 6.57757 21.8184 12 21.8184C17.4224 21.8184 21.8184 17.4224 21.8184 12C21.8184 6.57757 17.4224 2.18164 12 2.18164Z",
            fill: "currentColor",
            key: "svg-88-1",
            fillRule: "evenodd",
            clipRule: "evenodd"
          },
          []
        ]
      ]
    ],
    [
      "defs",
      { key: "svg-88-1" },
      [
        [
          "clipPath",
          { id: "clip0_16446_11515", key: "svg-88-0" },
          [
            [
              "rect",
              { width: "24", height: "24", fill: "white", key: "svg-88-0" },
              []
            ]
          ]
        ]
      ]
    ]
  ],
  true
);

var IconRotateLeft = createReactComponent(
  "rotateLeft",
  "IconRotateLeft",
  [
    [
      "g",
      { key: "svg-89-0", clipPath: "url(#clip0_985_10302)" },
      [
        [
          "path",
          {
            d: "M11.2274 1.34349C11.3581 2.02135 10.9146 2.67685 10.2367 2.80757C5.9714 3.63013 2.75 7.38519 2.75 11.8899C2.75 16.9986 6.89137 21.1399 12 21.1399C17.1086 21.1399 21.25 16.9986 21.25 11.8899C21.25 9.33532 20.2161 7.02456 18.5408 5.34928L18.5242 5.33263L18.25 5.03699V6.88994C18.25 7.5803 17.6904 8.13994 17 8.13994C16.3096 8.13994 15.75 7.5803 15.75 6.88994V2.03994C15.75 1.26674 16.3768 0.639941 17.15 0.639941H22C22.6904 0.639941 23.25 1.19959 23.25 1.88994C23.25 2.5803 22.6904 3.13994 22 3.13994H19.9003L20.3257 3.59864C22.4406 5.72225 23.75 8.65436 23.75 11.8899C23.75 18.3793 18.4893 23.6399 12 23.6399C5.51065 23.6399 0.25 18.3793 0.25 11.8899C0.25 6.16453 4.34372 1.39796 9.7633 0.352803C10.4412 0.222077 11.0967 0.665622 11.2274 1.34349Z",
            fill: "currentColor",
            key: "svg-89-0",
            fillRule: "evenodd",
            clipRule: "evenodd"
          },
          []
        ]
      ]
    ],
    [
      "defs",
      { key: "svg-89-1" },
      [
        [
          "clipPath",
          { id: "clip0_985_10302", key: "svg-89-0" },
          [
            [
              "rect",
              { width: "24", height: "24", fill: "white", key: "svg-89-0" },
              []
            ]
          ]
        ]
      ]
    ]
  ],
  true
);

var IconRotateRight = createReactComponent(
  "rotateRight",
  "IconRotateRight",
  [
    [
      "g",
      { key: "svg-90-0", clipPath: "url(#clip0_4343_545)" },
      [
        [
          "path",
          {
            d: "M12.7726 1.34349C12.6419 2.02135 13.0854 2.67685 13.7633 2.80757C18.0286 3.63013 21.25 7.38519 21.25 11.8899C21.25 16.9986 17.1086 21.1399 12 21.1399C6.89137 21.1399 2.75 16.9986 2.75 11.8899C2.75 9.33532 3.78394 7.02456 5.45919 5.34928L5.47583 5.33263L5.75 5.03699V6.88994C5.75 7.5803 6.30964 8.13994 7 8.13994C7.69036 8.13994 8.25 7.5803 8.25 6.88994V2.03994C8.25 1.26674 7.62319 0.639941 6.85 0.639941H2C1.30964 0.639941 0.75 1.19959 0.75 1.88994C0.75 2.5803 1.30964 3.13994 2 3.13994H4.09971L3.67432 3.59864C1.55944 5.72225 0.25 8.65436 0.25 11.8899C0.25 18.3793 5.51065 23.6399 12 23.6399C18.4893 23.6399 23.75 18.3793 23.75 11.8899C23.75 6.16453 19.6563 1.39796 14.2367 0.352803C13.5588 0.222077 12.9033 0.665622 12.7726 1.34349Z",
            fill: "currentColor",
            key: "svg-90-0",
            fillRule: "evenodd",
            clipRule: "evenodd"
          },
          []
        ]
      ]
    ],
    [
      "defs",
      { key: "svg-90-1" },
      [
        [
          "clipPath",
          { id: "clip0_4343_545", key: "svg-90-0" },
          [
            [
              "rect",
              { width: "24", height: "24", fill: "white", key: "svg-90-0" },
              []
            ]
          ]
        ]
      ]
    ]
  ],
  true
);

var IconScience = createReactComponent(
  "science",
  "IconScience",
  [
    [
      "path",
      {
        d: "M15.6499 1.00006C16.5909 1.00006 17.4306 1.38723 18.0366 1.99323C18.8277 2.78433 19.2287 3.95564 18.9321 5.18463L18.9302 5.19244C18.6478 6.32193 17.8088 7.13271 16.8062 7.5069L20.5161 15.9991L20.646 16.3106C21.2687 17.8754 21.4406 19.5146 20.6958 20.8438C19.8727 22.3128 18.169 23 15.9302 23.0001H8.26026C6.00429 23.0001 4.29414 22.312 3.47705 20.834C2.69044 19.4111 2.95582 17.638 3.68506 15.9864L7.40381 7.54108C6.93499 7.37324 6.51054 7.10484 6.1626 6.7569C5.53564 6.13951 5.16947 5.28511 5.16944 4.37018C5.16944 2.52076 6.67469 1.00025 8.53955 1.00006H15.6499ZM5.51514 16.793C4.88446 18.2213 4.88969 19.2542 5.22803 19.8663C5.53604 20.4232 6.33652 21.0001 8.26026 21.0001H15.9302C17.8309 21 18.6374 20.4272 18.9517 19.8663C19.2946 19.2542 19.3077 18.2248 18.6841 16.8018L18.6831 16.8008L17.6372 14.4073C17.3158 14.5608 16.9118 14.733 16.4448 14.8829C15.2455 15.2678 13.5559 15.5399 11.7837 14.9493C10.3847 14.483 8.95436 14.2728 7.86182 14.1817C7.39441 14.1428 6.99374 14.1276 6.69092 14.1212L5.51514 16.793ZM8.53955 3.00006C7.78474 3.00025 7.16944 3.61983 7.16944 4.37018C7.16946 4.70324 7.28616 5.00657 7.48096 5.23932L7.56885 5.33502L7.57666 5.34283L7.67334 5.43073C7.90872 5.62367 8.21635 5.74029 8.5503 5.7403H8.8501C9.18776 5.74037 9.50241 5.91071 9.68702 6.19342C9.87154 6.47631 9.90112 6.83349 9.76514 7.14264L7.55713 12.1534C7.706 12.1625 7.8632 12.1748 8.02784 12.1885C9.21511 12.2875 10.8148 12.5183 12.4155 13.0518C13.6424 13.4608 14.8681 13.2884 15.8335 12.9786C16.2328 12.8504 16.5749 12.7012 16.8364 12.5733L14.4634 7.14069C14.3283 6.83152 14.3587 6.47475 14.5435 6.19244C14.7282 5.91025 15.0431 5.7403 15.3804 5.7403H15.5396C16.2551 5.7403 16.8459 5.28232 16.9897 4.70709C17.1094 4.19936 16.9496 3.73437 16.6226 3.40729C16.3686 3.15335 16.0288 3.00006 15.6499 3.00006H8.53955Z",
        fill: "currentColor",
        key: "svg-91-0",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ]
  ],
  true
);

var IconSearch = createReactComponent(
  "search",
  "IconSearch",
  [
    [
      "path",
      {
        fill: "currentColor",
        d: "M17.3821 19.4517C15.5628 20.8364 13.292 21.6585 10.8293 21.6585C4.84843 21.6585 0 16.8101 0 10.8293C0 4.84843 4.84843 0 10.8293 0C16.8101 0 21.6585 4.84843 21.6585 10.8293C21.6585 13.292 20.8364 15.5628 19.4517 17.3821L23.5714 21.5018C24.1429 22.0733 24.1429 22.9999 23.5714 23.5714C22.9999 24.1429 22.0733 24.1429 21.5018 23.5714L17.3821 19.4517ZM2.92683 10.8293C2.92683 6.46487 6.46487 2.92683 10.8293 2.92683C15.1937 2.92683 18.7317 6.46487 18.7317 10.8293C18.7317 12.9509 17.8957 14.8772 16.535 16.2967C16.4915 16.3313 16.4494 16.3688 16.4091 16.4091C16.3688 16.4494 16.3313 16.4915 16.2967 16.535C14.8772 17.8957 12.9509 18.7317 10.8293 18.7317C6.46487 18.7317 2.92683 15.1937 2.92683 10.8293Z",
        key: "svg-92-0",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ]
  ],
  true
);

var IconSearching = createReactComponent(
  "searching",
  "IconSearching",
  [
    [
      "path",
      {
        d: "M7.67073 2.07317C4.57929 2.07317 2.07317 4.57929 2.07317 7.67073C2.07317 10.7622 4.57929 13.2683 7.67073 13.2683C10.7622 13.2683 13.2683 10.7622 13.2683 7.67073C13.2683 4.57929 10.7622 2.07317 7.67073 2.07317ZM0 7.67073C0 3.4343 3.4343 0 7.67073 0C11.9072 0 15.3415 3.4343 15.3415 7.67073C15.3415 11.9072 11.9072 15.3415 7.67073 15.3415C3.4343 15.3415 0 11.9072 0 7.67073Z",
        fill: "currentColor",
        key: "svg-93-0"
      },
      []
    ],
    [
      "path",
      {
        d: "M11.6239 11.6229C12.0287 11.2181 12.6851 11.2181 13.0899 11.6229L16.6972 15.2303C17.102 15.6351 17.102 16.2914 16.6972 16.6962C16.2924 17.101 15.6361 17.101 15.2312 16.6962L11.6239 13.0889C11.2191 12.6841 11.2191 12.0278 11.6239 11.6229Z",
        fill: "currentColor",
        key: "svg-93-1"
      },
      []
    ]
  ],
  true
);

var IconSecurityShield = createReactComponent(
  "securityShield",
  "IconSecurityShield",
  [
    [
      "path",
      {
        d: "M11.7427 24C5.2469 21.0841 1.99902 18.175 1.99902 15.2727V4.36364C1.99902 3.52626 2.31796 3.33165 3.20066 2.79304L3.20067 2.79304C3.46793 2.62996 3.78686 2.43535 4.16428 2.18182C4.33944 2.06415 8.0219 0 11.7427 0C14.9854 0 17.6971 1.09091 19.3211 2.18182C19.6985 2.43535 20.0174 2.62997 20.2847 2.79304C21.1674 3.33165 21.4863 3.52626 21.4863 4.36364C21.5076 4.60062 21.4972 9.64049 21.4904 12.8669C21.4882 13.9672 21.4863 14.8566 21.4863 15.2727C21.4863 18.1818 18.2384 21.0909 11.7427 24ZM19.3208 15.2728C19.3208 15.0215 19.3215 14.6006 19.3228 13.9143L19.3272 11.7834C19.3286 11.0941 19.3297 10.5025 19.3306 9.93801C19.3346 7.50294 19.3335 5.41296 19.3312 4.76656L19.1824 4.67348C18.8323 4.45464 18.3761 4.16944 18.1198 3.99727C16.5215 2.92361 14.1894 2.18188 11.7424 2.18188C9.4019 2.18188 6.36032 3.32873 5.36513 3.99727C5.10883 4.16944 4.65259 4.45465 4.30251 4.67349L4.30243 4.67354L4.16406 4.76007V15.2728C4.16406 16.9184 6.57736 19.166 11.7435 21.6022C16.9089 19.1714 19.3208 16.9247 19.3208 15.2728ZM15.3079 7.95593L10.6603 12.6391L8.17794 10.1378L6.64687 11.6805L10.6603 15.7246L16.839 9.49871L15.3079 7.95593Z",
        fill: "currentColor",
        key: "svg-94-0",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ]
  ],
  true
);

var IconSettings = createReactComponent(
  "settings",
  "IconSettings",
  [
    [
      "g",
      { key: "svg-95-0", clipPath: "url(#clip0_187_7270)" },
      [
        [
          "path",
          {
            d: "M17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12ZM15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z",
            fill: "currentColor",
            key: "svg-95-0",
            fillRule: "evenodd",
            clipRule: "evenodd"
          },
          []
        ],
        [
          "path",
          {
            d: "M8.55209 2.06021C9.95503 -0.686738 13.8803 -0.686738 15.2832 2.06021C15.9609 3.38712 17.355 4.192 18.843 4.11544C21.9234 3.95695 23.886 7.35631 22.2085 9.94478C21.3983 11.1951 21.3983 12.8049 22.2085 14.0552C23.886 16.6437 21.9234 20.0431 18.843 19.8846C17.355 19.808 15.9609 20.6129 15.2832 21.9398C13.8803 24.6867 9.95503 24.6867 8.55208 21.9398C7.8744 20.6129 6.48031 19.808 4.99234 19.8846C1.91193 20.0431 -0.050693 16.6437 1.62676 14.0552C2.43705 12.8049 2.43705 11.1951 1.62676 9.94478C-0.0506928 7.35631 1.91193 3.95695 4.99234 4.11544C6.48031 4.192 7.8744 3.38712 8.55209 2.06021ZM4.88957 6.1128C7.16503 6.22987 9.29689 4.99904 10.3332 2.9699C10.9937 1.6767 12.8416 1.6767 13.5021 2.9699C14.5384 4.99904 16.6703 6.22987 18.9457 6.1128C20.3959 6.03818 21.3199 7.63852 20.5302 8.8571C19.2911 10.7692 19.2911 13.2308 20.5302 15.1429C21.3199 16.3615 20.3959 17.9618 18.9457 17.8872C16.6703 17.7701 14.5384 19.001 13.5021 21.0301C12.8416 22.3233 10.9937 22.3233 10.3332 21.0301C9.29689 19.001 7.16503 17.7701 4.88957 17.8872C3.43939 17.9618 2.51544 16.3615 3.30514 15.1429C4.54426 13.2308 4.54426 10.7692 3.30514 8.8571C2.51544 7.63852 3.43939 6.03818 4.88957 6.1128Z",
            fill: "currentColor",
            key: "svg-95-1",
            fillRule: "evenodd",
            clipRule: "evenodd"
          },
          []
        ]
      ]
    ],
    [
      "defs",
      { key: "svg-95-1" },
      [
        [
          "clipPath",
          { id: "clip0_187_7270", key: "svg-95-0" },
          [
            [
              "rect",
              {
                width: "24",
                height: "24",
                fill: "transparent",
                key: "svg-95-0"
              },
              []
            ]
          ]
        ]
      ]
    ]
  ],
  true
);

var IconShare = createReactComponent(
  "share",
  "IconShare",
  [
    [
      "path",
      {
        d: "M20.5706 3.42906L3.92116 8.59613L11.5452 11.8636C11.8107 11.9774 12.0223 12.1889 12.1361 12.4545L15.4035 20.0785L20.5706 3.42906ZM21.186 1.40573C22.0509 1.13731 22.8624 1.94872 22.5939 2.81362L16.5719 22.2178C16.2619 23.2168 14.8755 23.289 14.4635 22.3275L10.6261 13.3736L1.67214 9.5362C0.710685 9.12415 0.782827 7.73776 1.78185 7.42772L21.186 1.40573Z",
        fill: "currentColor",
        key: "svg-96-0",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ],
    [
      "path",
      {
        d: "M21.8107 3.4264L11.9112 13.3259L10.6738 12.0885L20.5733 2.18896L21.8107 3.4264Z",
        fill: "currentColor",
        key: "svg-96-1",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ]
  ],
  true
);

var IconSheet = createReactComponent(
  "sheet",
  "IconSheet",
  [
    [
      "path",
      {
        d: "M19.4282 22.2143H4.57101C3.97928 22.2143 3.49958 21.7346 3.49958 21.1429V2.85714C3.49958 2.26541 3.97928 1.78571 4.57101 1.78571H19.4282C20.0199 1.78571 20.4996 2.26541 20.4996 2.85714V21.1429C20.4996 21.7346 20.0199 22.2143 19.4282 22.2143ZM4.57101 24C2.99305 24 1.71387 22.7208 1.71387 21.1429V2.85714C1.71387 1.27919 2.99305 0 4.57101 0H19.4282C21.0061 0 22.2853 1.27919 22.2853 2.85714V21.1429C22.2853 22.7208 21.0061 24 19.4282 24H4.57101Z",
        fill: "currentColor",
        key: "svg-97-0",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ],
    [
      "path",
      {
        d: "M5.99958 5.14286C5.99958 4.66947 6.38334 4.28571 6.85672 4.28571H11.9996C12.473 4.28571 12.8567 4.66947 12.8567 5.14286C12.8567 5.61624 12.473 6 11.9996 6H6.85672C6.38334 6 5.99958 5.61624 5.99958 5.14286Z",
        fill: "currentColor",
        key: "svg-97-1",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ],
    [
      "path",
      {
        d: "M5.99958 18.8571C5.99958 18.3838 6.38334 18 6.85672 18H11.9996C12.473 18 12.8567 18.3838 12.8567 18.8571C12.8567 19.3305 12.473 19.7143 11.9996 19.7143H6.85672C6.38334 19.7143 5.99958 19.3305 5.99958 18.8571Z",
        fill: "currentColor",
        key: "svg-97-2",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ],
    [
      "path",
      {
        d: "M5.99958 15.4286C5.99958 14.9552 6.38334 14.5714 6.85672 14.5714H17.1424C17.6158 14.5714 17.9996 14.9552 17.9996 15.4286C17.9996 15.902 17.6158 16.2857 17.1424 16.2857H6.85672C6.38334 16.2857 5.99958 15.902 5.99958 15.4286Z",
        fill: "currentColor",
        key: "svg-97-3",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ],
    [
      "path",
      {
        d: "M5.99958 12C5.99958 11.5266 6.38334 11.1429 6.85672 11.1429H13.7139C14.1873 11.1429 14.571 11.5266 14.571 12C14.571 12.4734 14.1873 12.8571 13.7139 12.8571H6.85672C6.38334 12.8571 5.99958 12.4734 5.99958 12Z",
        fill: "currentColor",
        key: "svg-97-4",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ],
    [
      "path",
      {
        d: "M5.99958 8.57143C5.99958 8.09804 6.38334 7.71429 6.85672 7.71429H17.1424C17.6158 7.71429 17.9996 8.09804 17.9996 8.57143C17.9996 9.04482 17.6158 9.42857 17.1424 9.42857H6.85672C6.38334 9.42857 5.99958 9.04482 5.99958 8.57143Z",
        fill: "currentColor",
        key: "svg-97-5",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ]
  ],
  true
);

var IconShopping = createReactComponent(
  "shopping",
  "IconShopping",
  [
    [
      "path",
      {
        d: "M5.44236 0C5.06359 0 4.70693 0.178333 4.47966 0.48135L1.24722 4.79127C1.09218 4.99386 1 5.24736 1 5.52204V20.6373C1 21.5291 1.35428 22.3845 1.98491 23.0151C2.61554 23.6457 3.47086 24 4.3627 24H19.478C20.3698 24 21.2251 23.6457 21.8558 23.0151C22.4864 22.3845 22.8407 21.5291 22.8407 20.6373V5.52202C22.8407 5.24736 22.7481 4.99335 22.5931 4.79077L19.361 0.48135C19.1338 0.178333 18.7771 0 18.3983 0H5.44236ZM4.61011 4.31866L6.04405 2.40675H17.7966L19.2306 4.31866H4.61011ZM3.40675 20.6373V6.72541H20.4339V20.6373C20.4339 20.8908 20.3332 21.134 20.1539 21.3133C19.9747 21.4925 19.7315 21.5933 19.478 21.5933H4.3627C4.10916 21.5933 3.86602 21.4925 3.68674 21.3133C3.50746 21.134 3.40675 20.8908 3.40675 20.6373ZM7.60125 8.63732C6.93664 8.63732 6.39787 9.17609 6.39787 9.8407C6.39787 11.3052 6.97966 12.7098 8.01524 13.7454C9.05082 14.7809 10.4554 15.3627 11.9199 15.3627C13.3844 15.3627 14.789 14.7809 15.8246 13.7454C16.8601 12.7098 17.4419 11.3052 17.4419 9.8407C17.4419 9.17609 16.9032 8.63732 16.2385 8.63732C15.5739 8.63732 15.0352 9.17609 15.0352 9.8407C15.0352 10.6669 14.707 11.4593 14.1227 12.0435C13.5385 12.6278 12.7461 12.956 11.9199 12.956C11.0937 12.956 10.3013 12.6278 9.71706 12.0435C9.13284 11.4593 8.80462 10.6669 8.80462 9.8407C8.80462 9.17609 8.26585 8.63732 7.60125 8.63732Z",
        fill: "currentColor",
        key: "svg-98-0",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ]
  ],
  true
);

var IconShoppingCart = createReactComponent(
  "shoppingCart",
  "IconShoppingCart",
  [
    [
      "path",
      {
        d: "M1.22449 0C0.548222 0 0 0.548222 0 1.22449C0 1.90076 0.548222 2.44898 1.22449 2.44898H4.13916L4.91345 6.31754C4.91844 6.34866 4.92461 6.37941 4.9319 6.40973L6.56737 14.581C6.71313 15.3134 7.11171 15.9712 7.69343 16.4395C8.27206 16.9053 8.99524 17.154 9.7377 17.1428H19.2386C19.9811 17.154 20.7043 16.9053 21.2829 16.4395C21.8649 15.971 22.2636 15.3127 22.4092 14.5798L22.4096 14.5779L23.9783 6.35183C24.0467 5.99336 23.9516 5.62308 23.719 5.3419C23.4863 5.06072 23.1404 4.89796 22.7755 4.89796H7.12687L6.34353 0.984175C6.22899 0.4119 5.72648 0 5.14285 0H1.22449ZM8.96912 14.1023L7.61703 7.34694H21.2954L20.0067 14.105L20.0064 14.1063C19.9722 14.274 19.8806 14.4245 19.7472 14.5318C19.6129 14.64 19.4448 14.6974 19.2724 14.6941L19.2701 14.6941L19.2513 14.6939L9.72734 14.6939L9.70623 14.6941L9.70388 14.6941C9.53148 14.6974 9.36342 14.64 9.2291 14.5318C9.09479 14.4237 9.00271 14.2714 8.96912 14.1023ZM9.06122 18.6122C7.84394 18.6122 6.85714 19.599 6.85714 20.8163C6.85714 22.0336 7.84394 23.0204 9.06122 23.0204C10.2785 23.0204 11.2653 22.0336 11.2653 20.8163C11.2653 19.599 10.2785 18.6122 9.06122 18.6122ZM19.8367 18.6122C18.6194 18.6122 17.6326 19.599 17.6326 20.8163C17.6326 22.0336 18.6194 23.0204 19.8367 23.0204C21.054 23.0204 22.0408 22.0336 22.0408 20.8163C22.0408 19.599 21.054 18.6122 19.8367 18.6122Z",
        fill: "currentColor",
        key: "svg-99-0",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ]
  ],
  true
);

var IconSingleLineA = createReactComponent(
  "single-line-a",
  "IconSingleLineA",
  [
    [
      "g",
      { key: "svg-100-0", clipPath: "url(#clip0_15351_342572)" },
      [
        [
          "path",
          {
            d: "M12.4629 3.30769C12.292 2.89744 11.7108 2.89744 11.5398 3.30769L3.38598 22.8769C3.06736 23.6416 2.18915 24.0032 1.42444 23.6846C0.659743 23.366 0.298127 22.4878 0.616752 21.7231L8.7706 2.15385C9.96718 -0.71795 14.0356 -0.717948 15.2321 2.15385L23.386 21.7231C23.7046 22.4878 23.343 23.366 22.5783 23.6846C21.8136 24.0032 20.9354 23.6416 20.6168 22.8769L12.4629 3.30769Z",
            fill: "currentColor",
            key: "svg-100-0",
            fillRule: "evenodd",
            clipRule: "evenodd"
          },
          []
        ],
        [
          "path",
          {
            d: "M5.50137 13.8C5.50137 12.9716 6.17294 12.3 7.00137 12.3L17.0014 12.3C17.8298 12.3 18.5014 12.9716 18.5014 13.8C18.5014 14.6284 17.8298 15.3 17.0014 15.3L7.00137 15.3C6.17294 15.3 5.50137 14.6284 5.50137 13.8Z",
            fill: "currentColor",
            key: "svg-100-1",
            fillRule: "evenodd",
            clipRule: "evenodd"
          },
          []
        ]
      ]
    ],
    [
      "defs",
      { key: "svg-100-1" },
      [
        [
          "clipPath",
          { id: "clip0_15351_342572", key: "svg-100-0" },
          [
            [
              "rect",
              { width: "24", height: "24", fill: "white", key: "svg-100-0" },
              []
            ]
          ]
        ]
      ]
    ]
  ],
  true
);

var IconSingleSelect = createReactComponent(
  "singleSelect",
  "IconSingleSelect",
  [
    [
      "g",
      { key: "svg-101-0", clipPath: "url(#clip0_15351_342569)" },
      [
        [
          "path",
          {
            d: "M12.0542 0C15.1605 0.000341557 17.6792 2.51861 17.6792 5.625C17.6792 8.73139 15.1605 11.2497 12.0542 11.25H5.625C2.5184 11.25 0 8.7316 0 5.625C0 2.5184 2.5184 0 5.625 0H12.0542ZM12.2783 2.37598C11.9241 2.07658 11.3943 2.12153 11.0947 2.47559L7.6377 6.55811L6.27393 5.31885C5.93071 5.00688 5.39953 5.0315 5.0874 5.37451C4.77577 5.71761 4.80049 6.24894 5.14307 6.56104L7.15283 8.3877C7.32137 8.54066 7.54533 8.61925 7.77246 8.60449C7.99961 8.58951 8.21124 8.48227 8.3584 8.30859L12.3765 3.56104C12.676 3.20702 12.632 2.67576 12.2783 2.37598Z",
            fill: "currentColor",
            key: "svg-101-0",
            fillRule: "evenodd",
            clipRule: "evenodd"
          },
          []
        ],
        [
          "path",
          {
            d: "M18.0542 22.125V24H11.625V22.125H18.0542ZM21.8042 18.375C21.8042 16.3041 20.125 14.6253 18.0542 14.625H11.625C9.55393 14.625 7.875 16.3039 7.875 18.375C7.875 20.4461 9.55393 22.125 11.625 22.125V24C8.5184 24 6 21.4816 6 18.375C6 15.3657 8.36315 12.9083 11.335 12.7573L11.625 12.75H18.0542L18.3428 12.7573C21.315 12.9079 23.6792 15.3654 23.6792 18.375L23.6719 18.665C23.5258 21.5411 21.2189 23.847 18.3428 23.9927L18.0542 24V22.125C20.125 22.1247 21.8042 20.4459 21.8042 18.375Z",
            fill: "currentColor",
            key: "svg-101-1"
          },
          []
        ]
      ]
    ],
    [
      "defs",
      { key: "svg-101-1" },
      [
        [
          "clipPath",
          { id: "clip0_15351_342569", key: "svg-101-0" },
          [
            [
              "rect",
              { width: "24", height: "24", fill: "white", key: "svg-101-0" },
              []
            ]
          ]
        ]
      ]
    ]
  ],
  true
);

var IconSms = createReactComponent(
  "sms",
  "IconSms",
  [
    [
      "path",
      {
        d: "M21.6 0H2.4C1.08 0 0 1.08 0 2.4V24L4.8 19.2H21.6C22.92 19.2 24 18.12 24 16.8V2.4C24 1.08 22.92 0 21.6 0ZM21.6 16.8H3.804L2.4 18.204V2.4H21.6V16.8ZM8.4 8.4H6V10.8H8.4V8.4ZM15.6 8.4H18V10.8H15.6V8.4ZM13.2 8.4H10.8V10.8H13.2V8.4Z",
        fill: "currentColor",
        key: "svg-102-0",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ]
  ],
  true
);

var IconSports = createReactComponent(
  "sports",
  "IconSports",
  [
    [
      "path",
      {
        d: "M-5.24537e-07 12C-3.87843e-07 8.70103 1.33245 5.71122 3.48633 3.54297L3.90332 3.14258C6.03675 1.19143 8.88014 -3.88164e-07 12 -5.24537e-07C15.1198 -6.60909e-07 17.9633 1.19143 20.0967 3.14258L20.5137 3.54297C22.6675 5.71121 24 8.70102 24 12C24 15.093 22.8285 17.9139 20.9072 20.041L20.5137 20.457C18.341 22.6441 15.3278 24 12 24C8.67216 24 5.65897 22.6441 3.48633 20.457L3.09277 20.041C1.17147 17.9139 -3.89339e-07 15.093 -5.24537e-07 12ZM17.6572 13C17.8533 14.9764 18.6261 16.7817 19.8037 18.25C20.9814 16.7817 21.7541 14.9765 21.9502 13L17.6572 13ZM21.9502 11C21.7541 9.02377 20.9812 7.21924 19.8037 5.75098C18.6264 7.21919 17.8533 9.02389 17.6572 11L21.9502 11ZM13 21.9502C15.0417 21.7476 16.902 20.9316 18.3955 19.6875C16.857 17.8455 15.8587 15.5345 15.6494 13L13 13L13 21.9502ZM15.6494 11C15.8586 8.46579 16.8573 6.15544 18.3955 4.31348C16.9019 3.06912 15.0419 2.25237 13 2.0498L13 11L15.6494 11ZM5.60351 4.31348C7.142 6.1555 8.14035 8.46561 8.34961 11L11 11L11 2.0498C8.9578 2.2524 7.09723 3.06885 5.60351 4.31348ZM5.60352 19.6875C7.09715 20.9319 8.95803 21.7476 11 21.9502L11 13L8.34961 13C8.14033 15.5347 7.14227 17.8454 5.60352 19.6875ZM2.04883 13C2.24488 14.9764 3.01776 16.7817 4.19531 18.25C5.37312 16.7816 6.1457 14.9766 6.3418 13L2.04883 13ZM6.3418 11C6.14572 9.02371 5.37285 7.21925 4.19531 5.75098C3.01802 7.21917 2.24485 9.02394 2.04883 11L6.3418 11Z",
        fill: "currentColor",
        key: "svg-103-0"
      },
      []
    ]
  ],
  true
);

var IconStar = createReactComponent(
  "star",
  "IconStar",
  [
    [
      "g",
      { key: "svg-104-0", clipPath: "url(#clip0_1058_6376)" },
      [
        [
          "path",
          {
            d: "M24 10.9074H14.6469L19.6754 5.86975L18.1302 4.32461L13.4766 8.97829L13.0925 8.35658V0H10.9074V8.35658L10.5326 8.97829L5.87879 4.32461L4.33371 5.86975L9.36228 10.9074H0V13.0926H9.36228L4.33371 18.1211L5.87879 19.6663L10.6148 14.9303L10.9074 15.3874V24H13.0925V15.3874L13.3943 14.9303L18.1302 19.6663L19.6754 18.1211L14.6469 13.0926H24V10.9074Z",
            fill: "currentColor",
            key: "svg-104-0"
          },
          []
        ]
      ]
    ],
    [
      "defs",
      { key: "svg-104-1" },
      [
        [
          "clipPath",
          { id: "clip0_1058_6376", key: "svg-104-0" },
          [
            [
              "rect",
              {
                width: "24",
                height: "24",
                fill: "transparent",
                key: "svg-104-0"
              },
              []
            ]
          ]
        ]
      ]
    ]
  ],
  true
);

var IconStarGroup = createReactComponent(
  "starGroup",
  "IconStarGroup",
  [
    [
      "path",
      {
        d: "M9.908 11.4273L10.5516 12.0587L13.4644 9.14129L14.8023 10.4811L11.867 13.3939L12.5144 14.0431H17.9114V15.9214H12.4881L11.8652 16.5453L14.8005 19.4853L13.4644 20.8232L10.53 17.8823L9.908 18.5062V23.938H8.02975V18.5316L7.38331 17.8842L4.47528 20.8251L3.1373 19.4853L6.05003 16.5669L5.41957 15.9214H0V14.0431H5.39608L6.04534 13.392L3.1373 10.4793L4.4734 9.14129L7.38144 12.054L8.02975 11.4048V6.02654H9.908V11.4273Z",
        fill: "currentColor",
        key: "svg-105-0",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ],
    [
      "path",
      {
        d: "M19.9983 2.7624L20.3196 3.0781L21.776 1.61986L22.2307 2.07462L22.445 2.28978L20.9773 3.74521L21.3015 4.07031H24V5.0099H21.2874L20.9764 5.32091L22.2307 6.57714L22.444 6.79137L21.9902 7.24519L21.776 7.46036L21.5618 7.24519L20.3083 5.9899L19.9983 6.29996V9.0182H19.0587V6.315L18.7345 5.99084L17.2819 7.4613L17.0667 7.24519L16.6129 6.79137L16.8262 6.57714L18.0684 5.33218L17.7536 5.0099H15.0438V4.07031H17.7414L18.0665 3.74427L16.6129 2.28885L16.8262 2.07462L17.281 1.61986L18.7345 3.07528L19.0587 2.75112V0.0620117H19.9983V2.7624Z",
        fill: "currentColor",
        key: "svg-105-1"
      },
      []
    ]
  ],
  true
);

var IconSupplies = createReactComponent(
  "supplies",
  "IconSupplies",
  [
    [
      "path",
      {
        d: "M16.8733 1.7597C18.0326 0.712276 19.8224 0.747912 20.9397 1.86517L22.134 3.0595L22.2395 3.16986C23.2527 4.29177 23.253 6.00417 22.2395 7.12591L22.134 7.23529L19.8225 9.54583C19.8173 9.55132 19.8133 9.55802 19.8079 9.56341C19.8026 9.56871 19.7957 9.5729 19.7903 9.57806L8.7395 20.6308C8.43963 20.9307 8.07883 21.1618 7.68286 21.3095L7.51099 21.3681L2.29029 22.957C1.93704 23.0644 1.55332 22.968 1.29224 22.707C1.03115 22.4459 0.934823 22.0622 1.04224 21.7089L2.63111 16.4882L2.6897 16.3163C2.83743 15.9203 3.06859 15.5595 3.36841 15.2597L16.7639 1.86517L16.8733 1.7597ZM4.78247 16.6738C4.67207 16.7842 4.58981 16.9201 4.54419 17.0693L4.54517 17.0702L3.5022 20.496L6.92798 19.454L7.03833 19.414C7.14476 19.3667 7.2416 19.2995 7.32447 19.2167L17.6848 8.8554L15.1428 6.31341L4.78247 16.6738ZM19.5256 3.27923C19.1767 2.93026 18.6246 2.90844 18.2502 3.2138L18.178 3.27923L16.5579 4.89935L19.0999 7.44134L20.72 5.82122L20.7854 5.74896C21.0704 5.3995 21.0705 4.89528 20.7854 4.54583L20.72 4.47357L19.5256 3.27923Z",
        fill: "currentColor",
        key: "svg-106-0"
      },
      []
    ]
  ],
  true
);

var IconSupport = createReactComponent(
  "support",
  "IconSupport",
  [
    [
      "path",
      {
        d: "M10.9094 4.18178C7.89685 4.18178 5.4547 6.62381 5.4547 9.63622V18.3634H2.18188C0.976861 18.3634 0 17.3865 0 16.1816V11.818C0 10.6131 0.976861 9.63625 2.18188 9.63625H3.27282C3.27282 5.41888 6.69183 2 10.9094 2H13.0913C17.3088 2 20.7278 5.41883 20.7279 9.63618H21.8181C23.0231 9.63618 24 10.613 24 11.818V16.1815C24 17.3865 23.0231 18.3633 21.8181 18.3633H20.5904C20.106 20.2453 18.3974 21.636 16.3641 21.636H14.9817C14.6045 22.2881 13.8993 22.7269 13.0917 22.7269C11.8867 22.7269 10.9098 21.7501 10.9098 20.5451C10.9098 19.3401 11.8867 18.3633 13.0917 18.3633C13.8993 18.3633 14.6044 18.8021 14.9817 19.4542H16.3641C17.5508 19.4542 18.5163 18.5068 18.5453 17.3271V9.63618C18.5453 6.62379 16.1038 4.18178 13.0913 4.18178H10.9094ZM20.7272 11.818H21.8181V16.1815H20.7272V11.818ZM3.27282 11.818H2.18188V16.1816H3.27282V11.818Z",
        fill: "currentColor",
        key: "svg-107-0",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ],
    [
      "path",
      {
        d: "M10.9094 12.0907C10.9094 12.8438 10.2989 13.4543 9.54572 13.4543C8.79259 13.4543 8.18205 12.8438 8.18205 12.0907C8.18205 11.3376 8.79259 10.7271 9.54572 10.7271C10.2989 10.7271 10.9094 11.3376 10.9094 12.0907Z",
        fill: "currentColor",
        key: "svg-107-1"
      },
      []
    ],
    [
      "path",
      {
        d: "M14.455 13.4543C15.2081 13.4543 15.8186 12.8438 15.8186 12.0907C15.8186 11.3376 15.2081 10.7271 14.455 10.7271C13.7018 10.7271 13.0913 11.3376 13.0913 12.0907C13.0913 12.8438 13.7018 13.4543 14.455 13.4543Z",
        fill: "currentColor",
        key: "svg-107-2"
      },
      []
    ]
  ],
  true
);

var IconTag = createReactComponent(
  "tag",
  "IconTag",
  [
    [
      "path",
      {
        fill: "currentColor",
        d: "M3.14755 0.0664492C2.53202 -0.076789 1.88249 0.00300398 1.29381 0.389442C0.849209 0.681304 0.493334 1.04739 0.266076 1.49481C0.0368343 1.94615 -0.0286801 2.41588 0.0107486 2.859C0.0855319 3.69943 0.536503 4.45398 0.958885 5.00965C1.39966 5.58951 1.91756 6.09163 2.31036 6.43985C2.35189 6.47667 2.39231 6.51201 2.43141 6.54581L1.23339 11.0169C1.16037 11.2894 1.14183 11.5736 1.17882 11.8534C1.21581 12.1331 1.3076 12.4028 1.44894 12.6472L7.39386 22.9251C7.98814 23.9525 9.30344 24.305 10.3318 23.7123L20.2423 18.0011C21.271 17.4083 21.623 16.0944 21.0286 15.0667L15.0836 4.78878C14.7982 4.29532 14.3283 3.93524 13.7774 3.78762L5.95867 1.69258C5.78662 1.64648 5.61356 1.62255 5.44267 1.61914C5.19117 1.34399 4.93058 1.09029 4.66318 0.870799C4.23419 0.518656 3.7232 0.20041 3.14755 0.0664492ZM2.49553 2.21517C2.52789 2.19392 2.54715 2.18797 2.5612 2.18567C2.57641 2.18318 2.60276 2.18225 2.65266 2.19386C2.77532 2.22241 2.98392 2.3188 3.27549 2.55814C3.34989 2.61921 3.42565 2.6862 3.50258 2.75877C3.42793 2.89948 3.36795 3.0506 3.32508 3.21061L3.07677 4.13729C2.9449 3.99352 2.81701 3.84307 2.70015 3.68933C2.36061 3.24266 2.20882 2.89084 2.1889 2.66693C2.18099 2.57813 2.19501 2.52605 2.21629 2.48414C2.23951 2.43842 2.30484 2.34034 2.49553 2.21517ZM8.493 6.31299C8.2295 5.80031 7.91088 5.20841 7.55352 4.5998L13.0586 6.07487L18.8281 16.0496L9.34668 21.5136L3.57665 11.5385L5.30181 5.10013C5.72321 5.77416 6.1066 6.46456 6.42408 7.07119C6.23968 7.2984 6.09907 7.56708 6.01862 7.86735C5.71149 9.01357 6.39324 10.1914 7.54036 10.4988C8.68748 10.8062 9.86683 10.127 10.174 8.98077C10.4811 7.83455 9.79933 6.6567 8.65221 6.34933C8.59922 6.33513 8.54612 6.32303 8.493 6.31299Z",
        key: "svg-108-0"
      },
      []
    ]
  ],
  true
);

var IconTheater = createReactComponent(
  "theater",
  "IconTheater",
  [
    [
      "g",
      { key: "svg-109-0", clipPath: "url(#clip0_14122_11337)" },
      [
        [
          "path",
          {
            d: "M8.51074 16.335C8.79532 16.335 9.03059 16.452 9.18457 16.6885L9.23535 16.7764C9.27908 16.8661 9.30339 16.9627 9.30566 17.0635C9.30784 17.1635 9.28743 17.2602 9.24902 17.3525L9.20508 17.4453L9.2002 17.4521L9.19531 17.46C8.9031 17.896 8.51148 18.2124 8.02539 18.4062C7.55354 18.5944 7.05689 18.6895 6.53809 18.6895C6.0195 18.6894 5.52343 18.5943 5.05176 18.4062C4.56571 18.2124 4.17402 17.896 3.88184 17.46L3.87207 17.4443C3.80569 17.3251 3.76857 17.197 3.77148 17.0635C3.77452 16.9291 3.81862 16.8025 3.89258 16.6885L3.9541 16.6055C4.10615 16.4245 4.31732 16.335 4.56641 16.335H8.51074Z",
            fill: "currentColor",
            key: "svg-109-0"
          },
          []
        ],
        [
          "path",
          {
            d: "M4.23633 12.3867C4.58364 12.3867 4.88585 12.5044 5.12793 12.7402L5.21387 12.8311C5.39958 13.0513 5.49219 13.3177 5.49219 13.6191C5.49208 13.92 5.39985 14.1854 5.21582 14.4062L5.13086 14.499C4.89004 14.7364 4.58847 14.8544 4.24121 14.8545C3.93745 14.8545 3.66803 14.7642 3.44336 14.584L3.34961 14.502C3.10716 14.2655 2.98547 13.9674 2.98535 13.623C2.98535 13.2788 3.10599 12.9799 3.34668 12.7422L3.43945 12.6592C3.66333 12.4773 3.93226 12.3868 4.23633 12.3867Z",
            fill: "currentColor",
            key: "svg-109-1"
          },
          []
        ],
        [
          "path",
          {
            d: "M8.83594 12.3867C9.18325 12.3867 9.48546 12.5044 9.72754 12.7402L9.81348 12.8311C9.99913 13.0513 10.0918 13.3177 10.0918 13.6191C10.0917 13.92 9.9994 14.1854 9.81543 14.4062L9.73047 14.499C9.48967 14.7364 9.18804 14.8544 8.84082 14.8545C8.53678 14.8545 8.2668 14.7644 8.04199 14.584L7.94922 14.502C7.70674 14.2655 7.58507 13.9674 7.58496 13.623C7.58496 13.2788 7.7056 12.9799 7.94629 12.7422L8.03906 12.6592C8.26297 12.4774 8.53184 12.3868 8.83594 12.3867Z",
            fill: "currentColor",
            key: "svg-109-2"
          },
          []
        ],
        [
          "path",
          {
            d: "M10.7842 8.89453C11.4115 8.89463 11.9553 9.11629 12.4023 9.55469C12.8497 9.99347 13.0771 10.5291 13.0771 11.1484V16.4404C13.077 18.2206 12.4387 19.7392 11.1689 20.9854L11.1699 20.9873C9.89998 22.2335 8.35255 22.8573 6.54199 22.8574C4.8441 22.8574 3.37702 22.3086 2.15234 21.2129L1.91016 20.9873C0.638346 19.7411 0.000105292 18.2209 0 16.4404V11.1484C0 10.5291 0.227461 9.99347 0.674805 9.55469C1.122 9.11613 1.6664 8.89453 2.29395 8.89453H10.7842ZM2.29395 11.0156C2.2399 11.0156 2.21007 11.0306 2.18848 11.0518C2.16735 11.0726 2.15332 11.0991 2.15332 11.1484V16.4404C2.15343 17.6221 2.58032 18.6289 3.44043 19.4727C4.30083 20.3166 5.32946 20.7362 6.53809 20.7363C7.74696 20.7363 8.77618 20.3167 9.63672 19.4727C10.4969 18.6289 10.9237 17.6221 10.9238 16.4404V11.1484C10.9238 11.099 10.9099 11.0726 10.8887 11.0518C10.8779 11.0412 10.8652 11.0318 10.8486 11.0254L10.7842 11.0156H2.29395Z",
            fill: "currentColor",
            key: "svg-109-3",
            fillRule: "evenodd",
            clipRule: "evenodd"
          },
          []
        ],
        [
          "path",
          {
            d: "M21.707 1C22.3346 1 22.8789 1.22151 23.3262 1.66016C23.7735 2.09894 24.001 2.63457 24.001 3.25391V8.54492C24.001 10.2536 23.4299 11.7088 22.29 12.8975L22.0537 13.1318C20.7598 14.359 19.1897 14.9735 17.3564 14.9736C17.1005 14.9736 16.8464 14.9597 16.5957 14.9316L16.3457 14.8984C16.0099 14.8477 15.6817 14.7614 15.3613 14.6406C15.0754 14.541 14.8682 14.3483 14.7549 14.0703C14.644 13.798 14.6428 13.5177 14.75 13.2402L14.7949 13.1377C14.9095 12.9086 15.0908 12.7398 15.333 12.6406C15.5691 12.5441 15.8117 12.5267 16.0527 12.5889L16.1553 12.6201L16.1582 12.6211L16.3232 12.6768C16.4878 12.7283 16.6514 12.767 16.8145 12.792L17.1494 12.8301C17.2619 12.8385 17.3756 12.8428 17.4902 12.8428C18.6991 12.8428 19.7236 12.4224 20.5742 11.5791C21.4252 10.7354 21.8477 9.72757 21.8477 8.54492V3.25391C21.8477 3.20437 21.8328 3.17712 21.8115 3.15625C21.79 3.13537 21.7606 3.12109 21.707 3.12109H13.2168C13.1633 3.12117 13.1338 3.13529 13.1123 3.15625C13.0911 3.1771 13.0771 3.20445 13.0771 3.25391V6.57129C13.0771 6.86601 12.9733 7.12319 12.7656 7.32715C12.5579 7.53069 12.2969 7.63177 12 7.63184C11.7404 7.63174 11.509 7.55487 11.3164 7.39941L11.2354 7.32715C11.0277 7.12313 10.9238 6.86605 10.9238 6.57129V3.25391C10.9238 2.63456 11.1513 2.09894 11.5986 1.66016C12.0457 1.22168 12.5894 1.0001 13.2168 1H21.707Z",
            fill: "currentColor",
            key: "svg-109-4"
          },
          []
        ],
        [
          "path",
          {
            d: "M17.4609 8.43945C17.9913 8.43945 18.5014 8.53668 18.9873 8.73047L19.1709 8.81152C19.5872 9.01677 19.9159 9.32481 20.1514 9.73242C20.22 9.84851 20.2574 9.97635 20.2471 10.1113C20.2392 10.2131 20.2042 10.3073 20.1514 10.3926L20.0938 10.4746C19.9204 10.6893 19.6804 10.7939 19.3994 10.7939H15.5244C15.2745 10.7938 15.0564 10.7154 14.8887 10.5508L14.8203 10.4746C14.7349 10.3688 14.6774 10.2469 14.667 10.1113C14.6566 9.9756 14.6943 9.84702 14.7637 9.73047C15.033 9.26537 15.425 8.93101 15.9316 8.73047L16.1152 8.66211C16.5476 8.51381 16.9968 8.43953 17.4609 8.43945Z",
            fill: "currentColor",
            key: "svg-109-5"
          },
          []
        ],
        [
          "path",
          {
            d: "M15.1602 4.49219C15.5072 4.49219 15.8098 4.60827 16.0518 4.84375L16.1377 4.93652C16.3233 5.1567 16.416 5.42325 16.416 5.72461C16.4159 6.02541 16.3236 6.29092 16.1396 6.51172L16.0547 6.60449C15.8139 6.84188 15.5123 6.95985 15.165 6.95996C14.861 6.95996 14.591 6.86987 14.3662 6.68945L14.2734 6.60742C14.0309 6.37091 13.9092 6.07202 13.9092 5.72754C13.9093 5.38368 14.0292 5.08516 14.2695 4.84766L14.3633 4.76367C14.5871 4.58207 14.8562 4.49226 15.1602 4.49219Z",
            fill: "currentColor",
            key: "svg-109-6"
          },
          []
        ],
        [
          "path",
          {
            d: "M19.7598 4.49219C20.1068 4.49223 20.4094 4.60824 20.6514 4.84375L20.7363 4.93652C20.9221 5.15677 21.0156 5.42308 21.0156 5.72461C21.0155 6.02537 20.9232 6.29094 20.7393 6.51172L20.6543 6.60449C20.4135 6.84179 20.1118 6.95981 19.7646 6.95996C19.4607 6.95996 19.1906 6.86977 18.9658 6.68945L18.873 6.60742C18.6305 6.37091 18.5088 6.07202 18.5088 5.72754C18.5089 5.3835 18.6295 5.08523 18.8701 4.84766L18.9629 4.76367C19.1867 4.58213 19.4559 4.49226 19.7598 4.49219Z",
            fill: "currentColor",
            key: "svg-109-7"
          },
          []
        ]
      ]
    ],
    [
      "defs",
      { key: "svg-109-1" },
      [
        [
          "clipPath",
          { id: "clip0_14122_11337", key: "svg-109-0" },
          [
            [
              "rect",
              { width: "24", height: "24", fill: "white", key: "svg-109-0" },
              []
            ]
          ]
        ]
      ]
    ]
  ],
  true
);

var IconTicket = createReactComponent(
  "ticket",
  "IconTicket",
  [
    [
      "path",
      {
        d: "M11.3816 5.81286C11.5524 5.64202 11.8294 5.642 12.0003 5.81286L13.2377 7.0503C13.4086 7.22116 13.4086 7.49817 13.2377 7.66902L12.619 8.28773C12.4482 8.45858 12.1712 8.4586 12.0003 8.28773L10.7629 7.0503C10.592 6.87944 10.592 6.60242 10.7629 6.43158L11.3816 5.81286Z",
        fill: "currentColor",
        key: "svg-110-0"
      },
      []
    ],
    [
      "path",
      {
        d: "M13.8564 8.28773C14.0273 8.11689 14.3043 8.11687 14.4752 8.28773L15.7126 9.52517C15.8835 9.69603 15.8834 9.97305 15.7126 10.1439L15.0939 10.7626C14.923 10.9335 14.646 10.9335 14.4752 10.7626L13.2377 9.52517C13.0669 9.35431 13.0669 9.0773 13.2377 8.90645L13.8564 8.28773Z",
        fill: "currentColor",
        key: "svg-110-1"
      },
      []
    ],
    [
      "path",
      {
        d: "M16.95 10.7626C16.7792 10.5917 16.5022 10.5918 16.3313 10.7626L15.7126 11.3813C15.5418 11.5522 15.5417 11.8292 15.7126 12L16.95 13.2375C17.1209 13.4083 17.3979 13.4083 17.5688 13.2375L18.1875 12.6188C18.3583 12.4479 18.3583 12.1709 18.1875 12L16.95 10.7626Z",
        fill: "currentColor",
        key: "svg-110-2"
      },
      []
    ],
    [
      "path",
      {
        d: "M14.4752 2.10055C14.1335 1.75884 13.5794 1.75884 13.2377 2.10055L2.1008 13.2375C1.75909 13.5792 1.75909 14.1332 2.1008 14.4749L3.41635 15.7905C4.75883 14.9979 6.51573 15.1775 7.66926 16.3311C8.82279 17.4846 9.00241 19.2415 8.20986 20.584L9.52542 21.8995C9.86713 22.2412 10.4211 22.2412 10.7629 21.8995L21.8998 10.7626C22.2415 10.4209 22.2415 9.86688 21.8998 9.52517L20.5842 8.20961C19.2417 9.00216 17.4848 8.82254 16.3313 7.66902C15.1778 6.51549 14.9982 4.75859 15.7907 3.41611L14.4752 2.10055ZM12.0003 0.863113C13.0254 -0.162014 14.6875 -0.162013 15.7126 0.863113L17.2594 2.40991C17.7928 2.94336 17.7154 3.70932 17.3796 4.17982C16.8922 4.86277 16.9559 5.81874 17.5688 6.43158C18.1816 7.04442 19.1376 7.10816 19.8205 6.62071C20.291 6.2849 21.057 6.20749 21.5904 6.74094L23.1372 8.28773C24.1623 9.31286 24.1623 10.9749 23.1372 12L12.0003 23.137C10.9752 24.1621 9.31311 24.1621 8.28798 23.137L6.74118 21.5902C6.20774 21.0567 6.28514 20.2908 6.62096 19.8203C7.10841 19.1373 7.04466 18.1813 6.43182 17.5685C5.81899 16.9557 4.86302 16.8919 4.18007 17.3794C3.70956 17.7152 2.9436 17.7926 2.41015 17.2592L0.863358 15.7124C-0.161768 14.6872 -0.161766 13.0252 0.863358 12L12.0003 0.863113Z",
        fill: "currentColor",
        key: "svg-110-3",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ]
  ],
  true
);

var IconTransportation = createReactComponent(
  "transportation",
  "IconTransportation",
  [
    [
      "path",
      {
        d: "M7.77456 15.0282C8.08571 15.0282 8.33794 14.7759 8.33794 14.4648C8.33794 14.1537 8.08571 13.9014 7.77456 13.9014C7.46342 13.9014 7.21118 14.1537 7.21118 14.4648C7.21118 14.7759 7.46342 15.0282 7.77456 15.0282Z",
        fill: "currentColor",
        key: "svg-111-0"
      },
      []
    ],
    [
      "path",
      {
        d: "M8.33794 14.4648C8.33794 14.7759 8.08571 15.0282 7.77456 15.0282C7.46342 15.0282 7.21118 14.7759 7.21118 14.4648C7.21118 14.1537 7.46342 13.9014 7.77456 13.9014C8.08571 13.9014 8.33794 14.1537 8.33794 14.4648Z",
        fill: "currentColor",
        key: "svg-111-1",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ],
    [
      "path",
      {
        d: "M16.2252 15.0282C16.5363 15.0282 16.7886 14.7759 16.7886 14.4648C16.7886 14.1537 16.5363 13.9014 16.2252 13.9014C15.9141 13.9014 15.6619 14.1537 15.6619 14.4648C15.6619 14.7759 15.9141 15.0282 16.2252 15.0282Z",
        fill: "currentColor",
        key: "svg-111-2"
      },
      []
    ],
    [
      "path",
      {
        d: "M16.7886 14.4648C16.7886 14.7759 16.5363 15.0282 16.2252 15.0282C15.9141 15.0282 15.6619 14.7759 15.6619 14.4648C15.6619 14.1537 15.9141 13.9014 16.2252 13.9014C16.5363 13.9014 16.7886 14.1537 16.7886 14.4648Z",
        fill: "currentColor",
        key: "svg-111-3",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ],
    [
      "path",
      {
        d: "M16.2256 14.0283C15.9844 14.0283 15.7891 14.2237 15.7891 14.4648L15.7979 14.5527C15.8386 14.7517 16.0146 14.9014 16.2256 14.9014C16.4365 14.9012 16.6127 14.7517 16.6533 14.5527L16.6621 14.4648L16.6533 14.377C16.6185 14.2064 16.484 14.0721 16.3135 14.0371L16.2256 14.0283ZM8.20215 14.377C8.16728 14.2063 8.03302 14.0719 7.8623 14.0371L7.77441 14.0283C7.53329 14.0284 7.33789 14.2238 7.33789 14.4648L7.34668 14.5527C7.38735 14.7517 7.56341 14.9013 7.77441 14.9014C7.98546 14.9014 8.16145 14.7517 8.20215 14.5527L8.21094 14.4648L8.20215 14.377ZM7.07031 3C5.75591 3.00006 4.69065 4.06551 4.69043 5.37988V9.30957H19.3096V5.37988C19.3094 4.0655 18.2441 3.00006 16.9297 3H7.07031ZM19.3096 11.3096H4.69043V16.9297C4.69049 17.3106 4.99896 17.6199 5.37988 17.6201H18.6201C19.001 17.6199 19.3095 17.3106 19.3096 16.9297V11.3096ZM21.3096 16.9297C21.3095 17.7684 20.9259 18.5174 20.3242 19.0107V20.5918C20.3241 21.6107 19.4974 22.4365 18.4785 22.4365C17.4598 22.4363 16.6339 21.6106 16.6338 20.5918V19.6201H7.36621V20.5918C7.36608 21.6105 6.54025 22.4363 5.52148 22.4365C4.50256 22.4365 3.67591 21.6107 3.67578 20.5918V19.0107C3.07414 18.5174 2.69046 17.7684 2.69043 16.9297V8H2C1.44772 8 1 7.55228 1 7V6.15527C1 5.14421 1.81325 4.32328 2.82129 4.31055C3.29864 2.40845 5.02018 1.00005 7.07031 1H16.9297C18.9798 1.00005 20.7003 2.40857 21.1777 4.31055C22.1862 4.32277 23 5.14388 23 6.15527V7C23 7.55228 22.5523 8 22 8H21.3096V16.9297ZM9.33789 14.4648C9.33786 15.3281 8.63787 16.0283 7.77441 16.0283C6.96512 16.0282 6.29998 15.413 6.21973 14.625L6.21094 14.4648L6.21973 14.3047C6.29992 13.5166 6.96507 12.9014 7.77441 12.9014L7.93457 12.9092C8.72289 12.9893 9.33789 13.6555 9.33789 14.4648ZM17.7891 14.4648C17.789 15.3281 17.0888 16.0281 16.2256 16.0283C15.4163 16.0283 14.7502 15.4131 14.6699 14.625L14.6621 14.4648L14.6699 14.3047C14.7501 13.5165 15.4162 12.9014 16.2256 12.9014L16.3848 12.9092C17.1732 12.9891 17.7891 13.6553 17.7891 14.4648Z",
        fill: "currentColor",
        key: "svg-111-4"
      },
      []
    ]
  ],
  true
);

var IconTwitter = createReactComponent(
  "twitter",
  "IconTwitter",
  [
    [
      "g",
      { key: "svg-112-0", clipPath: "url(#clip0_200_3641)" },
      [
        [
          "path",
          {
            d: "M14.3416 2.37183C15.4241 1.95865 16.6074 1.88791 17.7314 2.16916C18.5604 2.37658 19.3277 2.76809 19.9784 3.31005C20.6768 3.03703 21.3406 2.68028 21.9549 2.24698C22.3968 1.93528 22.9856 1.93038 23.4327 2.23468C23.8797 2.53897 24.091 3.08863 23.9631 3.61403C23.6282 4.98912 22.9678 6.26004 22.0414 7.32154C22.0494 7.44118 22.0536 7.5611 22.054 7.68112L22.054 7.68541C22.054 13.7339 19.1359 18.2016 14.9203 20.4454C10.7364 22.6723 5.40446 22.6402 0.667402 20.0085C0.142246 19.7168 -0.113897 19.1026 0.0483264 18.5242C0.21055 17.9458 0.748698 17.5544 1.34898 17.5782C2.73728 17.6335 4.11335 17.3994 5.39282 16.9002C4.15442 16.0473 3.22826 15.063 2.55785 14.0045C1.5447 12.4048 1.16468 10.7135 1.09606 9.20376C1.02769 7.69973 1.2665 6.3494 1.51611 5.38426C1.64169 4.89867 1.77215 4.50238 1.87322 4.22282C1.92383 4.08284 1.96729 3.97151 1.99941 3.89224C2.01547 3.85258 2.02872 3.82089 2.03863 3.79758L2.05094 3.76894L2.0551 3.75943L2.05667 3.75588L2.05731 3.75442C2.0576 3.75377 2.05787 3.75316 3.24335 4.28004L2.05787 3.75316C2.24768 3.32608 2.65254 3.03412 3.11769 2.98885C3.58285 2.94358 4.0364 3.15201 4.30499 3.53447C5.16504 4.75913 6.31462 5.75209 7.65133 6.42491C8.61242 6.90865 9.6488 7.2161 10.7114 7.33628C10.7692 6.31644 11.1023 5.32854 11.6788 4.47934C12.3296 3.52067 13.2591 2.785 14.3416 2.37183ZM3.83739 6.91318C3.72414 7.55864 3.65233 8.30226 3.68795 9.08595C3.74095 10.2519 4.02985 11.4795 4.74979 12.6162C5.46451 13.7448 6.65332 14.8623 8.63505 15.7431C9.06549 15.9344 9.35842 16.344 9.40032 16.8132C9.44221 17.2824 9.2265 17.7374 8.83677 18.0019C8.06345 18.5269 7.23892 18.9612 6.37939 19.3002C8.99805 19.7199 11.5613 19.294 13.7013 18.155C17.0257 16.3856 19.4587 12.827 19.4594 7.68762C19.4587 7.4976 19.4403 7.30806 19.4047 7.12142C19.335 6.75718 19.425 6.38376 19.6459 6.09304C19.277 6.09254 18.9186 5.93444 18.6687 5.64703C18.2571 5.17379 17.7101 4.83837 17.1017 4.68614C16.4932 4.5339 15.8527 4.57219 15.2668 4.79584C14.6808 5.01948 14.1777 5.41769 13.8254 5.9366C13.4732 6.45551 13.2888 7.07009 13.2972 7.69721L13.2974 7.7146H13.2973V8.68756C13.2973 9.39094 12.7368 9.96618 12.0337 9.98441C10.1099 10.0343 8.20374 9.60765 6.48483 8.74246C5.5185 8.25608 4.62822 7.63958 3.83739 6.91318Z",
            fill: "currentColor",
            key: "svg-112-0",
            fillRule: "evenodd",
            clipRule: "evenodd"
          },
          []
        ]
      ]
    ],
    [
      "defs",
      { key: "svg-112-1" },
      [
        [
          "clipPath",
          { id: "clip0_200_3641", key: "svg-112-0" },
          [
            [
              "rect",
              {
                width: "24",
                height: "24",
                fill: "transparent",
                key: "svg-112-0"
              },
              []
            ]
          ]
        ]
      ]
    ]
  ],
  true
);

var IconUniform = createReactComponent(
  "uniform",
  "IconUniform",
  [
    [
      "path",
      {
        d: "M17.1621 8.41895C17.1621 8.06317 17.3509 7.73386 17.6582 7.55469C17.9657 7.37553 18.3457 7.3734 18.6553 7.54883L19.6963 8.13867L20.7481 6.20996L17.1729 3.13086C17.0747 3.04636 16.9495 3.0001 16.8203 3H15.7901C15.1888 4.5045 13.7195 5.56732 12 5.56738C10.2805 5.56738 8.81134 4.50448 8.20998 3H7.17971C7.08256 3.00003 6.98796 3.02642 6.90529 3.0752L6.82717 3.13086L3.25099 6.20996L4.30275 8.13867L5.34474 7.54883L5.46389 7.49121C5.74795 7.3767 6.07195 7.39815 6.34084 7.55469C6.64828 7.73384 6.83791 8.06312 6.83791 8.41895V19.459C6.83791 19.7574 7.07956 19.9998 7.37795 20H16.6211C16.9196 20 17.1621 19.7575 17.1621 19.459V8.41895ZM19.1621 19.459C19.1621 20.8621 18.0242 22 16.6211 22H7.37795C5.97496 21.9998 4.83791 20.8619 4.83791 19.459V10.1348L4.40529 10.3799C4.17212 10.512 3.89544 10.5452 3.63771 10.4717C3.41211 10.4073 3.21708 10.2663 3.08596 10.0742L3.0342 9.98926L1.10842 6.45898C0.882704 6.04518 0.976819 5.52925 1.334 5.22168L5.52248 1.61523L5.70119 1.47461C6.13085 1.16707 6.64757 1.00003 7.17971 1H8.96096L9.05178 1.00391C9.50047 1.04431 9.8715 1.38327 9.94728 1.83496C10.1124 2.81828 10.97 3.56738 12 3.56738C13.03 3.56731 13.8866 2.81816 14.0518 1.83496L14.0713 1.74609C14.1854 1.31036 14.5802 1.0001 15.0381 1H16.8203C17.4286 1.0001 18.0166 1.21844 18.4776 1.61523L22.666 5.22168C23.0232 5.52925 23.1173 6.04518 22.8916 6.45898L20.9658 9.98926C20.8375 10.2244 20.6199 10.3981 20.3623 10.4717C20.1046 10.5452 19.8279 10.512 19.5947 10.3799L19.1621 10.1348V19.459Z",
        fill: "currentColor",
        key: "svg-113-0"
      },
      []
    ]
  ],
  true
);

var IconUpload = createReactComponent(
  "upload",
  "IconUpload",
  [
    [
      "path",
      {
        d: "M13.3353 5.4235L13.3353 17.284C13.3353 17.6134 13.2022 17.9312 12.9621 18.167C12.7217 18.4031 12.3936 18.5374 12.0496 18.5374C11.7056 18.5374 11.3776 18.4031 11.1372 18.167C10.8971 17.9312 10.764 17.6134 10.764 17.284L10.764 5.42276L5.35549 11.0283C5.23996 11.1484 5.10048 11.246 4.94573 11.314C4.79096 11.3821 4.62372 11.4197 4.4536 11.4244C4.28349 11.4291 4.11426 11.4009 3.95569 11.3415C3.79712 11.2821 3.65262 11.1928 3.53021 11.0792C3.40782 10.9656 3.30994 10.83 3.2417 10.6803C3.17347 10.5306 3.13607 10.3696 3.13137 10.2063C3.12666 10.043 3.15473 9.88024 3.21418 9.72717C3.27364 9.57408 3.36346 9.43338 3.47896 9.31333L11.1095 1.39659C11.2292 1.27214 11.3744 1.17203 11.5358 1.10371C11.6972 1.03538 11.8715 1 12.0478 1C12.2242 1 12.3984 1.03538 12.5599 1.10371C12.7212 1.17203 12.8661 1.27172 12.9857 1.39616L20.6239 9.31333C20.7393 9.43334 20.8293 9.57414 20.8887 9.72717C20.9481 9.88024 20.9762 10.043 20.9715 10.2063C20.962 10.5356 20.8197 10.8499 20.5727 11.0792C20.3253 11.3088 19.9932 11.434 19.6493 11.4244C19.3053 11.4149 18.9813 11.2715 18.7479 11.0289L13.3353 5.4235Z",
        fill: "currentColor",
        key: "svg-114-0",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ],
    [
      "path",
      {
        d: "M1.30435 20.8261C0.583976 20.8261 0 21.4101 0 22.1304C0 22.8508 0.583976 23.4348 1.30435 23.4348H22.6957C23.416 23.4348 24 22.8508 24 22.1304C24 21.4101 23.416 20.8261 22.6957 20.8261H1.30435Z",
        fill: "currentColor",
        key: "svg-114-1",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ]
  ],
  true
);

var IconUser = createReactComponent(
  "user",
  "IconUser",
  [
    [
      "g",
      { key: "svg-115-0", clipPath: "url(#clip0_191_3271)" },
      [
        [
          "path",
          {
            d: "M8.6998 6.25C8.6998 4.26177 10.3116 2.65 12.2998 2.65C14.288 2.65 15.8998 4.26177 15.8998 6.25C15.8998 8.23822 14.288 9.85 12.2998 9.85C10.3116 9.85 8.6998 8.23822 8.6998 6.25ZM12.2998 0.25C8.9861 0.25 6.2998 2.93629 6.2998 6.25C6.2998 9.56371 8.9861 12.25 12.2998 12.25C15.6135 12.25 18.2998 9.56371 18.2998 6.25C18.2998 2.93629 15.6135 0.25 12.2998 0.25ZM7.5 14.65C5.9087 14.65 4.38258 15.2822 3.25736 16.4074C2.13214 17.5326 1.5 19.0587 1.5 20.65V23.05C1.5 23.7128 2.03726 24.25 2.7 24.25C3.36274 24.25 3.9 23.7128 3.9 23.05V20.65C3.9 19.6952 4.27928 18.7796 4.95442 18.1044C5.62955 17.4293 6.54522 17.05 7.5 17.05H17.1C18.0548 17.05 18.9705 17.4293 19.6456 18.1044C20.3207 18.7796 20.7 19.6952 20.7 20.65V23.05C20.7 23.7128 21.2373 24.25 21.9 24.25C22.5627 24.25 23.1 23.7128 23.1 23.05V20.65C23.1 19.0587 22.4679 17.5326 21.3426 16.4074C20.2174 15.2822 18.6913 14.65 17.1 14.65H7.5Z",
            fill: "currentColor",
            key: "svg-115-0",
            fillRule: "evenodd",
            clipRule: "evenodd"
          },
          []
        ]
      ]
    ],
    [
      "defs",
      { key: "svg-115-1" },
      [
        [
          "clipPath",
          { id: "clip0_191_3271", key: "svg-115-0" },
          [
            [
              "rect",
              { width: "24", height: "24", fill: "white", key: "svg-115-0" },
              []
            ]
          ]
        ]
      ]
    ]
  ],
  true
);

var IconUsers = createReactComponent(
  "users",
  "IconUsers",
  [
    [
      "path",
      {
        d: "M1.46447 15.4645C2.40215 14.5268 3.67392 14 5 14H13C14.3261 14 15.5979 14.5268 16.5355 15.4645C17.4732 16.4021 18 17.6739 18 19V21C18 21.5523 17.5523 22 17 22C16.4477 22 16 21.5523 16 21V19C16 18.2043 15.6839 17.4413 15.1213 16.8787C14.5587 16.3161 13.7957 16 13 16H5C4.20435 16 3.44129 16.3161 2.87868 16.8787C2.31607 17.4413 2 18.2043 2 19V21C2 21.5523 1.55228 22 1 22C0.447715 22 0 21.5523 0 21V19C0 17.6739 0.526784 16.4021 1.46447 15.4645Z",
        fill: "currentColor",
        key: "svg-116-0",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ],
    [
      "path",
      {
        d: "M9 4C7.34315 4 6 5.34314 6 7C6 8.65685 7.34315 10 9 10C10.6569 10 12 8.65685 12 7C12 5.34314 10.6569 4 9 4ZM4 7C4 4.23858 6.23858 2 9 2C11.7614 2 14 4.23858 14 7C14 9.76142 11.7614 12 9 12C6.23858 12 4 9.76142 4 7Z",
        fill: "currentColor",
        key: "svg-116-1",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ],
    [
      "path",
      {
        d: "M19.0318 14.88C19.1698 14.3453 19.7153 14.0237 20.25 14.1618C21.3227 14.4387 22.273 15.0641 22.9517 15.9396C23.6304 16.8152 23.9992 17.8914 24 18.9993V21C24 21.5523 23.5523 22 23 22C22.4477 22 22 21.5523 22 21V19.0007C21.9994 18.3361 21.7782 17.6902 21.371 17.165C20.9638 16.6396 20.3936 16.2644 19.75 16.0982C19.2153 15.9602 18.8937 15.4147 19.0318 14.88Z",
        fill: "currentColor",
        key: "svg-116-2",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ],
    [
      "path",
      {
        d: "M15.0313 2.88196C15.1682 2.34693 15.713 2.02426 16.248 2.16125C17.3236 2.43663 18.2768 3.06213 18.9576 3.93914C19.6383 4.81615 20.0078 5.89479 20.0078 7.005C20.0078 8.11521 19.6383 9.19385 18.9576 10.0709C18.2768 10.9479 17.3236 11.5734 16.248 11.8487C15.713 11.9857 15.1682 11.6631 15.0313 11.128C14.8943 10.593 15.2169 10.0482 15.752 9.91125C16.3973 9.74602 16.9692 9.37072 17.3777 8.84452C17.7861 8.31831 18.0078 7.67113 18.0078 7.005C18.0078 6.33887 17.7861 5.69169 17.3777 5.16548C16.9692 4.63928 16.3973 4.26398 15.752 4.09875C15.2169 3.96176 14.8943 3.41699 15.0313 2.88196Z",
        fill: "currentColor",
        key: "svg-116-3",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ]
  ],
  true
);

var IconVerified = createReactComponent(
  "verified",
  "IconVerified",
  [
    [
      "path",
      {
        d: "M9.98857 1.04211C10.9691 -0.347208 13.0301 -0.347208 14.0106 1.04211C14.6399 1.93345 15.7812 2.30436 16.8142 1.95299C18.424 1.40559 20.0905 2.61684 20.0672 4.31709C20.0524 5.40799 20.7579 6.37828 21.8001 6.70116C23.4244 7.20443 24.0608 9.16458 23.0425 10.5265C22.3893 11.4003 22.3892 12.6 23.0425 13.4738C24.0608 14.8357 23.4242 16.7948 21.8001 17.2981C20.7578 17.6211 20.0522 18.5921 20.0672 19.6832C20.0905 21.3834 18.424 22.5946 16.8142 22.0473C15.7811 21.6959 14.6398 22.0667 14.0106 22.9582C13.0301 24.3474 10.9691 24.3474 9.98857 22.9582C9.35935 22.0667 8.21808 21.6959 7.18501 22.0473C5.57524 22.5945 3.90869 21.3834 3.93201 19.6832C3.94697 18.5921 3.24145 17.6211 2.19914 17.2981C0.575003 16.7948 -0.0615832 14.8357 0.956665 13.4738C1.61003 12.6 1.60989 11.4003 0.956665 10.5265C-0.0616218 9.16459 0.574886 7.20446 2.19914 6.70116C3.2413 6.37828 3.94677 5.40799 3.93201 4.31709C3.90868 2.61686 5.5752 1.40564 7.18501 1.95299C8.21798 2.30436 9.35931 1.93343 9.98857 1.04211ZM16.8182 7.5621C16.3439 7.16082 15.6345 7.21984 15.2331 7.69394L10.3601 13.4519L8.41051 11.679C7.9508 11.2612 7.23942 11.2953 6.82146 11.755C6.40363 12.2147 6.43766 12.9261 6.89737 13.344L9.70991 15.9009C9.93577 16.106 10.2354 16.2104 10.5399 16.1905C10.8443 16.1705 11.1278 16.0279 11.3249 15.795L16.95 9.14715C17.3511 8.673 17.292 7.96349 16.8182 7.5621Z",
        fill: "currentColor",
        key: "svg-117-0",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ]
  ],
  true
);

var IconViewOff = createReactComponent(
  "viewOff",
  "IconViewOff",
  [
    [
      "path",
      {
        d: "M12 6.50005C14.76 6.50005 17 8.74005 17 11.5001C17 12.0101 16.9 12.5001 16.76 12.9601L19.82 16.0201C21.21 14.7901 22.31 13.2501 23 11.4901C21.27 7.11005 17 4.00005 12 4.00005C10.73 4.00005 9.51 4.20005 8.36 4.57005L10.53 6.74005C11 6.60005 11.49 6.50005 12 6.50005ZM2.71 3.16005C2.32 3.55005 2.32 4.18005 2.71 4.57005L4.68 6.54005C3.06 7.83005 1.77 9.53005 1 11.5001C2.73 15.8901 7 19.0001 12 19.0001C13.52 19.0001 14.97 18.7001 16.31 18.1801L19.03 20.9001C19.42 21.2901 20.05 21.2901 20.44 20.9001C20.83 20.5101 20.83 19.8801 20.44 19.4901L4.13 3.16005C3.74 2.77005 3.1 2.77005 2.71 3.16005ZM12 16.5001C9.24 16.5001 7 14.2601 7 11.5001C7 10.7301 7.18 10.0001 7.49 9.36005L9.06 10.9301C9.03 11.1101 9 11.3001 9 11.5001C9 13.1601 10.34 14.5001 12 14.5001C12.2 14.5001 12.38 14.4701 12.57 14.4301L14.14 16.0001C13.49 16.3201 12.77 16.5001 12 16.5001ZM14.97 11.1701C14.82 9.77005 13.72 8.68005 12.33 8.53005L14.97 11.1701Z",
        fill: "currentColor",
        key: "svg-118-0"
      },
      []
    ]
  ],
  true
);

var IconViewOn = createReactComponent(
  "viewOn",
  "IconViewOn",
  [
    [
      "path",
      {
        d: "M12 4C7 4 2.73 7.11 1 11.5C2.73 15.89 7 19 12 19C17 19 21.27 15.89 23 11.5C21.27 7.11 17 4 12 4ZM12 16.5C9.24 16.5 7 14.26 7 11.5C7 8.74 9.24 6.5 12 6.5C14.76 6.5 17 8.74 17 11.5C17 14.26 14.76 16.5 12 16.5ZM12 8.5C10.34 8.5 9 9.84 9 11.5C9 13.16 10.34 14.5 12 14.5C13.66 14.5 15 13.16 15 11.5C15 9.84 13.66 8.5 12 8.5Z",
        fill: "currentColor",
        key: "svg-119-0"
      },
      []
    ]
  ],
  true
);

var IconWallet = createReactComponent(
  "wallet",
  "IconWallet",
  [
    [
      "path",
      {
        d: "M12.0006 13.35C12.9645 13.35 13.805 12.8156 14.2395 12.0219C14.5173 11.5145 14.9017 10.9691 15.4032 10.539C15.91 10.1043 16.5841 9.74995 17.4006 9.74995H21.9V4.80002C21.9 4.63434 21.7657 4.50002 21.6 4.50002H2.4C2.23431 4.50002 2.1 4.63434 2.1 4.80002V9.74995H6.60059C7.41709 9.74995 8.09113 10.1043 8.59795 10.539C9.09944 10.9691 9.48388 11.5145 9.76166 12.0219C10.1961 12.8156 11.0367 13.35 12.0006 13.35ZM2.1 11.85V18C2.1 18.1657 2.23432 18.3 2.4 18.3H21.6C21.7657 18.3 21.9 18.1657 21.9 18V11.85H17.4006C17.223 11.85 17.0157 11.9226 16.7703 12.1331C16.5197 12.348 16.2811 12.6657 16.0816 13.0303C15.2935 14.4699 13.7622 15.45 12.0006 15.45C10.2389 15.45 8.70768 14.4699 7.91961 13.0303C7.72004 12.6657 7.48151 12.348 7.23084 12.1331C6.98551 11.9226 6.7782 11.85 6.60059 11.85H2.1ZM2.4 2.40002C1.07452 2.40002 0 3.47454 0 4.80002V18C0 19.3255 1.07452 20.4 2.4 20.4H21.6C22.9255 20.4 24 19.3255 24 18V4.80002C24 3.47454 22.9255 2.40002 21.6 2.40002H2.4Z",
        fill: "currentColor",
        key: "svg-120-0",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ]
  ],
  true
);

var IconWarning = createReactComponent(
  "warning",
  "IconWarning",
  [
    [
      "path",
      {
        d: "M12.8478 0.489463C12.6729 0.186582 12.3497 0 12 0C11.6503 0 11.3271 0.186582 11.1522 0.489463L0.131151 19.5785C-0.0437171 19.8814 -0.0437171 20.2546 0.131151 20.5574C0.30602 20.8603 0.629189 21.0469 0.978926 21.0469H23.0211C23.3708 21.0469 23.694 20.8603 23.8688 20.5574C24.0437 20.2546 24.0437 19.8814 23.8688 19.5785L12.8478 0.489463ZM2.67448 19.0891L12 2.93678L21.3255 19.0891H2.67448ZM10.6229 8.57807C10.6229 7.81743 11.2395 7.20082 12.0001 7.20082H12.0105C12.7711 7.20082 13.3877 7.81743 13.3877 8.57807C13.3877 9.3387 12.7711 9.95531 12.0105 9.95531H12.0001C11.2395 9.95531 10.6229 9.3387 10.6229 8.57807ZM10.6229 12.726C10.6229 11.9654 11.2395 11.3488 12.0001 11.3488C12.7608 11.3488 13.3774 11.9654 13.3774 12.726V16.874C13.3774 17.6346 12.7608 18.2512 12.0001 18.2512C11.2395 18.2512 10.6229 17.6346 10.6229 16.874V12.726Z",
        fill: "currentColor",
        key: "svg-121-0",
        fillRule: "evenodd",
        clipRule: "evenodd"
      },
      []
    ]
  ],
  true
);

var IconWorld = createReactComponent(
  "world",
  "IconWorld",
  [
    [
      "path",
      {
        d: "M12 0C5.376 0 0 5.376 0 12C0 18.624 5.376 24 12 24C18.624 24 24 18.624 24 12C24 5.376 18.624 0 12 0ZM10.8 21.516C6.06 20.928 2.4 16.896 2.4 12C2.4 11.256 2.496 10.548 2.652 9.852L8.4 15.6V16.8C8.4 18.12 9.48 19.2 10.8 19.2V21.516ZM19.08 18.468C18.768 17.496 17.88 16.8 16.8 16.8H15.6V13.2C15.6 12.54 15.06 12 14.4 12H7.2V9.6H9.6C10.26 9.6 10.8 9.06 10.8 8.4V6H13.2C14.52 6 15.6 4.92 15.6 3.6V3.108C19.116 4.536 21.6 7.98 21.6 12C21.6 14.496 20.64 16.764 19.08 18.468Z",
        fill: "currentColor",
        key: "svg-122-0"
      },
      []
    ]
  ],
  true
);

var IconXTwitter = createReactComponent(
  "xTwitter",
  "IconXTwitter",
  [
    [
      "g",
      { id: "x - twitter", key: "svg-123-0" },
      [
        [
          "path",
          {
            id: "Vector",
            d: "M18.8916 1H22.5542L14.5542 10.2048L24 22.6867H16.5783L10.7952 15.1205L4.14458 22.6867H0.481928L9.06024 12.8554L0 1H7.61446L12.8675 7.93976L18.8916 1ZM17.5904 20.4699H19.6145L6.50602 3.07229H4.28916L17.5904 20.4699Z",
            fill: "currentColor",
            key: "svg-123-0"
          },
          []
        ]
      ]
    ]
  ],
  true
);

var IconZoomMinus = createReactComponent(
  "zoomMinus",
  "IconZoomMinus",
  [
    [
      "g",
      { key: "svg-124-0", clipPath: "url(#clip0_985_10262)" },
      [
        [
          "path",
          {
            d: "M17.3821 19.4517C15.5628 20.8364 13.292 21.6585 10.8293 21.6585C4.84843 21.6585 0 16.8101 0 10.8293C0 4.84843 4.84843 0 10.8293 0C16.8101 0 21.6585 4.84843 21.6585 10.8293C21.6585 13.292 20.8364 15.5628 19.4517 17.3821L23.5714 21.5018C24.1429 22.0733 24.1429 22.9999 23.5714 23.5714C22.9999 24.1429 22.0733 24.1429 21.5018 23.5714L17.3821 19.4517ZM2.92683 10.8293C2.92683 6.46487 6.46487 2.92683 10.8293 2.92683C15.1937 2.92683 18.7317 6.46487 18.7317 10.8293C18.7317 12.9509 17.8957 14.8772 16.535 16.2967C16.4915 16.3313 16.4494 16.3688 16.4091 16.4091C16.3688 16.4494 16.3313 16.4915 16.2967 16.535C14.8772 17.8957 12.9509 18.7317 10.8293 18.7317C6.46487 18.7317 2.92683 15.1937 2.92683 10.8293Z",
            fill: "currentColor",
            key: "svg-124-0",
            fillRule: "evenodd",
            clipRule: "evenodd"
          },
          []
        ],
        [
          "path",
          {
            d: "M14.999 9.99976C15.5513 9.99976 15.999 10.4475 15.999 10.9998C15.999 11.552 15.5513 11.9998 14.999 11.9998H6.99902C6.44674 11.9998 5.99902 11.552 5.99902 10.9998C5.99902 10.4475 6.44674 9.99975 6.99902 9.99975L14.999 9.99976Z",
            fill: "currentColor",
            key: "svg-124-1"
          },
          []
        ]
      ]
    ],
    [
      "defs",
      { key: "svg-124-1" },
      [
        [
          "clipPath",
          { id: "clip0_985_10262", key: "svg-124-0" },
          [
            [
              "rect",
              { width: "24", height: "24", fill: "white", key: "svg-124-0" },
              []
            ]
          ]
        ]
      ]
    ]
  ],
  true
);

var IconZoomPlus = createReactComponent(
  "zoomPlus",
  "IconZoomPlus",
  [
    [
      "g",
      { key: "svg-125-0", clipPath: "url(#clip0_985_10263)" },
      [
        [
          "path",
          {
            d: "M17.3821 19.4517C15.5628 20.8364 13.292 21.6585 10.8293 21.6585C4.84843 21.6585 0 16.8101 0 10.8293C0 4.84843 4.84843 0 10.8293 0C16.8101 0 21.6585 4.84843 21.6585 10.8293C21.6585 13.292 20.8364 15.5628 19.4517 17.3821L23.5714 21.5018C24.1429 22.0733 24.1429 22.9999 23.5714 23.5714C22.9999 24.1429 22.0733 24.1429 21.5018 23.5714L17.3821 19.4517ZM2.92683 10.8293C2.92683 6.46487 6.46487 2.92683 10.8293 2.92683C15.1937 2.92683 18.7317 6.46487 18.7317 10.8293C18.7317 12.9509 17.8957 14.8772 16.535 16.2967C16.4915 16.3313 16.4494 16.3688 16.4091 16.4091C16.3688 16.4494 16.3313 16.4915 16.2967 16.535C14.8772 17.8957 12.9509 18.7317 10.8293 18.7317C6.46487 18.7317 2.92683 15.1937 2.92683 10.8293Z",
            fill: "currentColor",
            key: "svg-125-0",
            fillRule: "evenodd",
            clipRule: "evenodd"
          },
          []
        ],
        [
          "path",
          {
            d: "M9.99902 7C9.99902 6.44771 10.4467 6 10.999 6C11.5513 6 11.999 6.44772 11.999 7V15C11.999 15.5523 11.5513 16 10.999 16C10.4467 16 9.99902 15.5523 9.99902 15V7Z",
            fill: "currentColor",
            key: "svg-125-1"
          },
          []
        ],
        [
          "path",
          {
            d: "M14.999 9.99976C15.5513 9.99976 15.999 10.4475 15.999 10.9998C15.999 11.552 15.5513 11.9998 14.999 11.9998H6.99902C6.44674 11.9998 5.99902 11.552 5.99902 10.9998C5.99902 10.4475 6.44674 9.99975 6.99902 9.99975L14.999 9.99976Z",
            fill: "currentColor",
            key: "svg-125-2"
          },
          []
        ]
      ]
    ],
    [
      "defs",
      { key: "svg-125-1" },
      [
        [
          "clipPath",
          { id: "clip0_985_10263", key: "svg-125-0" },
          [
            [
              "rect",
              { width: "24", height: "24", fill: "white", key: "svg-125-0" },
              []
            ]
          ]
        ]
      ]
    ]
  ],
  true
);

export { IconAccountCode, IconAdd, IconAddLocation, IconAnnouncements, IconApple, IconArrowLeft, IconArrowRight, IconArrowsApartVertical, IconArrowsTogetherVertical, IconArrowsUpDown, IconArt, IconBackslash, IconBank, IconBling, IconBolt, IconBook, IconBookmarkHeart, IconBox, IconBuilding, IconCalendar, IconCash, IconCheck, IconCheckboxOutlined, IconChevronDown, IconChevronLeft, IconChevronRight, IconChevronUp, IconCircleCheck, IconCircleClose, IconClock, IconClose, IconCopy, IconCreditCard, IconCrop, IconDashboard, IconDelete, IconDesktop, IconDirection, IconDollar, IconDownload, IconDuplicate, IconEarn, IconEdit, IconEmail, IconEvent, IconExternalLink, IconFacebook, IconFees, IconFile, IconFilter, IconFolderTree, IconFood, IconGift, IconGivebacks, IconGoal, IconGraduation, IconHambMenu, IconHeart, IconHeartCircle, IconHome, IconImage, IconInfo, IconInstagram, IconLink, IconLinkedIn, IconLoadingError, IconLocation, IconLock, IconMap, IconMembershipCard, IconMinus, IconMobile, IconMore, IconMove, IconMusic, IconNotificationBell, IconPartiallyPaid, IconPercent, IconPlus, IconPrint, IconProfile, IconQrCode, IconQuestionMark, IconReceipt, IconReferral, IconRewardsCenter, IconRewardsLeft, IconRewardsRight, IconRewardsSimple, IconRotateLeft, IconRotateRight, IconScience, IconSearch, IconSearching, IconSecurityShield, IconSettings, IconShare, IconSheet, IconShopping, IconShoppingCart, IconSingleLineA, IconSingleSelect, IconSms, IconSports, IconStar, IconStarGroup, IconSupplies, IconSupport, IconTag, IconTheater, IconTicket, IconTransportation, IconTwitter, IconUniform, IconUpload, IconUser, IconUsers, IconVerified, IconViewOff, IconViewOn, IconWallet, IconWarning, IconWorld, IconXTwitter, IconZoomMinus, IconZoomPlus, createReactComponent };
//# sourceMappingURL=ui-icons.js.map
